import { Property, BaseModel, Field, Data, Model } from '@red/core';

var CURRENCY;
(function (CURRENCY) {
    CURRENCY["AFN"] = "AFN";
    CURRENCY["EUR"] = "EUR";
    CURRENCY["ALL"] = "ALL";
    CURRENCY["DZD"] = "DZD";
    CURRENCY["USD"] = "USD";
    CURRENCY["AOA"] = "AOA";
    CURRENCY["XCD"] = "XCD";
    CURRENCY["ARS"] = "ARS";
    CURRENCY["AMD"] = "AMD";
    CURRENCY["AWG"] = "AWG";
    CURRENCY["AUD"] = "AUD";
    CURRENCY["AZN"] = "AZN";
    CURRENCY["BSD"] = "BSD";
    CURRENCY["BHD"] = "BHD";
    CURRENCY["BDT"] = "BDT";
    CURRENCY["BBD"] = "BBD";
    CURRENCY["BYN"] = "BYN";
    CURRENCY["BZD"] = "BZD";
    CURRENCY["XOF"] = "XOF";
    CURRENCY["BMD"] = "BMD";
    CURRENCY["INR"] = "INR";
    CURRENCY["BTN"] = "BTN";
    CURRENCY["BOB"] = "BOB";
    CURRENCY["BOV"] = "BOV";
    CURRENCY["BAM"] = "BAM";
    CURRENCY["BWP"] = "BWP";
    CURRENCY["NOK"] = "NOK";
    CURRENCY["BRL"] = "BRL";
    CURRENCY["BND"] = "BND";
    CURRENCY["BGN"] = "BGN";
    CURRENCY["BIF"] = "BIF";
    CURRENCY["CVE"] = "CVE";
    CURRENCY["KHR"] = "KHR";
    CURRENCY["XAF"] = "XAF";
    CURRENCY["CAD"] = "CAD";
    CURRENCY["KYD"] = "KYD";
    CURRENCY["CLP"] = "CLP";
    CURRENCY["CLF"] = "CLF";
    CURRENCY["CNY"] = "CNY";
    CURRENCY["COP"] = "COP";
    CURRENCY["COU"] = "COU";
    CURRENCY["KMF"] = "KMF";
    CURRENCY["CDF"] = "CDF";
    CURRENCY["NZD"] = "NZD";
    CURRENCY["CRC"] = "CRC";
    CURRENCY["HRK"] = "HRK";
    CURRENCY["CUP"] = "CUP";
    CURRENCY["CUC"] = "CUC";
    CURRENCY["ANG"] = "ANG";
    CURRENCY["CZK"] = "CZK";
    CURRENCY["DKK"] = "DKK";
    CURRENCY["DJF"] = "DJF";
    CURRENCY["DOP"] = "DOP";
    CURRENCY["EGP"] = "EGP";
    CURRENCY["SVC"] = "SVC";
    CURRENCY["ERN"] = "ERN";
    CURRENCY["ETB"] = "ETB";
    CURRENCY["FKP"] = "FKP";
    CURRENCY["FJD"] = "FJD";
    CURRENCY["XPF"] = "XPF";
    CURRENCY["GMD"] = "GMD";
    CURRENCY["GEL"] = "GEL";
    CURRENCY["GHS"] = "GHS";
    CURRENCY["GIP"] = "GIP";
    CURRENCY["GTQ"] = "GTQ";
    CURRENCY["GBP"] = "GBP";
    CURRENCY["GNF"] = "GNF";
    CURRENCY["GYD"] = "GYD";
    CURRENCY["HTG"] = "HTG";
    CURRENCY["HNL"] = "HNL";
    CURRENCY["HKD"] = "HKD";
    CURRENCY["HUF"] = "HUF";
    CURRENCY["ISK"] = "ISK";
    CURRENCY["IDR"] = "IDR";
    CURRENCY["XDR"] = "XDR";
    CURRENCY["IRR"] = "IRR";
    CURRENCY["IQD"] = "IQD";
    CURRENCY["ILS"] = "ILS";
    CURRENCY["JMD"] = "JMD";
    CURRENCY["JPY"] = "JPY";
    CURRENCY["JOD"] = "JOD";
    CURRENCY["KZT"] = "KZT";
    CURRENCY["KES"] = "KES";
    CURRENCY["KPW"] = "KPW";
    CURRENCY["KRW"] = "KRW";
    CURRENCY["KWD"] = "KWD";
    CURRENCY["KGS"] = "KGS";
    CURRENCY["LAK"] = "LAK";
    CURRENCY["LBP"] = "LBP";
    CURRENCY["LSL"] = "LSL";
    CURRENCY["ZAR"] = "ZAR";
    CURRENCY["LRD"] = "LRD";
    CURRENCY["LYD"] = "LYD";
    CURRENCY["CHF"] = "CHF";
    CURRENCY["MOP"] = "MOP";
    CURRENCY["MKD"] = "MKD";
    CURRENCY["MGA"] = "MGA";
    CURRENCY["MWK"] = "MWK";
    CURRENCY["MYR"] = "MYR";
    CURRENCY["MVR"] = "MVR";
    CURRENCY["MRO"] = "MRO";
    CURRENCY["MUR"] = "MUR";
    CURRENCY["XUA"] = "XUA";
    CURRENCY["MXN"] = "MXN";
    CURRENCY["MXV"] = "MXV";
    CURRENCY["MDL"] = "MDL";
    CURRENCY["MNT"] = "MNT";
    CURRENCY["MAD"] = "MAD";
    CURRENCY["MZN"] = "MZN";
    CURRENCY["MMK"] = "MMK";
    CURRENCY["NAD"] = "NAD";
    CURRENCY["NPR"] = "NPR";
    CURRENCY["NIO"] = "NIO";
    CURRENCY["NGN"] = "NGN";
    CURRENCY["OMR"] = "OMR";
    CURRENCY["PKR"] = "PKR";
    CURRENCY["PAB"] = "PAB";
    CURRENCY["PGK"] = "PGK";
    CURRENCY["PYG"] = "PYG";
    CURRENCY["PEN"] = "PEN";
    CURRENCY["PHP"] = "PHP";
    CURRENCY["PLN"] = "PLN";
    CURRENCY["QAR"] = "QAR";
    CURRENCY["RON"] = "RON";
    CURRENCY["RUB"] = "RUB";
    CURRENCY["RWF"] = "RWF";
    CURRENCY["SHP"] = "SHP";
    CURRENCY["WST"] = "WST";
    CURRENCY["STD"] = "STD";
    CURRENCY["SAR"] = "SAR";
    CURRENCY["RSD"] = "RSD";
    CURRENCY["SCR"] = "SCR";
    CURRENCY["SLL"] = "SLL";
    CURRENCY["SGD"] = "SGD";
    CURRENCY["XSU"] = "XSU";
    CURRENCY["SBD"] = "SBD";
    CURRENCY["SOS"] = "SOS";
    CURRENCY["SSP"] = "SSP";
    CURRENCY["LKR"] = "LKR";
    CURRENCY["SDG"] = "SDG";
    CURRENCY["SRD"] = "SRD";
    CURRENCY["SZL"] = "SZL";
    CURRENCY["SEK"] = "SEK";
    CURRENCY["CHE"] = "CHE";
    CURRENCY["CHW"] = "CHW";
    CURRENCY["SYP"] = "SYP";
    CURRENCY["TWD"] = "TWD";
    CURRENCY["TJS"] = "TJS";
    CURRENCY["TZS"] = "TZS";
    CURRENCY["THB"] = "THB";
    CURRENCY["TOP"] = "TOP";
    CURRENCY["TTD"] = "TTD";
    CURRENCY["TND"] = "TND";
    CURRENCY["TRY"] = "TRY";
    CURRENCY["TMT"] = "TMT";
    CURRENCY["UGX"] = "UGX";
    CURRENCY["UAH"] = "UAH";
    CURRENCY["AED"] = "AED";
    CURRENCY["USN"] = "USN";
    CURRENCY["UYU"] = "UYU";
    CURRENCY["UYI"] = "UYI";
    CURRENCY["UZS"] = "UZS";
    CURRENCY["VUV"] = "VUV";
    CURRENCY["VEF"] = "VEF";
    CURRENCY["VND"] = "VND";
    CURRENCY["YER"] = "YER";
    CURRENCY["ZMW"] = "ZMW";
    CURRENCY["ZWL"] = "ZWL";
    CURRENCY["XBA"] = "XBA";
    CURRENCY["XBB"] = "XBB";
    CURRENCY["XBC"] = "XBC";
    CURRENCY["XBD"] = "XBD";
    CURRENCY["XTS"] = "XTS";
    CURRENCY["XXX"] = "XXX";
    CURRENCY["XAU"] = "XAU";
    CURRENCY["XPD"] = "XPD";
    CURRENCY["XPT"] = "XPT";
    CURRENCY["XAG"] = "XAG";
})(CURRENCY || (CURRENCY = {}));

var __decorate$1n = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1n = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var REFERENCE_TYPE;
(function (REFERENCE_TYPE) {
    REFERENCE_TYPE["ASSET"] = "ASSET";
    REFERENCE_TYPE["INVOICE"] = "INVOICE";
    REFERENCE_TYPE["SALARY"] = "SALARY";
    REFERENCE_TYPE["BILL"] = "BILL";
    REFERENCE_TYPE["EXPENSE"] = "EXPENSE";
    REFERENCE_TYPE["HISTORICAL_INVOICE"] = "HISTORICAL_INVOICE";
    REFERENCE_TYPE["ROYALTY_STATEMENT"] = "ROYALTY_STATEMENT";
    REFERENCE_TYPE["SETTLEMENT"] = "SETTLEMENT";
    REFERENCE_TYPE["PAYMENT"] = "PAYMENT";
    REFERENCE_TYPE["ACCOUNT_ENTRY"] = "ACCOUNT_ENTRY";
    REFERENCE_TYPE["RECEIPT"] = "RECEIPT";
    REFERENCE_TYPE["TRANSACTION"] = "TRANSACTION";
    REFERENCE_TYPE["USER"] = "USER";
    REFERENCE_TYPE["COMPANY"] = "COMPANY";
    REFERENCE_TYPE["ROLE"] = "ROLE";
    REFERENCE_TYPE["GPS_TRANSACTION"] = "GPS_TRANSACTION";
    REFERENCE_TYPE["GPS_CARD"] = "GPS_CARD";
    REFERENCE_TYPE["OWNER_DEPOSIT"] = "OWNER_DEPOSIT";
    REFERENCE_TYPE["OWNER_WITHDRAWAL"] = "OWNER_WITHDRAWAL";
    REFERENCE_TYPE["REDFLAG_CASH_ADJUSTMENT"] = "REDFLAG_CASH_ADJUSTMENT";
    REFERENCE_TYPE["REGISTRATION_STEP"] = "REGISTRATION_STEP";
    REFERENCE_TYPE["SESSION"] = "SESSION";
    REFERENCE_TYPE["FINANCIAL_PAYMENT"] = "FINANCIAL_PAYMENT";
    REFERENCE_TYPE["REPORT"] = "REPORT";
    REFERENCE_TYPE["VOUCHER"] = "VOUCHER";
    REFERENCE_TYPE["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    REFERENCE_TYPE["WIRECARD_PAYMENT"] = "WIRECARD_PAYMENT";
    REFERENCE_TYPE["CHARGEBACK"] = "CHARGEBACK";
    REFERENCE_TYPE["REGISTRATION"] = "REGISTRATION";
    REFERENCE_TYPE["BANCO_LIFECYCLE"] = "BANCO_LIFECYCLE";
    REFERENCE_TYPE["BANCO_PAYMENT"] = "BANCO_PAYMENT";
    REFERENCE_TYPE["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    REFERENCE_TYPE["ONBOARDING"] = "ONBOARDING";
    REFERENCE_TYPE["MIR_PAYMENT"] = "MIR_PAYMENT";
})(REFERENCE_TYPE || (REFERENCE_TYPE = {}));
class Reference extends BaseModel {
    static fromStringRef(string) {
        if (string === null || string.length === 0) {
            throw new Error("Reference string can't be empty or null");
        }
        const strings = string.split(':');
        if (strings.length === 1) {
            throw new Error(`Wrong reference string format, missing a colon in ${string}`);
        }
        const ref = new Reference();
        ref.id = strings[1];
        ref.type = REFERENCE_TYPE[strings[0]];
        return ref;
    }
}
__decorate$1n([
    Property(),
    __metadata$1n("design:type", String)
], Reference.prototype, "id", void 0);
__decorate$1n([
    Property({ type: REFERENCE_TYPE }),
    __metadata$1n("design:type", String)
], Reference.prototype, "type", void 0);

var __decorate$1m = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1m = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class NonAmountObject extends Error {
}
class MismatchAmountCurrencyError extends Error {
}
class InfinityAmountCurrencyError extends Error {
}
class Amount extends BaseModel {
    static ZERO(currency) {
        return new Amount({ amount: 0, currency: currency });
    }
    static divide(a, b) {
        Amount.verifyCurrency(a, b);
        const result = a.amount / b.amount;
        if (result === Infinity || isNaN(result)) {
            throw new InfinityAmountCurrencyError("Amount can't be infinity or NaN. It doesn't make sense.");
        }
        return new Amount({ amount: result, currency: a.amount });
    }
    static sum(...sums) {
        const first = sums.shift();
        const sum = sums.reduce((acc, amount) => {
            Amount.verifyCurrency(amount, first);
            return Number((Number(acc.toFixed(2)) + Number(amount.toFixed(2))).toFixed(2));
        }, first.toFixed());
        return new Amount({ amount: sum, currency: first.currency });
    }
    static verifyAmount(first, second) {
        if (!(first instanceof Amount)) {
            throw new NonAmountObject(`${first} is not an instance of Amount`);
        }
        if (!(second instanceof Amount)) {
            throw new NonAmountObject(`${second} is not an instance of Amount`);
        }
    }
    static verifyCurrency(first, second) {
        if (first.currency !== second.currency) {
            throw new MismatchAmountCurrencyError(`${first.currency} doesn't match first currency ${second.currency}`);
        }
    }
    static SEK(amount) {
        return new Amount({
            amount: amount,
            currency: CURRENCY.SEK,
        });
    }
    add(amount) {
        Amount.verifyCurrency(this, amount);
        this.amount += amount.amount;
        return this;
    }
    equal(amount) {
        Amount.verifyAmount(this, amount);
        Amount.verifyCurrency(this, amount);
        return this.amount === amount.amount;
    }
    greaterThen(amount) {
        Amount.verifyCurrency(this, amount);
        return this.amount > amount.amount;
    }
    greaterThenOrEqual(amount) {
        Amount.verifyCurrency(this, amount);
        return this.amount >= amount.amount;
    }
    lessThen(amount) {
        Amount.verifyCurrency(this, amount);
        return this.amount < amount.amount;
    }
    lessThenOrEqual(amount) {
        Amount.verifyCurrency(this, amount);
        return this.amount <= amount.amount;
    }
    subtract(amount) {
        Amount.verifyCurrency(this, amount);
        this.amount -= amount.amount;
        return this;
    }
    negate() {
        this.amount *= -1;
        return this;
    }
    toFixed(fractionDigits = 2) {
        if (!this.amount && this.amount !== 0) {
            return this.amount;
        }
        const fixed = parseFloat(this.amount.toString()).toFixed(fractionDigits);
        return parseFloat(fixed);
    }
    toJSON() {
        return {
            amount: this.toFixed(),
            currency: this.currency,
        };
    }
}
__decorate$1m([
    Property(),
    __metadata$1m("design:type", Number)
], Amount.prototype, "amount", void 0);
__decorate$1m([
    Property(),
    __metadata$1m("design:type", String)
], Amount.prototype, "currency", void 0);

var __decorate$1l = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1l = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
    ACCOUNT_TYPE["IBAN"] = "IBAN";
    ACCOUNT_TYPE["SE_BANK_ACCOUNT"] = "SE_BANK_ACCOUNT";
    ACCOUNT_TYPE["SE_BANKGIRO"] = "SE_BANKGIRO";
    ACCOUNT_TYPE["SE_PLUSGIRO"] = "SE_PLUSGIRO";
    ACCOUNT_TYPE["UNKNOWN"] = "UNKNOWN";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
var COMPANY_ACCOUNT_TYPE;
(function (COMPANY_ACCOUNT_TYPE) {
    COMPANY_ACCOUNT_TYPE["CASH"] = "CASH";
    COMPANY_ACCOUNT_TYPE["RESERVED"] = "RESERVED";
    COMPANY_ACCOUNT_TYPE["SETTLEMENT"] = "SETTLEMENT";
    COMPANY_ACCOUNT_TYPE["SYSTEM"] = "SYSTEM";
})(COMPANY_ACCOUNT_TYPE || (COMPANY_ACCOUNT_TYPE = {}));
class Account extends BaseModel {
}
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], Account.prototype, "accountId", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], Account.prototype, "clearingSystemId", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], Account.prototype, "type", void 0);
class CompanyAccount extends BaseModel {
}
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "id", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "companyId", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "created", void 0);
__decorate$1l([
    Property({ type: CURRENCY }),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "currency", void 0);
__decorate$1l([
    Property({ type: COMPANY_ACCOUNT_TYPE }),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "type", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "status", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], CompanyAccount.prototype, "tag", void 0);
class AccountStatementEntry extends BaseModel {
}
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatementEntry.prototype, "id", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatementEntry.prototype, "transactionId", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatementEntry.prototype, "account", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatementEntry.prototype, "timestamp", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Reference)
], AccountStatementEntry.prototype, "reference", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Amount)
], AccountStatementEntry.prototype, "balance", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Amount)
], AccountStatementEntry.prototype, "amount", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatementEntry.prototype, "reservationStatus", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatementEntry.prototype, "description", void 0);
class AccountStatement extends BaseModel {
}
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatement.prototype, "to", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", String)
], AccountStatement.prototype, "from", void 0);
__decorate$1l([
    Property({ type: CURRENCY }),
    __metadata$1l("design:type", String)
], AccountStatement.prototype, "currency", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatement.prototype, "clearingCode", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatement.prototype, "accountNumber", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatement.prototype, "companyName", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatement.prototype, "organisationNumber", void 0);
__decorate$1l([
    Property(),
    __metadata$1l("design:type", Number)
], AccountStatement.prototype, "ownerId", void 0);
__decorate$1l([
    Property({ type: AccountStatementEntry }),
    __metadata$1l("design:type", Array)
], AccountStatement.prototype, "entries", void 0);

var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["EN"] = "en";
    LANGUAGE["SV"] = "sv";
})(LANGUAGE || (LANGUAGE = {}));

// https://github.com/michaelwittig/node-i18n-iso-countries/blob/master/langs/sv.json
const LOCALE_SV_COUNTRY = {
    AD: 'Andorra',
    AE: 'Förenade Arabemiraten',
    AF: 'Afghanistan',
    AG: 'Antigua och Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AN: 'Nederländska Antillerna',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentina',
    AS: 'Amerikanska Samoa',
    AT: 'Österrike',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Åland',
    AZ: 'Azerbajdzjan',
    BA: 'Bosnien och Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint-Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BQ: 'Bonaire, Saint Eustatius och Saba',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetön',
    BW: 'Botswana',
    BY: 'Vitryssland',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Kokosöarna',
    CD: 'Demokratiska republiken Kongo',
    CF: 'Centralafrikanska republiken',
    CG: 'Kongo-Brazzaville',
    CH: 'Schweiz',
    CI: 'Elfenbenskusten',
    CK: 'Cooköarna',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Kap Verde',
    CW: 'Curacao',
    CX: 'Julön',
    CY: 'Cypern',
    CZ: 'Tjeckien',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Dominikanska republiken',
    DZ: 'Algeriet',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypten',
    EH: 'Västsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Etiopien',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsöarna',
    FM: 'Mikronesiska federationen',
    FO: 'Färöarna',
    FR: 'Frankrike',
    GA: 'Gabon',
    GB: 'Storbritannien',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Franska Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ekvatorialguinea',
    GR: 'Grekland',
    GS: 'Sydgeorgien och Sydsandwichöarna',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HM: 'Heard- och McDonaldsöarna',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HU: 'Ungern',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Brittiska territoriet i Indiska Oceanen',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordanien',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgizistan',
    KH: 'Kambodja',
    KI: 'Kiribati',
    KM: 'Komorerna',
    KN: 'Saint Kitts och Nevis',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KY: 'Caymanöarna',
    KZ: 'Kazakstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marocko',
    MC: 'Monaco',
    MD: 'Moldavien',
    ME: 'Montenegro',
    MF: 'Saint Martin (franska delen)',
    MG: 'Madagaskar',
    MH: 'Marshallöarna',
    MK: 'Makedonien',
    ML: 'Mali',
    MM: 'Burma',
    MN: 'Mongoliet',
    MO: 'Macau',
    MP: 'Nordmarianerna',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldiverna',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Moçambique',
    NA: 'Namibia',
    NC: 'Nya Kaledonien',
    NE: 'Niger',
    NF: 'Norfolkön',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederländerna',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nya Zeeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Franska Polynesien',
    PG: 'Papua Nya Guinea',
    PH: 'Filippinerna',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint-Pierre och Miquelon',
    PN: 'Pitcairnöarna',
    PR: 'Puerto Rico',
    PS: 'Palestinska territoriet, ockuperade',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Ryssland',
    RW: 'Rwanda',
    SA: 'Saudiarabien',
    SB: 'Salomonöarna',
    SC: 'Seychellerna',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Sankta Helena',
    SI: 'Slovenien',
    SJ: 'Svalbard och Jan Mayen',
    SK: 'Slovakien',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sydsudan',
    ST: 'São Tomé och Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten (nederländska delen)',
    SY: 'Syrien',
    SZ: 'Swaziland',
    TC: 'Turks- och Caicosöarna',
    TD: 'Tchad',
    TF: 'Franska södra territorierna',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadzjikistan',
    TK: 'Tokelauöarna',
    TL: 'Östtimor',
    TM: 'Turkmenistan',
    TN: 'Tunisien',
    TO: 'Tonga',
    TR: 'Turkiet',
    TT: 'Trinidad och Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'USA:s yttre öar',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent och Grenadinerna',
    VE: 'Venezuela',
    VG: 'Brittiska Jungfruöarna',
    VI: 'Amerikanska Jungfruöarna',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis- och Futunaöarna',
    WS: 'Samoa',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Sydafrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    XK: 'Kosovo',
};

// https://github.com/michaelwittig/node-i18n-iso-countries/blob/master/langs/en.json
const LOCALE_EN_COUNTRY = {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AN: 'Netherlands Antilles',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, the Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Cote D'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, the Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States of America',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Viet Nam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AX: 'Åland Islands',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    CW: 'Curaçao',
    GG: 'Guernsey',
    IM: 'Isle of Man',
    JE: 'Jersey',
    ME: 'Montenegro',
    BL: 'Saint Barthélemy',
    MF: 'Saint Martin (French part)',
    RS: 'Serbia',
    SX: 'Sint Maarten (Dutch part)',
    SS: 'South Sudan',
    XK: 'Kosovo',
};

var COUNTRY;
(function (COUNTRY) {
    COUNTRY["AFGHANISTAN"] = "AF";
    COUNTRY["ALANDISLANDS"] = "AX";
    COUNTRY["ALBANIA"] = "AL";
    COUNTRY["ALGERIA"] = "DZ";
    COUNTRY["AMERICANSAMOA"] = "AS";
    COUNTRY["ANDORRA"] = "AD";
    COUNTRY["ANGOLA"] = "AO";
    COUNTRY["ANGUILLA"] = "AI";
    COUNTRY["ANTARCTICA"] = "AQ";
    COUNTRY["ANTIGUAANDBARBUDA"] = "AG";
    COUNTRY["ARGENTINA"] = "AR";
    COUNTRY["ARMENIA"] = "AM";
    COUNTRY["ARUBA"] = "AW";
    COUNTRY["AUSTRALIA"] = "AU";
    COUNTRY["AUSTRIA"] = "AT";
    COUNTRY["AZERBAIJAN"] = "AZ";
    COUNTRY["BAHAMAS"] = "BS";
    COUNTRY["BAHRAIN"] = "BH";
    COUNTRY["BANGLADESH"] = "BD";
    COUNTRY["BARBADOS"] = "BB";
    COUNTRY["BELARUS"] = "BY";
    COUNTRY["BELGIUM"] = "BE";
    COUNTRY["BELIZE"] = "BZ";
    COUNTRY["BENIN"] = "BJ";
    COUNTRY["BERMUDA"] = "BM";
    COUNTRY["BHUTAN"] = "BT";
    COUNTRY["BOLIVIA"] = "BO";
    COUNTRY["BOSNIAANDHERZEGOVINA"] = "BA";
    COUNTRY["BOTSWANA"] = "BW";
    COUNTRY["BOUVETISLAND"] = "BV";
    COUNTRY["BRAZIL"] = "BR";
    COUNTRY["BRITISHINDIANOCEANTERRITORY"] = "IO";
    COUNTRY["BRUNEIDARUSSALAM"] = "BN";
    COUNTRY["BULGARIA"] = "BG";
    COUNTRY["BURKINAFASO"] = "BF";
    COUNTRY["BURUNDI"] = "BI";
    COUNTRY["CAMBODIA"] = "KH";
    COUNTRY["CAMEROON"] = "CM";
    COUNTRY["CANADA"] = "CA";
    COUNTRY["CAPEVERDE"] = "CV";
    COUNTRY["CAYMANISLANDS"] = "KY";
    COUNTRY["CENTRALAFRICANREPUBLIC"] = "CF";
    COUNTRY["CHAD"] = "TD";
    COUNTRY["CHILE"] = "CL";
    COUNTRY["CHINA"] = "CN";
    COUNTRY["CHRISTMASISLAND"] = "CX";
    COUNTRY["COCOSKEELINGISLANDS"] = "CC";
    COUNTRY["COLOMBIA"] = "CO";
    COUNTRY["COMOROS"] = "KM";
    COUNTRY["CONGO"] = "CG";
    COUNTRY["CONGODEMOCRATICREPUBLIC"] = "CD";
    COUNTRY["COOKISLANDS"] = "CK";
    COUNTRY["COSTARICA"] = "CR";
    COUNTRY["COTEDIVOIRE"] = "CI";
    COUNTRY["CROATIA"] = "HR";
    COUNTRY["CUBA"] = "CU";
    COUNTRY["CYPRUS"] = "CY";
    COUNTRY["CZECHREPUBLIC"] = "CZ";
    COUNTRY["DENMARK"] = "DK";
    COUNTRY["DJIBOUTI"] = "DJ";
    COUNTRY["DOMINICA"] = "DM";
    COUNTRY["DOMINICANREPUBLIC"] = "DO";
    COUNTRY["ECUADOR"] = "EC";
    COUNTRY["EGYPT"] = "EG";
    COUNTRY["ELSALVADOR"] = "SV";
    COUNTRY["EQUATORIALGUINEA"] = "GQ";
    COUNTRY["ERITREA"] = "ER";
    COUNTRY["ESTONIA"] = "EE";
    COUNTRY["ETHIOPIA"] = "ET";
    COUNTRY["FALKLANDISLANDS"] = "FK";
    COUNTRY["FAROEISLANDS"] = "FO";
    COUNTRY["FIJI"] = "FJ";
    COUNTRY["FINLAND"] = "FI";
    COUNTRY["FRANCE"] = "FR";
    COUNTRY["FRENCHGUIANA"] = "GF";
    COUNTRY["FRENCHPOLYNESIA"] = "PF";
    COUNTRY["FRENCHSOUTHERNTERRITORIES"] = "TF";
    COUNTRY["GABON"] = "GA";
    COUNTRY["GAMBIA"] = "GM";
    COUNTRY["GEORGIA"] = "GE";
    COUNTRY["GERMANY"] = "DE";
    COUNTRY["GHANA"] = "GH";
    COUNTRY["GIBRALTAR"] = "GI";
    COUNTRY["GREECE"] = "GR";
    COUNTRY["GREENLAND"] = "GL";
    COUNTRY["GRENADA"] = "GD";
    COUNTRY["GUADELOUPE"] = "GP";
    COUNTRY["GUAM"] = "GU";
    COUNTRY["GUATEMALA"] = "GT";
    COUNTRY["GUERNSEY"] = "GG";
    COUNTRY["GUINEA"] = "GN";
    COUNTRY["GUINEABISSAU"] = "GW";
    COUNTRY["GUYANA"] = "GY";
    COUNTRY["HAITI"] = "HT";
    COUNTRY["HEARDISLANDMCDONALDISLANDS"] = "HM";
    COUNTRY["HOLYSEEVATICANCITYSTATE"] = "VA";
    COUNTRY["HONDURAS"] = "HN";
    COUNTRY["HONGKONG"] = "HK";
    COUNTRY["HUNGARY"] = "HU";
    COUNTRY["ICELAND"] = "IS";
    COUNTRY["INDIA"] = "IN";
    COUNTRY["INDONESIA"] = "ID";
    COUNTRY["IRAN"] = "IR";
    COUNTRY["IRAQ"] = "IQ";
    COUNTRY["IRELAND"] = "IE";
    COUNTRY["ISLEOFMAN"] = "IM";
    COUNTRY["ISRAEL"] = "IL";
    COUNTRY["ITALY"] = "IT";
    COUNTRY["JAMAICA"] = "JM";
    COUNTRY["JAPAN"] = "JP";
    COUNTRY["JERSEY"] = "JE";
    COUNTRY["JORDAN"] = "JO";
    COUNTRY["KAZAKHSTAN"] = "KZ";
    COUNTRY["KENYA"] = "KE";
    COUNTRY["KIRIBATI"] = "KI";
    COUNTRY["KOREA"] = "KR";
    COUNTRY["KOSOVO"] = "XK";
    COUNTRY["KUWAIT"] = "KW";
    COUNTRY["KYRGYZSTAN"] = "KG";
    COUNTRY["LAOPEOPLESDEMOCRATICREPUBLIC"] = "LA";
    COUNTRY["LATVIA"] = "LV";
    COUNTRY["LEBANON"] = "LB";
    COUNTRY["LESOTHO"] = "LS";
    COUNTRY["LIBERIA"] = "LR";
    COUNTRY["LIBYANARABJAMAHIRIYA"] = "LY";
    COUNTRY["LIECHTENSTEIN"] = "LI";
    COUNTRY["LITHUANIA"] = "LT";
    COUNTRY["LUXEMBOURG"] = "LU";
    COUNTRY["MACAO"] = "MO";
    COUNTRY["MACEDONIA"] = "MK";
    COUNTRY["MADAGASCAR"] = "MG";
    COUNTRY["MALAWI"] = "MW";
    COUNTRY["MALAYSIA"] = "MY";
    COUNTRY["MALDIVES"] = "MV";
    COUNTRY["MALI"] = "ML";
    COUNTRY["MALTA"] = "MT";
    COUNTRY["MARSHALLISLANDS"] = "MH";
    COUNTRY["MARTINIQUE"] = "MQ";
    COUNTRY["MAURITANIA"] = "MR";
    COUNTRY["MAURITIUS"] = "MU";
    COUNTRY["MAYOTTE"] = "YT";
    COUNTRY["MEXICO"] = "MX";
    COUNTRY["MICRONESIA"] = "FM";
    COUNTRY["MOLDOVA"] = "MD";
    COUNTRY["MONACO"] = "MC";
    COUNTRY["MONGOLIA"] = "MN";
    COUNTRY["MONTENEGRO"] = "ME";
    COUNTRY["MONTSERRAT"] = "MS";
    COUNTRY["MOROCCO"] = "MA";
    COUNTRY["MOZAMBIQUE"] = "MZ";
    COUNTRY["MYANMAR"] = "MM";
    COUNTRY["NAMIBIA"] = "NA";
    COUNTRY["NAURU"] = "NR";
    COUNTRY["NEPAL"] = "NP";
    COUNTRY["NETHERLANDS"] = "NL";
    COUNTRY["NETHERLANDSANTILLES"] = "AN";
    COUNTRY["NEWCALEDONIA"] = "NC";
    COUNTRY["NEWZEALAND"] = "NZ";
    COUNTRY["NICARAGUA"] = "NI";
    COUNTRY["NIGER"] = "NE";
    COUNTRY["NIGERIA"] = "NG";
    COUNTRY["NIUE"] = "NU";
    COUNTRY["NORFOLKISLAND"] = "NF";
    COUNTRY["NORTHERNMARIANAISLANDS"] = "MP";
    COUNTRY["NORWAY"] = "NO";
    COUNTRY["OMAN"] = "OM";
    COUNTRY["PAKISTAN"] = "PK";
    COUNTRY["PALAU"] = "PW";
    COUNTRY["PALESTINIANTERRITORY"] = "PS";
    COUNTRY["PANAMA"] = "PA";
    COUNTRY["PAPUANEWGUINEA"] = "PG";
    COUNTRY["PARAGUAY"] = "PY";
    COUNTRY["PERU"] = "PE";
    COUNTRY["PHILIPPINES"] = "PH";
    COUNTRY["PITCAIRN"] = "PN";
    COUNTRY["POLAND"] = "PL";
    COUNTRY["PORTUGAL"] = "PT";
    COUNTRY["PUERTORICO"] = "PR";
    COUNTRY["QATAR"] = "QA";
    COUNTRY["REUNION"] = "RE";
    COUNTRY["ROMANIA"] = "RO";
    COUNTRY["RUSSIANFEDERATION"] = "RU";
    COUNTRY["RWANDA"] = "RW";
    COUNTRY["SAINTBARTHELEMY"] = "BL";
    COUNTRY["SAINTHELENA"] = "SH";
    COUNTRY["SAINTKITTSANDNEVIS"] = "KN";
    COUNTRY["SAINTLUCIA"] = "LC";
    COUNTRY["SAINTMARTIN"] = "MF";
    COUNTRY["SAINTPIERREANDMIQUELON"] = "PM";
    COUNTRY["SAINTVINCENTANDGRENADINES"] = "VC";
    COUNTRY["SAMOA"] = "WS";
    COUNTRY["SANMARINO"] = "SM";
    COUNTRY["SAOTOMEANDPRINCIPE"] = "ST";
    COUNTRY["SAUDIARABIA"] = "SA";
    COUNTRY["SENEGAL"] = "SN";
    COUNTRY["SERBIA"] = "RS";
    COUNTRY["SEYCHELLES"] = "SC";
    COUNTRY["SIERRALEONE"] = "SL";
    COUNTRY["SINGAPORE"] = "SG";
    COUNTRY["SLOVAKIA"] = "SK";
    COUNTRY["SLOVENIA"] = "SI";
    COUNTRY["SOLOMONISLANDS"] = "SB";
    COUNTRY["SOMALIA"] = "SO";
    COUNTRY["SOUTHAFRICA"] = "ZA";
    COUNTRY["SOUTHGEORGIAANDSANDWICHISL"] = "GS";
    COUNTRY["SPAIN"] = "ES";
    COUNTRY["SRILANKA"] = "LK";
    COUNTRY["SUDAN"] = "SD";
    COUNTRY["SURINAME"] = "SR";
    COUNTRY["SVALBARDANDJANMAYEN"] = "SJ";
    COUNTRY["SWAZILAND"] = "SZ";
    COUNTRY["SWEDEN"] = "SE";
    COUNTRY["SWITZERLAND"] = "CH";
    COUNTRY["SYRIANARABREPUBLIC"] = "SY";
    COUNTRY["TAIWAN"] = "TW";
    COUNTRY["TAJIKISTAN"] = "TJ";
    COUNTRY["TANZANIA"] = "TZ";
    COUNTRY["THAILAND"] = "TH";
    COUNTRY["TIMORLESTE"] = "TL";
    COUNTRY["TOGO"] = "TG";
    COUNTRY["TOKELAU"] = "TK";
    COUNTRY["TONGA"] = "TO";
    COUNTRY["TRINIDADANDTOBAGO"] = "TT";
    COUNTRY["TUNISIA"] = "TN";
    COUNTRY["TURKEY"] = "TR";
    COUNTRY["TURKMENISTAN"] = "TM";
    COUNTRY["TURKSANDCAICOSISLANDS"] = "TC";
    COUNTRY["TUVALU"] = "TV";
    COUNTRY["UGANDA"] = "UG";
    COUNTRY["UKRAINE"] = "UA";
    COUNTRY["UNITEDARABEMIRATES"] = "AE";
    COUNTRY["UNITEDKINGDOM"] = "GB";
    COUNTRY["UNITEDSTATES"] = "US";
    COUNTRY["UNITEDSTATESOUTLYINGISLANDS"] = "UM";
    COUNTRY["URUGUAY"] = "UY";
    COUNTRY["UZBEKISTAN"] = "UZ";
    COUNTRY["VANUATU"] = "VU";
    COUNTRY["VENEZUELA"] = "VE";
    COUNTRY["VIETNAM"] = "VN";
    COUNTRY["VIRGINISLANDSBRITISH"] = "VG";
    COUNTRY["VIRGINISLANDSUS"] = "VI";
    COUNTRY["WALLISANDFUTUNA"] = "WF";
    COUNTRY["WESTERNSAHARA"] = "EH";
    COUNTRY["YEMEN"] = "YE";
    COUNTRY["ZAMBIA"] = "ZM";
    COUNTRY["KOBOL"] = "BSG";
})(COUNTRY || (COUNTRY = {}));
class CountryData {
    static getLocalCountriesForLocaleId(localeId) {
        return Object.values(COUNTRY)
            .map(code => {
            return {
                code: code,
                label: CountryData._getCountryLabelForCode(localeId, code),
            };
        })
            .filter(country => !!country.label);
    }
    static _getCountryLabelForCode(localeId, country) {
        let label;
        switch (localeId) {
            case LANGUAGE.SV:
                label = LOCALE_SV_COUNTRY[country];
                break;
            default:
                label = LOCALE_EN_COUNTRY[country];
                break;
        }
        return label;
    }
}

var __decorate$1k = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1k = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Address extends BaseModel {
    isEmpty() {
        const empty = Object.keys(this._values).filter(key => key !== 'lines').length === 0;
        return empty && this.lines.length === 0;
    }
}
__decorate$1k([
    Property(),
    __metadata$1k("design:type", String)
], Address.prototype, "careOf", void 0);
__decorate$1k([
    Property({ type: String }),
    __metadata$1k("design:type", Array)
], Address.prototype, "lines", void 0);
__decorate$1k([
    Property(),
    __metadata$1k("design:type", String)
], Address.prototype, "postalCode", void 0);
__decorate$1k([
    Property(),
    __metadata$1k("design:type", String)
], Address.prototype, "postalTown", void 0);
__decorate$1k([
    Property(),
    __metadata$1k("design:type", String)
], Address.prototype, "countryCode", void 0);

var __decorate$1j = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1j = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class BankAccountDetails extends BaseModel {
}
__decorate$1j([
    Property(),
    __metadata$1j("design:type", String)
], BankAccountDetails.prototype, "country", void 0);
__decorate$1j([
    Property(),
    __metadata$1j("design:type", String)
], BankAccountDetails.prototype, "clearingNo", void 0);
__decorate$1j([
    Property(),
    __metadata$1j("design:type", String)
], BankAccountDetails.prototype, "accountNo", void 0);
__decorate$1j([
    Property(),
    __metadata$1j("design:type", String)
], BankAccountDetails.prototype, "iban", void 0);
__decorate$1j([
    Property(),
    __metadata$1j("design:type", String)
], BankAccountDetails.prototype, "bic", void 0);

var __decorate$1i = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1i = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SIGN_STATUS;
(function (SIGN_STATUS) {
    SIGN_STATUS["SIGNED"] = "SIGNED";
    SIGN_STATUS["NOT_SIGNED"] = "NOT_SIGNED";
})(SIGN_STATUS || (SIGN_STATUS = {}));
var SIGNATURE_TYPE;
(function (SIGNATURE_TYPE) {
    SIGNATURE_TYPE["XML_SIG"] = "XML_SIG";
    SIGNATURE_TYPE["JWS"] = "JWS";
})(SIGNATURE_TYPE || (SIGNATURE_TYPE = {}));
var SIGNATURE_SOURCE;
(function (SIGNATURE_SOURCE) {
    SIGNATURE_SOURCE["SE_BANKID"] = "SE_BANKID";
    SIGNATURE_SOURCE["CONTEXT_CERTIFICATE"] = "CONTEXT_CERTIFICATE";
    SIGNATURE_SOURCE["USER_ACCEPT"] = "USER_ACCEPT";
})(SIGNATURE_SOURCE || (SIGNATURE_SOURCE = {}));
var SIGNATURE_OBJECT_ENCODING;
(function (SIGNATURE_OBJECT_ENCODING) {
    SIGNATURE_OBJECT_ENCODING["BASE64"] = "BASE64";
    SIGNATURE_OBJECT_ENCODING["NONE"] = "NONE";
})(SIGNATURE_OBJECT_ENCODING || (SIGNATURE_OBJECT_ENCODING = {}));
var NODE_TYPE;
(function (NODE_TYPE) {
    NODE_TYPE["ARRAY"] = "ARRAY";
    NODE_TYPE["BINARY"] = "BINARY";
    NODE_TYPE["BOOLEAN"] = "BOOLEAN";
    NODE_TYPE["MISSING"] = "MISSING";
    NODE_TYPE["NULL"] = "NULL";
    NODE_TYPE["NUMBER"] = "NUMBER";
    NODE_TYPE["OBJECT"] = "OBJECT";
    NODE_TYPE["POJO"] = "POJO";
    NODE_TYPE["STRING"] = "STRING";
})(NODE_TYPE || (NODE_TYPE = {}));
var COLLECT_RESPONSE_TRANSFORM;
(function (COLLECT_RESPONSE_TRANSFORM) {
    COLLECT_RESPONSE_TRANSFORM["SHA256"] = "SHA256";
})(COLLECT_RESPONSE_TRANSFORM || (COLLECT_RESPONSE_TRANSFORM = {}));
var COLLECT_RESPONSE_STATUS;
(function (COLLECT_RESPONSE_STATUS) {
    COLLECT_RESPONSE_STATUS["PENDING"] = "PENDING";
    COLLECT_RESPONSE_STATUS["FAILED"] = "FAILED";
    COLLECT_RESPONSE_STATUS["COMPLETE"] = "COMPLETE";
})(COLLECT_RESPONSE_STATUS || (COLLECT_RESPONSE_STATUS = {}));
class SignRequestResponse extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignRequestResponse.prototype, "collectId", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignRequestResponse.prototype, "autostartToken", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignRequestResponse.prototype, "sourceMaterial", void 0);
__decorate$1i([
    Property({ type: COLLECT_RESPONSE_TRANSFORM }),
    __metadata$1i("design:type", String)
], SignRequestResponse.prototype, "transform", void 0);
class SignAssetRequest extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignAssetRequest.prototype, "assetId", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignAssetRequest.prototype, "userIdentification", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignAssetRequest.prototype, "summary", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignAssetRequest.prototype, "clientRemoteIp", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Object)
], SignAssetRequest.prototype, "properties", void 0);
class SignPayloadRequest extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignPayloadRequest.prototype, "payloadBase64", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignPayloadRequest.prototype, "userIdentification", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignPayloadRequest.prototype, "summary", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], SignPayloadRequest.prototype, "clientRemoteIp", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Object)
], SignPayloadRequest.prototype, "properties", void 0);
class JsonNode extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "float", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "array", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "null", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "valueNode", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "containerNode", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "missingNode", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "object", void 0);
__decorate$1i([
    Property({ type: NODE_TYPE }),
    __metadata$1i("design:type", String)
], JsonNode.prototype, "nodeType", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "pojo", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "number", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "integralNumber", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "floatingPointNumber", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "short", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "int", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "long", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "double", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "bigDecimal", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "bigInteger", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "textual", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "boolean", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Boolean)
], JsonNode.prototype, "binary", void 0);
class Signature extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], Signature.prototype, "object", void 0);
__decorate$1i([
    Property({ type: SIGNATURE_TYPE }),
    __metadata$1i("design:type", String)
], Signature.prototype, "type", void 0);
__decorate$1i([
    Property({ type: SIGNATURE_SOURCE }),
    __metadata$1i("design:type", String)
], Signature.prototype, "source", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", String)
], Signature.prototype, "sourceMaterial", void 0);
__decorate$1i([
    Property({ type: SIGNATURE_OBJECT_ENCODING }),
    __metadata$1i("design:type", String)
], Signature.prototype, "objectEncoding", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", JsonNode)
], Signature.prototype, "trustMaterial", void 0);
class CollectResponse extends BaseModel {
}
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Signature)
], CollectResponse.prototype, "signature", void 0);
__decorate$1i([
    Property(),
    __metadata$1i("design:type", Object)
], CollectResponse.prototype, "providerProperties", void 0);
__decorate$1i([
    Property({ type: COLLECT_RESPONSE_TRANSFORM }),
    __metadata$1i("design:type", String)
], CollectResponse.prototype, "transform", void 0);
__decorate$1i([
    Property({ type: COLLECT_RESPONSE_STATUS }),
    __metadata$1i("design:type", String)
], CollectResponse.prototype, "status", void 0);

var __decorate$1h = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1h = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class ShareholderDetails extends BaseModel {
}
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], ShareholderDetails.prototype, "name", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", Address)
], ShareholderDetails.prototype, "address", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], ShareholderDetails.prototype, "identifier", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", BankAccountDetails)
], ShareholderDetails.prototype, "bankAccount", void 0);
class Shareholder extends BaseModel {
}
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], Shareholder.prototype, "date", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], Shareholder.prototype, "companyId", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", Reference)
], Shareholder.prototype, "shareholder", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", Number)
], Shareholder.prototype, "numberOfShares", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", ShareholderDetails)
], Shareholder.prototype, "details", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], Shareholder.prototype, "signStatus", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", Boolean)
], Shareholder.prototype, "firstShareholder", void 0);
class UpdateShareholdersRequest extends BaseModel {
}
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], UpdateShareholdersRequest.prototype, "date", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", String)
], UpdateShareholdersRequest.prototype, "companyId", void 0);
__decorate$1h([
    Property(),
    __metadata$1h("design:type", Array)
], UpdateShareholdersRequest.prototype, "shareholders", void 0);
class ShareholderListResponse extends BaseModel {
}
__decorate$1h([
    Property({ type: Shareholder }),
    __metadata$1h("design:type", Array)
], ShareholderListResponse.prototype, "data", void 0);

var __decorate$1g = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1g = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SIGNATORY_TYPE;
(function (SIGNATORY_TYPE) {
    SIGNATORY_TYPE["CEO"] = "CEO";
    SIGNATORY_TYPE["BOARD_MEMBER"] = "BOARD_MEMBER";
    SIGNATORY_TYPE["CHAIRMAN"] = "CHAIRMAN";
    SIGNATORY_TYPE["ALTERNATE_MEMBER"] = "ALTERNATE_MEMBER";
})(SIGNATORY_TYPE || (SIGNATORY_TYPE = {}));
var DIVIDENDS_PAYMENT_STATUS;
(function (DIVIDENDS_PAYMENT_STATUS) {
    DIVIDENDS_PAYMENT_STATUS["SCHEDULED"] = "SCHEDULED";
    DIVIDENDS_PAYMENT_STATUS["PENDING"] = "PENDING";
    DIVIDENDS_PAYMENT_STATUS["DELIVERED"] = "DELIVERED";
    DIVIDENDS_PAYMENT_STATUS["CONFIRMED"] = "CONFIRMED";
    DIVIDENDS_PAYMENT_STATUS["REJECTED"] = "REJECTED";
    DIVIDENDS_PAYMENT_STATUS["CANCELLED"] = "CANCELLED";
})(DIVIDENDS_PAYMENT_STATUS || (DIVIDENDS_PAYMENT_STATUS = {}));
var REPORT_PERIOD_TYPE;
(function (REPORT_PERIOD_TYPE) {
    REPORT_PERIOD_TYPE["INSTANT"] = "INSTANT";
    REPORT_PERIOD_TYPE["RANGE"] = "RANGE";
    REPORT_PERIOD_TYPE["CURRENT_OPENING"] = "CURRENT_OPENING";
})(REPORT_PERIOD_TYPE || (REPORT_PERIOD_TYPE = {}));
var ANNUAL_REPORT_COLLECT_STATUS;
(function (ANNUAL_REPORT_COLLECT_STATUS) {
    ANNUAL_REPORT_COLLECT_STATUS["PENDING"] = "PENDING";
    ANNUAL_REPORT_COLLECT_STATUS["FAILED"] = "FAILED";
    ANNUAL_REPORT_COLLECT_STATUS["COMPLETE"] = "COMPLETE";
})(ANNUAL_REPORT_COLLECT_STATUS || (ANNUAL_REPORT_COLLECT_STATUS = {}));
var ANNUAL_REPORT_STATE;
(function (ANNUAL_REPORT_STATE) {
    ANNUAL_REPORT_STATE["DRAFT"] = "DRAFT";
    ANNUAL_REPORT_STATE["ACCEPTED"] = "ACCEPTED";
    ANNUAL_REPORT_STATE["REGISTERED"] = "REGISTERED";
    ANNUAL_REPORT_STATE["NOT_REGISTERED"] = "NOT_REGISTERED";
    ANNUAL_REPORT_STATE["INJUNCTION_SENT"] = "INJUNCTION_SENT";
    ANNUAL_REPORT_STATE["SUPPLEMENT_RECEIVED"] = "SUPPLEMENT_RECEIVED";
    ANNUAL_REPORT_STATE["TEST"] = "TEST";
    ANNUAL_REPORT_STATE["DELETED"] = "DELETED";
})(ANNUAL_REPORT_STATE || (ANNUAL_REPORT_STATE = {}));
var ANNUAL_REPORT_ASSET_TYPE;
(function (ANNUAL_REPORT_ASSET_TYPE) {
    ANNUAL_REPORT_ASSET_TYPE["IXBRL"] = "IXBRL";
    ANNUAL_REPORT_ASSET_TYPE["PDF"] = "PDF";
    ANNUAL_REPORT_ASSET_TYPE["INK2_PDF"] = "INK2_PDF";
    ANNUAL_REPORT_ASSET_TYPE["AGM_PROTOCOL_PDF"] = "AGM_PROTOCOL_PDF";
})(ANNUAL_REPORT_ASSET_TYPE || (ANNUAL_REPORT_ASSET_TYPE = {}));
var PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON;
(function (PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON) {
    PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON["BRING_PROFIT_FORWARD"] = "BRING_PROFIT_FORWARD";
})(PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON || (PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON = {}));
class AnnualReportImportBalance extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportImportBalance.prototype, "accountIdentifier", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportImportBalance.prototype, "date", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReportImportBalance.prototype, "amount", void 0);
class DividendsDecision extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecision.prototype, "id", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecision.prototype, "timestamp", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecision.prototype, "companyId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecision.prototype, "reportId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsDecision.prototype, "amount", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsDecision.prototype, "shareholderContributionPaybackAmount", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], DividendsDecision.prototype, "shareholderContributionPayback", void 0);
class Signatory extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], Signatory.prototype, "firstName", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], Signatory.prototype, "lastName", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], Signatory.prototype, "identifier", void 0);
__decorate$1g([
    Property({ type: SIGNATORY_TYPE }),
    __metadata$1g("design:type", String)
], Signatory.prototype, "type", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], Signatory.prototype, "roleDescription", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], Signatory.prototype, "printRole", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], Signatory.prototype, "ixbrlname", void 0);
class BoardMember extends Signatory {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], BoardMember.prototype, "signStatus", void 0);
class DividendsPayment extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsPayment.prototype, "time", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Shareholder)
], DividendsPayment.prototype, "shareholder", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsPayment.prototype, "financialPaymentId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsPayment.prototype, "amount", void 0);
__decorate$1g([
    Property({ type: DIVIDENDS_PAYMENT_STATUS }),
    __metadata$1g("design:type", String)
], DividendsPayment.prototype, "status", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], DividendsPayment.prototype, "calculated", void 0);
class ReportPeriod extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], ReportPeriod.prototype, "id", void 0);
__decorate$1g([
    Property({ type: REPORT_PERIOD_TYPE }),
    __metadata$1g("design:type", String)
], ReportPeriod.prototype, "type", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], ReportPeriod.prototype, "startDate", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], ReportPeriod.prototype, "endDate", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], ReportPeriod.prototype, "instant", void 0);
class AnnualReportAsset extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportAsset.prototype, "assetId", void 0);
__decorate$1g([
    Property({ type: ANNUAL_REPORT_ASSET_TYPE }),
    __metadata$1g("design:type", String)
], AnnualReportAsset.prototype, "type", void 0);
class AnnualReportSignature extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", AnnualReportAsset)
], AnnualReportSignature.prototype, "asset", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignature.prototype, "identifier", void 0);
class AnnualReportImportedBalance extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportImportedBalance.prototype, "accountIdentifier", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportImportedBalance.prototype, "date", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReportImportedBalance.prototype, "amount", void 0);
class AnnualReport extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "id", void 0);
__decorate$1g([
    Property({ type: ANNUAL_REPORT_STATE }),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "state", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "companyId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "companyName", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "companyIdentifier", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "companyPostalTown", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "companyOwnerIdentifier", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "story", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "significantEvents", void 0);
__decorate$1g([
    Property({ type: Number }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "averageNumberOfEmployees", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "firstFiscalYearStartDate", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "fiscalYearStartDate", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "fiscalYearEndDate", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", DividendsDecision)
], AnnualReport.prototype, "dividendsDecision", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", DividendsDecision)
], AnnualReport.prototype, "shareholderContributionPaybackDecision", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], AnnualReport.prototype, "hasBookedDividends", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "carriedDividends", void 0);
__decorate$1g([
    Property({ type: AnnualReportImportBalance }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "importedBalances", void 0);
__decorate$1g([
    Property({ type: ReportPeriod }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "balancePeriods", void 0);
__decorate$1g([
    Property({ type: ReportPeriod }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "profitLossPeriods", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", ReportPeriod)
], AnnualReport.prototype, "firstYearBalancePeriod", void 0);
__decorate$1g([
    Property({ type: Signatory }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "signatories", void 0);
__decorate$1g([
    Property({ type: AnnualReportSignature }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "signatures", void 0);
__decorate$1g([
    Property({ type: DividendsPayment }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "payments", void 0);
__decorate$1g([
    Property({ type: AnnualReportAsset }),
    __metadata$1g("design:type", Array)
], AnnualReport.prototype, "assets", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "overrideDividends", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "overrideShareholderContribution", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "overrideShareholderContributionPayback", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], AnnualReport.prototype, "fixedPrice", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Boolean)
], AnnualReport.prototype, "proposedProfitAppropriationApproved", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReport.prototype, "proposedProfitAppropriationRejectionReason", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "remainingDividends", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], AnnualReport.prototype, "dividendsPaid", void 0);
class DividendsDecisionRequest extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecisionRequest.prototype, "companyId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsDecisionRequest.prototype, "reportId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsDecisionRequest.prototype, "dividendsDecision", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsDecisionRequest.prototype, "shareholderContributionPayback", void 0);
class PossibleDividends extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], PossibleDividends.prototype, "dividends", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], PossibleDividends.prototype, "shareholderContributionPayback", void 0);
class AddSignatoryRequest extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AddSignatoryRequest.prototype, "firstName", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AddSignatoryRequest.prototype, "lastName", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AddSignatoryRequest.prototype, "identifier", void 0);
__decorate$1g([
    Property({ type: SIGNATORY_TYPE }),
    __metadata$1g("design:type", String)
], AddSignatoryRequest.prototype, "type", void 0);
class AnnualReportUpdateRequest extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportUpdateRequest.prototype, "story", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportUpdateRequest.prototype, "significantEvents", void 0);
__decorate$1g([
    Property({ type: Number }),
    __metadata$1g("design:type", Array)
], AnnualReportUpdateRequest.prototype, "averageNumberOfEmployees", void 0);
class DividendsPaymentRequest extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Amount)
], DividendsPaymentRequest.prototype, "amount", void 0);
class DividendsPaymentResponse extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], DividendsPaymentResponse.prototype, "reportId", void 0);
__decorate$1g([
    Property({ type: DividendsPayment }),
    __metadata$1g("design:type", Array)
], DividendsPaymentResponse.prototype, "payments", void 0);
class AnnualReportListResponse extends BaseModel {
}
__decorate$1g([
    Property({ type: AnnualReport }),
    __metadata$1g("design:type", Array)
], AnnualReportListResponse.prototype, "data", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Number)
], AnnualReportListResponse.prototype, "length", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Number)
], AnnualReportListResponse.prototype, "offset", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Number)
], AnnualReportListResponse.prototype, "total", void 0);
class AnnualReportSignRequest extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignRequest.prototype, "annualReportId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignRequest.prototype, "assetId", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignRequest.prototype, "endUserIp", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignRequest.prototype, "identifier", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignRequest.prototype, "summary", void 0);
class AnnualReportSignResponse extends BaseModel {
}
__decorate$1g([
    Property(),
    __metadata$1g("design:type", String)
], AnnualReportSignResponse.prototype, "collectId", void 0);
class AnnualReportCollectResponse extends BaseModel {
}
__decorate$1g([
    Property({ type: ANNUAL_REPORT_COLLECT_STATUS }),
    __metadata$1g("design:type", String)
], AnnualReportCollectResponse.prototype, "status", void 0);
__decorate$1g([
    Property(),
    __metadata$1g("design:type", Object)
], AnnualReportCollectResponse.prototype, "providerProperties", void 0);

var __decorate$1f = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1f = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ASSET_TRANSFORM;
(function (ASSET_TRANSFORM) {
    ASSET_TRANSFORM["RESIZE"] = "resize";
    ASSET_TRANSFORM["ICON"] = "icon";
})(ASSET_TRANSFORM || (ASSET_TRANSFORM = {}));
class OwnerMetaData extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], OwnerMetaData.prototype, "companyId", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], OwnerMetaData.prototype, "userId", void 0);
class SystemReference extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], SystemReference.prototype, "id", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], SystemReference.prototype, "type", void 0);
class BinaryMeta extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], BinaryMeta.prototype, "contentType", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], BinaryMeta.prototype, "filename", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], BinaryMeta.prototype, "alias", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", OwnerMetaData)
], BinaryMeta.prototype, "ownership", void 0);
__decorate$1f([
    Property({ type: SystemReference }),
    __metadata$1f("design:type", Array)
], BinaryMeta.prototype, "references", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", Object)
], BinaryMeta.prototype, "attributes", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], BinaryMeta.prototype, "created", void 0);
class AssetBinary extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetBinary.prototype, "id", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", BinaryMeta)
], AssetBinary.prototype, "meta", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetBinary.prototype, "contentBase64", void 0);
class Asset extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], Asset.prototype, "id", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", OwnerMetaData)
], Asset.prototype, "ownership", void 0);
__decorate$1f([
    Property({ type: AssetBinary }),
    __metadata$1f("design:type", Array)
], Asset.prototype, "parts", void 0);
class DownloadAssetCreationResponse extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], DownloadAssetCreationResponse.prototype, "assetId", void 0);
__decorate$1f([
    Property({ type: String }),
    __metadata$1f("design:type", Array)
], DownloadAssetCreationResponse.prototype, "assetIds", void 0);
var ASSETUPLOADSTATUS;
(function (ASSETUPLOADSTATUS) {
    ASSETUPLOADSTATUS["UPLOAD_IN_PROGRESS"] = "UPLOAD_IN_PROGRESS";
    ASSETUPLOADSTATUS["ERROR_DURING_UPLOAD"] = "ERROR_DURING_UPLOAD";
    ASSETUPLOADSTATUS["UPLOAD_DONE"] = "UPLOAD_DONE";
})(ASSETUPLOADSTATUS || (ASSETUPLOADSTATUS = {}));
class UploadedEntityDetails extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", Reference)
], UploadedEntityDetails.prototype, "uploadedEntity", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], UploadedEntityDetails.prototype, "verificationsFileName", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], UploadedEntityDetails.prototype, "uploadStatus", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], UploadedEntityDetails.prototype, "uploadStatusDescription", void 0);
class AssetsUploadDetails extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "companyId", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "assetUploadStatus", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "uploadInitiationTime", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "uploadCompletionTime", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "googleDriveFolderUrl", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], AssetsUploadDetails.prototype, "errorMessage", void 0);
__decorate$1f([
    Property({ type: String }),
    __metadata$1f("design:type", Array)
], AssetsUploadDetails.prototype, "userAccessList", void 0);
__decorate$1f([
    Property({ type: UploadedEntityDetails }),
    __metadata$1f("design:type", Array)
], AssetsUploadDetails.prototype, "allAssetsDetails", void 0);
__decorate$1f([
    Property({ type: UploadedEntityDetails }),
    __metadata$1f("design:type", Array)
], AssetsUploadDetails.prototype, "failedAssets", void 0);
class GoogleDriveAccessRequest extends BaseModel {
}
__decorate$1f([
    Property({ type: String }),
    __metadata$1f("design:type", Array)
], GoogleDriveAccessRequest.prototype, "emailsOfUsersForFolderAccess", void 0);
class GoogleDriveAccessUpdateResponse extends BaseModel {
}
__decorate$1f([
    Property(),
    __metadata$1f("design:type", String)
], GoogleDriveAccessUpdateResponse.prototype, "folderName", void 0);
__decorate$1f([
    Property(),
    __metadata$1f("design:type", Boolean)
], GoogleDriveAccessUpdateResponse.prototype, "accessGranted", void 0);
__decorate$1f([
    Property({ type: String }),
    __metadata$1f("design:type", Array)
], GoogleDriveAccessUpdateResponse.prototype, "userAccessList", void 0);

var __decorate$1e = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1e = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let BgcResponseItem = class BgcResponseItem extends Model {
};
__decorate$1e([
    Field(),
    __metadata$1e("design:type", String)
], BgcResponseItem.prototype, "companyName", void 0);
__decorate$1e([
    Field(),
    __metadata$1e("design:type", String)
], BgcResponseItem.prototype, "bankgiroNumber", void 0);
__decorate$1e([
    Field(),
    __metadata$1e("design:type", String)
], BgcResponseItem.prototype, "organizationNumber", void 0);
__decorate$1e([
    Field({ type: String }),
    __metadata$1e("design:type", Array)
], BgcResponseItem.prototype, "address", void 0);
BgcResponseItem = __decorate$1e([
    Data()
], BgcResponseItem);

var __decorate$1d = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1d = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let BgcResponse = class BgcResponse extends Model {
};
__decorate$1d([
    Field({ type: BgcResponseItem }),
    __metadata$1d("design:type", Array)
], BgcResponse.prototype, "items", void 0);
BgcResponse = __decorate$1d([
    Data()
], BgcResponse);

var __decorate$1c = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1c = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var REMITTANCE_TYPE;
(function (REMITTANCE_TYPE) {
    REMITTANCE_TYPE["MESSAGE"] = "MESSAGE";
    REMITTANCE_TYPE["OCR"] = "OCR";
    REMITTANCE_TYPE["UNKNOWN"] = "UNKNOWN";
})(REMITTANCE_TYPE || (REMITTANCE_TYPE = {}));
class RemittanceInfo extends BaseModel {
}
__decorate$1c([
    Property(),
    __metadata$1c("design:type", Amount)
], RemittanceInfo.prototype, "amount", void 0);
__decorate$1c([
    Property(),
    __metadata$1c("design:type", String)
], RemittanceInfo.prototype, "type", void 0);
__decorate$1c([
    Property(),
    __metadata$1c("design:type", String)
], RemittanceInfo.prototype, "value", void 0);
__decorate$1c([
    Property({ type: String }),
    __metadata$1c("design:type", Array)
], RemittanceInfo.prototype, "additionalInfo", void 0);

var PAYMENT_STATUS;
(function (PAYMENT_STATUS) {
    PAYMENT_STATUS["PENDING"] = "PENDING";
    PAYMENT_STATUS["PARTIAL"] = "PARTIAL";
    PAYMENT_STATUS["OVERPAID"] = "OVERPAID";
    PAYMENT_STATUS["FULL"] = "FULL";
    PAYMENT_STATUS["ABANDONED"] = "ABANDONED";
    PAYMENT_STATUS["DELIVERED"] = "DELIVERED";
    PAYMENT_STATUS["CONFIRMED"] = "CONFIRMED";
    PAYMENT_STATUS["CANCELLED"] = "CANCELLED";
    PAYMENT_STATUS["REJECTED"] = "REJECTED";
    PAYMENT_STATUS["SCHEDULED"] = "SCHEDULED";
    PAYMENT_STATUS["NA"] = "NA";
})(PAYMENT_STATUS || (PAYMENT_STATUS = {}));

var MARKET;
(function (MARKET) {
    MARKET["LOCAL"] = "LOCAL";
    MARKET["EU"] = "EU";
    MARKET["OTHER"] = "OTHER";
})(MARKET || (MARKET = {}));

var PAYMENT_TYPE;
(function (PAYMENT_TYPE) {
    PAYMENT_TYPE["CREDIT"] = "CREDIT";
    PAYMENT_TYPE["DEBIT"] = "DEBIT";
})(PAYMENT_TYPE || (PAYMENT_TYPE = {}));

var __decorate$1b = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1b = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BOOKABLE_TYPE;
(function (BOOKABLE_TYPE) {
    BOOKABLE_TYPE["REPRESENTATION_MIXED"] = "REPRESENTATION_MIXED";
    BOOKABLE_TYPE["REPRESENTATION_FOOD_AND_BEVERAGE"] = "REPRESENTATION_FOOD_AND_BEVERAGE";
    BOOKABLE_TYPE["REPRESENTATION_EVENT"] = "REPRESENTATION_EVENT";
    BOOKABLE_TYPE["INVENTORY_SALE"] = "INVENTORY_SALE";
    BOOKABLE_TYPE["INVENTORY_DEPRECIATION"] = "INVENTORY_DEPRECIATION";
    BOOKABLE_TYPE["EU_TRADE"] = "EU_TRADE";
    BOOKABLE_TYPE["LOCAL_TRADE"] = "LOCAL_TRADE";
    BOOKABLE_TYPE["OTHER_TRADE"] = "OTHER_TRADE";
    BOOKABLE_TYPE["NONE"] = "NONE";
})(BOOKABLE_TYPE || (BOOKABLE_TYPE = {}));
class BookkeepingHint extends BaseModel {
}
__decorate$1b([
    Property(),
    __metadata$1b("design:type", String)
], BookkeepingHint.prototype, "accountId", void 0);
__decorate$1b([
    Property(),
    __metadata$1b("design:type", Amount)
], BookkeepingHint.prototype, "amount", void 0);
__decorate$1b([
    Property(),
    __metadata$1b("design:type", String)
], BookkeepingHint.prototype, "bookableType", void 0);
__decorate$1b([
    Property(),
    __metadata$1b("design:type", String)
], BookkeepingHint.prototype, "direction", void 0);
__decorate$1b([
    Property(),
    __metadata$1b("design:type", String)
], BookkeepingHint.prototype, "market", void 0);

var __decorate$1a = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1a = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DEPRECIATION_ITEM_TYPE;
(function (DEPRECIATION_ITEM_TYPE) {
    DEPRECIATION_ITEM_TYPE["BUILDING"] = "BUILDING";
    DEPRECIATION_ITEM_TYPE["LAND_IMPROVEMENT"] = "LAND_IMPROVEMENT";
    DEPRECIATION_ITEM_TYPE["MACHINERY_OR_EQUIPMENT"] = "MACHINERY_OR_EQUIPMENT";
})(DEPRECIATION_ITEM_TYPE || (DEPRECIATION_ITEM_TYPE = {}));
class DepreciationItem extends BaseModel {
}
__decorate$1a([
    Property(),
    __metadata$1a("design:type", Amount)
], DepreciationItem.prototype, "cost", void 0);
__decorate$1a([
    Property(),
    __metadata$1a("design:type", String)
], DepreciationItem.prototype, "description", void 0);
__decorate$1a([
    Property(),
    __metadata$1a("design:type", String)
], DepreciationItem.prototype, "type", void 0);

const EU_MEMBERS = [
    COUNTRY.AUSTRIA,
    COUNTRY.BELGIUM,
    COUNTRY.BULGARIA,
    COUNTRY.CROATIA,
    COUNTRY.CYPRUS,
    COUNTRY.CZECHREPUBLIC,
    COUNTRY.DENMARK,
    COUNTRY.ESTONIA,
    COUNTRY.FINLAND,
    COUNTRY.FRANCE,
    COUNTRY.GERMANY,
    COUNTRY.GREECE,
    COUNTRY.HUNGARY,
    COUNTRY.IRELAND,
    COUNTRY.ITALY,
    COUNTRY.LATVIA,
    COUNTRY.LITHUANIA,
    COUNTRY.LUXEMBOURG,
    COUNTRY.MALTA,
    COUNTRY.NETHERLANDS,
    COUNTRY.POLAND,
    COUNTRY.PORTUGAL,
    COUNTRY.ROMANIA,
    COUNTRY.SLOVAKIA,
    COUNTRY.SLOVENIA,
    COUNTRY.SPAIN,
    COUNTRY.SWEDEN,
];
const EFTA_MEMBERS = [
    ...EU_MEMBERS,
    COUNTRY.ICELAND,
    COUNTRY.LIECHTENSTEIN,
    COUNTRY.NORWAY,
    COUNTRY.SWITZERLAND,
];
const HAS_VAT_IDENTIFIER = [
    ...EU_MEMBERS,
    COUNTRY.BRAZIL,
    COUNTRY.ICELAND,
    COUNTRY.RUSSIANFEDERATION,
    COUNTRY.SERBIA,
    COUNTRY.SWITZERLAND,
    COUNTRY.VENEZUELA,
    COUNTRY.SOUTHAFRICA,
];
var VAT_AREA;
(function (VAT_AREA) {
    VAT_AREA["DOMESTIC_VAT"] = "DOMNESTIC_VAT";
    VAT_AREA["DOMESTIC_NO_VAT"] = "DOMNESTIC_NO_VAT";
    VAT_AREA["NON_EU"] = "NON_EU";
    VAT_AREA["EU"] = "EU";
})(VAT_AREA || (VAT_AREA = {}));
var VAT_TYPE;
(function (VAT_TYPE) {
    VAT_TYPE["SE_25"] = "SE_25";
    VAT_TYPE["SE_12"] = "SE_12";
    VAT_TYPE["SE_06"] = "SE_06";
    VAT_TYPE["SE_00"] = "SE_00";
    VAT_TYPE["EU_00"] = "EU_00";
    VAT_TYPE["CUSTOM"] = "CUSTOM";
})(VAT_TYPE || (VAT_TYPE = {}));

var __decorate$19 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$19 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatAmount extends BaseModel {
}
__decorate$19([
    Property(),
    __metadata$19("design:type", Amount)
], VatAmount.prototype, "amount", void 0);
__decorate$19([
    Property(),
    __metadata$19("design:type", String)
], VatAmount.prototype, "type", void 0);

var countryToCurrency = {
    AF: 'AFN',
    AL: 'ALL',
    DZ: 'DZD',
    AS: 'USD',
    AD: 'EUR',
    AO: 'AOA',
    AI: 'USD',
    AQ: 'USD',
    AG: 'XCD',
    AR: 'ARS',
    AM: 'AMD',
    AW: 'AWG',
    AC: 'USD',
    AU: 'AUD',
    AT: 'EUR',
    AZ: 'AZN',
    BS: 'BSD',
    BH: 'BHD',
    BD: 'BDT',
    BB: 'BBD',
    BY: 'BYR',
    BE: 'EUR',
    BZ: 'BZD',
    BJ: 'XOF',
    BM: 'USD',
    BT: 'BTN',
    BO: 'BOB',
    BA: 'USD',
    BW: 'BWP',
    BV: 'USD',
    BR: 'BRL',
    IO: 'USD',
    BN: 'BND',
    BG: 'BGN',
    BF: 'USD',
    BI: 'USD',
    KH: 'USD',
    CM: 'XAF',
    CA: 'CAD',
    CV: 'USD',
    KY: 'USD',
    CF: 'USD',
    TD: 'USD',
    CL: 'CLP',
    CN: 'CNY',
    CX: 'USD',
    CC: 'USD',
    CO: 'COP',
    KM: 'USD',
    CG: 'USD',
    CD: 'USD',
    CK: 'NZD',
    CR: 'CRC',
    CI: 'XOF',
    HR: 'HRK',
    CU: 'USD',
    CY: 'EUR',
    CZ: 'CZK',
    DK: 'DKK',
    DJ: 'USD',
    DM: 'XCD',
    DO: 'DOP',
    TP: 'USD',
    EC: 'USD',
    EG: 'EGP',
    SV: 'USD',
    GQ: 'USD',
    ER: 'ERN',
    EE: 'EUR',
    ET: 'ETB',
    FK: 'FKP',
    FO: 'DKK',
    FJ: 'FJD',
    FI: 'EUR',
    FR: 'EUR',
    GF: 'EUR',
    PF: 'USD',
    TF: 'EUR',
    GA: 'USD',
    GM: 'GMD',
    GE: 'USD',
    DE: 'EUR',
    GH: 'USD',
    GI: 'GBP',
    GB: 'GBP',
    GR: 'EUR',
    GL: 'DKK',
    GD: 'XCD',
    GP: 'USD',
    GU: 'USD',
    GT: 'GTQ',
    GG: 'GBP',
    GN: 'USD',
    GW: 'USD',
    GY: 'GYD',
    HT: 'USD',
    HM: 'USD',
    HN: 'HNL',
    HK: 'HKD',
    HU: 'HUF',
    IS: 'ISK',
    IN: 'INR',
    ID: 'IDR',
    IR: 'IRR',
    IQ: 'IQD',
    IE: 'EUR',
    IM: 'GBP',
    IL: 'ILS',
    IT: 'EUR',
    JM: 'JMD',
    JP: 'JPY',
    JE: 'GBP',
    JO: 'JOD',
    KZ: 'USD',
    KE: 'KES',
    KI: 'USD',
    KP: 'KRW',
    KR: 'KRW',
    KW: 'KWD',
    KG: 'USD',
    LA: 'USD',
    LV: 'EUR',
    LB: 'LBP',
    LS: 'ZAR',
    LR: 'USD',
    LY: 'LYD',
    LI: 'CHF',
    LT: 'EUR',
    LU: 'EUR',
    MO: 'MOP',
    MK: 'MKD',
    MG: 'USD',
    MW: 'MWK',
    MY: 'MYR',
    MV: 'USD',
    ML: 'USD',
    MT: 'EUR',
    MH: 'USD',
    MQ: 'EUR',
    MR: 'USD',
    MU: 'MUR',
    YT: 'EUR',
    MX: 'MXN',
    FM: 'USD',
    MD: 'USD',
    MC: 'EUR',
    MN: 'USD',
    MS: 'XCD',
    MA: 'MAD',
    MZ: 'USD',
    MM: 'USD',
    NA: 'USD',
    NR: 'AUD',
    NP: 'NPR',
    NL: 'EUR',
    AN: 'ANG',
    NC: 'USD',
    NZ: 'NZD',
    NI: 'NIO',
    NE: 'USD',
    NG: 'NGN',
    NU: 'NZD',
    NF: 'AUD',
    MP: 'USD',
    NO: 'NOK',
    OM: 'OMR',
    PK: 'PKR',
    PW: 'USD',
    PS: 'USD',
    PA: 'PAB',
    PG: 'PGK',
    PY: 'PYG',
    PE: 'PEN',
    PH: 'PHP',
    PN: 'USD',
    PL: 'PLN',
    PT: 'EUR',
    PR: 'USD',
    QA: 'QAR',
    RE: 'USD',
    RO: 'RON',
    RU: 'RUB',
    RW: 'RWF',
    KN: 'XCD',
    LC: 'XCD',
    VC: 'XCD',
    WS: 'WST',
    SM: 'EUR',
    ST: 'USD',
    SA: 'SAR',
    SN: 'USD',
    CS: 'EUR',
    RS: 'RSD',
    SC: 'USD',
    SL: 'USD',
    SG: 'SGD',
    SK: 'EUR',
    SI: 'EUR',
    SB: 'SBD',
    SO: 'USD',
    ZA: 'ZAR',
    GS: 'USD',
    ES: 'EUR',
    LK: 'LKR',
    SH: 'USD',
    PM: 'USD',
    SD: 'USD',
    SR: 'USD',
    SJ: 'USD',
    SZ: 'SZL',
    SE: 'SEK',
    CH: 'CHF',
    SY: 'SYP',
    TW: 'TWD',
    TJ: 'USD',
    TZ: 'TZS',
    TH: 'THB',
    TG: 'USD',
    TK: 'USD',
    TO: 'TOP',
    TT: 'TTD',
    TN: 'TND',
    TR: 'TRY',
    TM: 'USD',
    TC: 'USD',
    TV: 'USD',
    UM: 'USD',
    UG: 'UGX',
    UA: 'UAH',
    AE: 'AED',
    US: 'USD',
    UY: 'USD',
    UZ: 'UZS',
    VU: 'VUV',
    VA: 'USD',
    VE: 'VEF',
    VN: 'VND',
    VG: 'USD',
    VI: 'USD',
    WF: 'USD',
    EH: 'USD',
    YE: 'YER',
    ZM: 'USD',
    ZW: 'ZWL',
};

var __decorate$18 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$18 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var EXCHANGE_RATE_SOURCE;
(function (EXCHANGE_RATE_SOURCE) {
    EXCHANGE_RATE_SOURCE["PROVIDER"] = "PROVIDER";
    EXCHANGE_RATE_SOURCE["COMPUTED"] = "COMPUTED";
})(EXCHANGE_RATE_SOURCE || (EXCHANGE_RATE_SOURCE = {}));
class ExchangeRate extends BaseModel {
}
__decorate$18([
    Property(),
    __metadata$18("design:type", Number)
], ExchangeRate.prototype, "factor", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", String)
], ExchangeRate.prototype, "source", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", String)
], ExchangeRate.prototype, "target", void 0);
class ForexAmount extends BaseModel {
}
__decorate$18([
    Property(),
    __metadata$18("design:type", Amount)
], ForexAmount.prototype, "counterValue", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", Amount)
], ForexAmount.prototype, "value", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", ExchangeRate)
], ForexAmount.prototype, "rate", void 0);
class CurrencyConversionRequest extends BaseModel {
}
__decorate$18([
    Property(),
    __metadata$18("design:type", Amount)
], CurrencyConversionRequest.prototype, "amount", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", String)
], CurrencyConversionRequest.prototype, "to", void 0);
class CurrencyConversionResponse extends BaseModel {
}
__decorate$18([
    Property(),
    __metadata$18("design:type", Amount)
], CurrencyConversionResponse.prototype, "amount", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", Amount)
], CurrencyConversionResponse.prototype, "converted", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", Number)
], CurrencyConversionResponse.prototype, "rate", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", String)
], CurrencyConversionResponse.prototype, "rateDate", void 0);
__decorate$18([
    Property(),
    __metadata$18("design:type", String)
], CurrencyConversionResponse.prototype, "requestedDate", void 0);
class CurrencyListResponse extends BaseModel {
}
__decorate$18([
    Property({ type: CURRENCY }),
    __metadata$18("design:type", Array)
], CurrencyListResponse.prototype, "data", void 0);
class Forex {
    static currencyForCountry(country, allowed) {
        const currency = countryToCurrency[country] || null;
        return allowed && allowed.indexOf(currency) === -1 ? null : currency;
    }
}

var __decorate$17 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$17 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class ExchangeAmount extends BaseModel {
}
__decorate$17([
    Property(),
    __metadata$17("design:type", Amount)
], ExchangeAmount.prototype, "value", void 0);
__decorate$17([
    Property(),
    __metadata$17("design:type", Amount)
], ExchangeAmount.prototype, "counterValue", void 0);
__decorate$17([
    Property(),
    __metadata$17("design:type", ExchangeRate)
], ExchangeAmount.prototype, "rate", void 0);
__decorate$17([
    Property(),
    __metadata$17("design:type", String)
], ExchangeAmount.prototype, "rateSource", void 0);

var __decorate$16 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$16 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BILL_STATUS;
(function (BILL_STATUS) {
    BILL_STATUS["PENDING"] = "PENDING";
    BILL_STATUS["IN_REVIEW"] = "IN_REVIEW";
    BILL_STATUS["IN_USER_REVIEW"] = "IN_USER_REVIEW";
    BILL_STATUS["REJECTED"] = "REJECTED";
    BILL_STATUS["BOOKED"] = "BOOKED";
    BILL_STATUS["CANCELLED"] = "CANCELLED";
    BILL_STATUS["DELETED"] = "DELETED";
})(BILL_STATUS || (BILL_STATUS = {}));
var BILL_SORT_ORDER;
(function (BILL_SORT_ORDER) {
    BILL_SORT_ORDER["ASCENDING"] = "ASCENDING";
    BILL_SORT_ORDER["DESCENDING"] = "DESCENDING";
})(BILL_SORT_ORDER || (BILL_SORT_ORDER = {}));
var BILL_ORDER_BY;
(function (BILL_ORDER_BY) {
    BILL_ORDER_BY["CREATED"] = "CREATED";
    BILL_ORDER_BY["MODIFIED"] = "MODIFIED";
})(BILL_ORDER_BY || (BILL_ORDER_BY = {}));
class BillPaymentReceiver extends BaseModel {
}
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], BillPaymentReceiver.prototype, "name", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Address)
], BillPaymentReceiver.prototype, "address", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Account)
], BillPaymentReceiver.prototype, "account", void 0);
class BillPayment extends BaseModel {
}
__decorate$16([
    Property(),
    __metadata$16("design:type", BillPaymentReceiver)
], BillPayment.prototype, "to", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", RemittanceInfo)
], BillPayment.prototype, "reference", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], BillPayment.prototype, "payBy", void 0);
class Bill extends BaseModel {
}
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "id", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "description", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "companyId", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "assetId", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Amount)
], Bill.prototype, "totalAmount", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Amount)
], Bill.prototype, "totalVAT", void 0);
__decorate$16([
    Property({ type: VatAmount }),
    __metadata$16("design:type", Array)
], Bill.prototype, "vatList", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "billDate", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "payBy", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "dueDate", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", BillPayment)
], Bill.prototype, "paymentDetails", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "paymentStatus", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "paymentRejectionMessage", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "created", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "modified", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], Bill.prototype, "resourceUrl", void 0);
__decorate$16([
    Property({ defaultValue: 'PENDING' }),
    __metadata$16("design:type", String)
], Bill.prototype, "status", void 0);
__decorate$16([
    Property({ type: BookkeepingHint }),
    __metadata$16("design:type", Array)
], Bill.prototype, "bookkeepingHints", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", DepreciationItem)
], Bill.prototype, "depreciationItem", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", ExchangeAmount)
], Bill.prototype, "forexAmount", void 0);
class BillListResponse extends BaseModel {
}
__decorate$16([
    Property({ type: Bill }),
    __metadata$16("design:type", Array)
], BillListResponse.prototype, "data", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Number)
], BillListResponse.prototype, "length", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Number)
], BillListResponse.prototype, "offset", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Number)
], BillListResponse.prototype, "total", void 0);
class BillUpdateRequest extends BaseModel {
}
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], BillUpdateRequest.prototype, "billDate", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], BillUpdateRequest.prototype, "dueDate", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", String)
], BillUpdateRequest.prototype, "description", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Amount)
], BillUpdateRequest.prototype, "totalAmount", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", Amount)
], BillUpdateRequest.prototype, "totalVat", void 0);
__decorate$16([
    Property({ type: VatAmount }),
    __metadata$16("design:type", Array)
], BillUpdateRequest.prototype, "vatList", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", ExchangeAmount)
], BillUpdateRequest.prototype, "forexAmount", void 0);
class BillBookkeepingUpdateRequest extends BaseModel {
}
__decorate$16([
    Property({ type: BookkeepingHint }),
    __metadata$16("design:type", Array)
], BillBookkeepingUpdateRequest.prototype, "bookkeepingHints", void 0);
__decorate$16([
    Property(),
    __metadata$16("design:type", DepreciationItem)
], BillBookkeepingUpdateRequest.prototype, "depreciationItem", void 0);
class BillPaymentUpdateRequest extends BillPayment {
}

var __decorate$15 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$15 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyBookedBalance extends BaseModel {
}
__decorate$15([
    Property(),
    __metadata$15("design:type", String)
], CompanyBookedBalance.prototype, "accountId", void 0);
__decorate$15([
    Property(),
    __metadata$15("design:type", Amount)
], CompanyBookedBalance.prototype, "amount", void 0);
__decorate$15([
    Property(),
    __metadata$15("design:type", String)
], CompanyBookedBalance.prototype, "direction", void 0);

var __decorate$14 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$14 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BOOKKEEPING_ACCOUNT_CLASS;
(function (BOOKKEEPING_ACCOUNT_CLASS) {
    BOOKKEEPING_ACCOUNT_CLASS["ACCOUNTANT_FEES"] = "ACCOUNTANT_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCOUNTS_PAYABLES"] = "ACCOUNTS_PAYABLES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCOUNTS_RECEIVABLES"] = "ACCOUNTS_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCOUNTS_RECEIVABLES_ROYALTY_STATEMENT"] = "ACCOUNTS_RECEIVABLES_ROYALTY_STATEMENT";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_CONTRACTUAL_SOCIAL_FEES"] = "ACCRUED_CONTRACTUAL_SOCIAL_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_FEES_AND_PREMIUMS"] = "ACCRUED_FEES_AND_PREMIUMS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_INCOME_VAT_EXEMPT"] = "ACCRUED_INCOME_VAT_EXEMPT";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_INCOME_WITH_VAT"] = "ACCRUED_INCOME_WITH_VAT";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_INTEREST_INCOME"] = "ACCRUED_INTEREST_INCOME";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_INTEREST_PAYABLE"] = "ACCRUED_INTEREST_PAYABLE";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_RENTAL_INCOME"] = "ACCRUED_RENTAL_INCOME";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_SALARIES"] = "ACCRUED_SALARIES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_SOCIAL_FEES"] = "ACCRUED_SOCIAL_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCRUED_VACATION_PAY"] = "ACCRUED_VACATION_PAY";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_ADDTL_DEPRECIATION"] = "ACCUMULATED_ADDTL_DEPRECIATION";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_BUILDINGS"] = "ACCUMULATED_DEPRECIATIONS_ON_BUILDINGS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_CARS_AND_VEHICLES"] = "ACCUMULATED_DEPRECIATIONS_ON_CARS_AND_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_COMPUTERS"] = "ACCUMULATED_DEPRECIATIONS_ON_COMPUTERS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_IMMATERIAL_ASSETS"] = "ACCUMULATED_DEPRECIATIONS_ON_IMMATERIAL_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_INVENTORY_AND_TOOLS"] = "ACCUMULATED_DEPRECIATIONS_ON_INVENTORY_AND_TOOLS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_LAND_IMPROVEMENTS"] = "ACCUMULATED_DEPRECIATIONS_ON_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_MACHINES_AND_OTHER_EQUIPMENT"] = "ACCUMULATED_DEPRECIATIONS_ON_MACHINES_AND_OTHER_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["ACCUMULATED_DEPRECIATIONS_ON_RENTAL_PROPERTIES"] = "ACCUMULATED_DEPRECIATIONS_ON_RENTAL_PROPERTIES";
    BOOKKEEPING_ACCOUNT_CLASS["ADVERTISING_AND_PR"] = "ADVERTISING_AND_PR";
    BOOKKEEPING_ACCOUNT_CLASS["ALLOWED_REBATES"] = "ALLOWED_REBATES";
    BOOKKEEPING_ACCOUNT_CLASS["ART_AND_SIMILAR_ASSETS"] = "ART_AND_SIMILAR_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["BALANCED_RESULT"] = "BALANCED_RESULT";
    BOOKKEEPING_ACCOUNT_CLASS["BALANCED_RESULT_PREVIOUS_YEAR"] = "BALANCED_RESULT_PREVIOUS_YEAR";
    BOOKKEEPING_ACCOUNT_CLASS["BANK"] = "BANK";
    BOOKKEEPING_ACCOUNT_CLASS["BANKING_FEES"] = "BANKING_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["BANK_ADVANCES"] = "BANK_ADVANCES";
    BOOKKEEPING_ACCOUNT_CLASS["BANK_FUNDS_RESERVED"] = "BANK_FUNDS_RESERVED";
    BOOKKEEPING_ACCOUNT_CLASS["BANK_LIABILITIES"] = "BANK_LIABILITIES";
    BOOKKEEPING_ACCOUNT_CLASS["BED_AND_BOARD_OTHER"] = "BED_AND_BOARD_OTHER";
    BOOKKEEPING_ACCOUNT_CLASS["BED_AND_BOARD_SWEDEN"] = "BED_AND_BOARD_SWEDEN";
    BOOKKEEPING_ACCOUNT_CLASS["BOOKKEEPING_SERVICES"] = "BOOKKEEPING_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["BUILDINGS"] = "BUILDINGS";
    BOOKKEEPING_ACCOUNT_CLASS["BUILDINGS_AND_LAND_IMPROVEMENTS"] = "BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["CAPITAL_CONTRIBUTIONS_FOREST_ACCOUNT_ETC"] = "CAPITAL_CONTRIBUTIONS_FOREST_ACCOUNT_ETC";
    BOOKKEEPING_ACCOUNT_CLASS["CARS_AND_OTHER_VEHICLES"] = "CARS_AND_OTHER_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["CAR_ALLOWANCE"] = "CAR_ALLOWANCE";
    BOOKKEEPING_ACCOUNT_CLASS["CAR_ALLOWANCE_TAX_EXEMPT"] = "CAR_ALLOWANCE_TAX_EXEMPT";
    BOOKKEEPING_ACCOUNT_CLASS["CAR_COSTS"] = "CAR_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["CAR_HOUSING_BENEFITS"] = "CAR_HOUSING_BENEFITS";
    BOOKKEEPING_ACCOUNT_CLASS["CAR_RENTALS"] = "CAR_RENTALS";
    BOOKKEEPING_ACCOUNT_CLASS["CASH_HANDOUTS"] = "CASH_HANDOUTS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_ADDITIONAL_DEPRECIATIONS"] = "CHANGE_IN_ADDITIONAL_DEPRECIATIONS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_INVENTORY"] = "CHANGE_IN_INVENTORY";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_INVENTORY_FINISHED_PRODUCTS"] = "CHANGE_IN_INVENTORY_FINISHED_PRODUCTS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_INVENTORY_RAW_MATERIALS"] = "CHANGE_IN_INVENTORY_RAW_MATERIALS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_INVENTORY_TRADE_GOODS"] = "CHANGE_IN_INVENTORY_TRADE_GOODS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_INVENTORY_WORK_IN_PROGRESS"] = "CHANGE_IN_INVENTORY_WORK_IN_PROGRESS";
    BOOKKEEPING_ACCOUNT_CLASS["CHANGE_IN_ONGOING_WORK"] = "CHANGE_IN_ONGOING_WORK";
    BOOKKEEPING_ACCOUNT_CLASS["COMPANY_INSURANCES"] = "COMPANY_INSURANCES";
    BOOKKEEPING_ACCOUNT_CLASS["COMPANY_INSURANCES_AND_OTHER_RISK_MITIGATION_COSTS"] = "COMPANY_INSURANCES_AND_OTHER_RISK_MITIGATION_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["COMPANY_INSURANCES_GROUP_ACCOUNT"] = "COMPANY_INSURANCES_GROUP_ACCOUNT";
    BOOKKEEPING_ACCOUNT_CLASS["COMPENSATION_FUND"] = "COMPENSATION_FUND";
    BOOKKEEPING_ACCOUNT_CLASS["COMPUTERS"] = "COMPUTERS";
    BOOKKEEPING_ACCOUNT_CLASS["CONSULTANT_FEES"] = "CONSULTANT_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["CONSUMABLE_INVENTORY"] = "CONSUMABLE_INVENTORY";
    BOOKKEEPING_ACCOUNT_CLASS["CONSUMABLE_MATERIALS"] = "CONSUMABLE_MATERIALS";
    BOOKKEEPING_ACCOUNT_CLASS["CONTRACUAL_SOCIAL_FEES"] = "CONTRACUAL_SOCIAL_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["COSTS_OF_VEHICLES"] = "COSTS_OF_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["COST_OF_EMPLOYEE_BENEFITS"] = "COST_OF_EMPLOYEE_BENEFITS";
    BOOKKEEPING_ACCOUNT_CLASS["COST_OF_FREE_CAR"] = "COST_OF_FREE_CAR";
    BOOKKEEPING_ACCOUNT_CLASS["COST_OF_SALES"] = "COST_OF_SALES";
    BOOKKEEPING_ACCOUNT_CLASS["CREDIT_AND_COUPON_RECEIVABLES"] = "CREDIT_AND_COUPON_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["CURRENCY_EFFECTS_ON_PAYABLES_AND_INVESTMENTS"] = "CURRENCY_EFFECTS_ON_PAYABLES_AND_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["CURRENCY_EFFECT_ON_DEBTS"] = "CURRENCY_EFFECT_ON_DEBTS";
    BOOKKEEPING_ACCOUNT_CLASS["CURRENCY_RATE_RESULT_ON_SHORT_TERM_ITEMS"] = "CURRENCY_RATE_RESULT_ON_SHORT_TERM_ITEMS";
    BOOKKEEPING_ACCOUNT_CLASS["CUSTOMER_ADVANCES"] = "CUSTOMER_ADVANCES";
    BOOKKEEPING_ACCOUNT_CLASS["DEBT_OBSERVATIONAL"] = "DEBT_OBSERVATIONAL";
    BOOKKEEPING_ACCOUNT_CLASS["DEBT_TO_CREDIT_INSTITUTIONS"] = "DEBT_TO_CREDIT_INSTITUTIONS";
    BOOKKEEPING_ACCOUNT_CLASS["DEPRECIATIONS_AND_DEVALUATIONS_OF_FIXED_ASSETS"] = "DEPRECIATIONS_AND_DEVALUATIONS_OF_FIXED_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["DEPRECIATIONS_AND_DEVALUATIONS_OF_MACHINES_EQUIPMENT_AND_IMMATERIALS"] = "DEPRECIATIONS_AND_DEVALUATIONS_OF_MACHINES_EQUIPMENT_AND_IMMATERIALS";
    BOOKKEEPING_ACCOUNT_CLASS["DEPRECIATIONS_ON_BUILDINGS_AND_LAND_IMPROVEMENTS"] = "DEPRECIATIONS_ON_BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["DEPRECIATIONS_ON_IMMATERIAL_ASSETS"] = "DEPRECIATIONS_ON_IMMATERIAL_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["DEPRECIATIONS_ON_MACHINES_AND_EQUIPMENT"] = "DEPRECIATIONS_ON_MACHINES_AND_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_ACCOUNTS_RECEIVABLES"] = "DEVALUATIONS_OF_ACCOUNTS_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_BUILDINGS_AND_LAND"] = "DEVALUATIONS_OF_BUILDINGS_AND_LAND";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_FINANCIAL_INSTRUMENTS"] = "DEVALUATIONS_OF_FINANCIAL_INSTRUMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_IMMATERIAL_ASSETS_MACHINES_AND_EQUPMENT"] = "DEVALUATIONS_OF_IMMATERIAL_ASSETS_MACHINES_AND_EQUPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_MACHINES_AND_EQUIPMENT"] = "DEVALUATIONS_OF_MACHINES_AND_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["DEVALUATIONS_OF_SHORT_TERM_INVESTMENTS"] = "DEVALUATIONS_OF_SHORT_TERM_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["DIRECTORS_FEES"] = "DIRECTORS_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["DISCOUNTS_REBATES_ETC"] = "DISCOUNTS_REBATES_ETC";
    BOOKKEEPING_ACCOUNT_CLASS["DIVIDENDS"] = "DIVIDENDS";
    BOOKKEEPING_ACCOUNT_CLASS["DIVIDENDS_FROM_OTHER_COMPANIES"] = "DIVIDENDS_FROM_OTHER_COMPANIES";
    BOOKKEEPING_ACCOUNT_CLASS["DIVIDENDS_ON_SHORT_TERM_INVESTMENTS"] = "DIVIDENDS_ON_SHORT_TERM_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["DUES_TO_BUSINESS_ORGS"] = "DUES_TO_BUSINESS_ORGS";
    BOOKKEEPING_ACCOUNT_CLASS["EDUCATION"] = "EDUCATION";
    BOOKKEEPING_ACCOUNT_CLASS["EMPLOYEES"] = "EMPLOYEES";
    BOOKKEEPING_ACCOUNT_CLASS["EMPLOYEE_SOCIALFEES"] = "EMPLOYEE_SOCIALFEES";
    BOOKKEEPING_ACCOUNT_CLASS["EMPLOYEE_TAXES"] = "EMPLOYEE_TAXES";
    BOOKKEEPING_ACCOUNT_CLASS["ENERGY_COSTS"] = "ENERGY_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["EQUALISATION_ACCOUNT"] = "EQUALISATION_ACCOUNT";
    BOOKKEEPING_ACCOUNT_CLASS["EQUITY"] = "EQUITY";
    BOOKKEEPING_ACCOUNT_CLASS["EXCHANGE_RATE_GAINS"] = "EXCHANGE_RATE_GAINS";
    BOOKKEEPING_ACCOUNT_CLASS["EXCHANGE_RATE_LOSSES"] = "EXCHANGE_RATE_LOSSES";
    BOOKKEEPING_ACCOUNT_CLASS["EXPANSION_FUND"] = "EXPANSION_FUND";
    BOOKKEEPING_ACCOUNT_CLASS["FEES_ON_BENEFITS"] = "FEES_ON_BENEFITS";
    BOOKKEEPING_ACCOUNT_CLASS["FEES_ON_SALARIES_ALLOWANCES"] = "FEES_ON_SALARIES_ALLOWANCES";
    BOOKKEEPING_ACCOUNT_CLASS["FEES_ON_VACATION_PAY_AND_SALARY_DEBTS"] = "FEES_ON_VACATION_PAY_AND_SALARY_DEBTS";
    BOOKKEEPING_ACCOUNT_CLASS["FEES_RETIRED_GROUP_1"] = "FEES_RETIRED_GROUP_1";
    BOOKKEEPING_ACCOUNT_CLASS["FEES_RETIRED_GROUP_2"] = "FEES_RETIRED_GROUP_2";
    BOOKKEEPING_ACCOUNT_CLASS["FINAL_RESULT"] = "FINAL_RESULT";
    BOOKKEEPING_ACCOUNT_CLASS["FIXED_ASSET_RENT"] = "FIXED_ASSET_RENT";
    BOOKKEEPING_ACCOUNT_CLASS["FREEHOLD_LAND_NON_DEPRECIABLE"] = "FREEHOLD_LAND_NON_DEPRECIABLE";
    BOOKKEEPING_ACCOUNT_CLASS["FREIGHT_AND_TRANSPORTS"] = "FREIGHT_AND_TRANSPORTS";
    BOOKKEEPING_ACCOUNT_CLASS["FUEL_COSTS_VEHICLES"] = "FUEL_COSTS_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["GOODS_MATERIALS_AND_SERVICES"] = "GOODS_MATERIALS_AND_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["GROUP_INSURANCE_PREMIUMS"] = "GROUP_INSURANCE_PREMIUMS";
    BOOKKEEPING_ACCOUNT_CLASS["HEALTHCARE"] = "HEALTHCARE";
    BOOKKEEPING_ACCOUNT_CLASS["HEALTHCARE_NON_DEDUCTIBLE"] = "HEALTHCARE_NON_DEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["IMMATERIAL_ASSETS"] = "IMMATERIAL_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["IMMATERIAL_ASSETS_DEPRECIATIONS"] = "IMMATERIAL_ASSETS_DEPRECIATIONS";
    BOOKKEEPING_ACCOUNT_CLASS["INSURANCE_AND_TAX_VEHICLES"] = "INSURANCE_AND_TAX_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["INSURANCE_FUND"] = "INSURANCE_FUND";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_PAID_LONG_TERM_DEBT"] = "INTEREST_PAID_LONG_TERM_DEBT";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_PAID_ON_ACCOUNTS_PAYABLE"] = "INTEREST_PAID_ON_ACCOUNTS_PAYABLE";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_PAID_ON_WORKING_CAPITAL"] = "INTEREST_PAID_ON_WORKING_CAPITAL";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_PAID_SHORT_TERM_DEBT"] = "INTEREST_PAID_SHORT_TERM_DEBT";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_RATES_AND_DIVIDENDS"] = "INTEREST_RATES_AND_DIVIDENDS";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_RATES_PAID"] = "INTEREST_RATES_PAID";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_RATES_PAYABLES"] = "INTEREST_RATES_PAYABLES";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_RECEIVED_FROM_FINANCIAL_INSTRUMENTS"] = "INTEREST_RECEIVED_FROM_FINANCIAL_INSTRUMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["INTEREST_TAX_FREE"] = "INTEREST_TAX_FREE";
    BOOKKEEPING_ACCOUNT_CLASS["INTERNAL_REPRESENTATION"] = "INTERNAL_REPRESENTATION";
    BOOKKEEPING_ACCOUNT_CLASS["INTERNAL_REPRESENTATION_NON_DEDUCTIBLE"] = "INTERNAL_REPRESENTATION_NON_DEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["INTERNAL_REPRESENTATION_DEDUCTIBLE"] = "INTERNAL_REPRESENTATION_DEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY"] = "INVENTORY";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY_AND_TOOLS"] = "INVENTORY_AND_TOOLS";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY_FINISHED_PRODUCTS"] = "INVENTORY_FINISHED_PRODUCTS";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY_RAW_MATERIALS"] = "INVENTORY_RAW_MATERIALS";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY_TRADE_GOODS"] = "INVENTORY_TRADE_GOODS";
    BOOKKEEPING_ACCOUNT_CLASS["INVENTORY_WORK_IN_PROGRESS"] = "INVENTORY_WORK_IN_PROGRESS";
    BOOKKEEPING_ACCOUNT_CLASS["INVOICED_COSTS"] = "INVOICED_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["IT_SERVICES"] = "IT_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["LABOR_MARKET_INSURANCE_POLICIES"] = "LABOR_MARKET_INSURANCE_POLICIES";
    BOOKKEEPING_ACCOUNT_CLASS["LAND_IMPROVEMENTS"] = "LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["LEASING_VEHICLES"] = "LEASING_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["LONGTERM_RECEIVABLES"] = "LONGTERM_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["LONG_TERM_DEBT_TO_CREDIT_INSTITUTIONS"] = "LONG_TERM_DEBT_TO_CREDIT_INSTITUTIONS";
    BOOKKEEPING_ACCOUNT_CLASS["LONG_TERM_DEBT_TO_RELATED_PARTIES"] = "LONG_TERM_DEBT_TO_RELATED_PARTIES";
    BOOKKEEPING_ACCOUNT_CLASS["LOSSES_ON_ACCOUNT_RECEIVABLES"] = "LOSSES_ON_ACCOUNT_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["LOSS_ON_SALE_OF_FIXED_ASSETS"] = "LOSS_ON_SALE_OF_FIXED_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["MACHINES_AND_OTHER_EQUIPMENT"] = "MACHINES_AND_OTHER_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["MEMBERSHIP_DUES"] = "MEMBERSHIP_DUES";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_COMPENSATION_BUILDINGS_AND_LAND_IMPROVEMENTS"] = "NEW_COMPENSATION_BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_COMPENSATION_CARS_AND_OTHER_VEHICLES"] = "NEW_COMPENSATION_CARS_AND_OTHER_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_COMPENSATION_FOR_MACHINES_AND_OTHER_EQUIPMENT"] = "NEW_COMPENSATION_FOR_MACHINES_AND_OTHER_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_DEPRECIATIONS_BUILDINGS_AND_LAND_IMPROVEMENTS"] = "NEW_DEPRECIATIONS_BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_DEPRECIATIONS_CARS_AND_OTHER_VEHICLES"] = "NEW_DEPRECIATIONS_CARS_AND_OTHER_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_DEPRECIATIONS_ON_MACHINES_AND_EQUIPMENT"] = "NEW_DEPRECIATIONS_ON_MACHINES_AND_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_PURCHASES_BUILDINGS_AND_LAND_IMPROVEMENTS"] = "NEW_PURCHASES_BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_PURCHASES_CARS_AND_OTHER_VEHICLES"] = "NEW_PURCHASES_CARS_AND_OTHER_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_PURCHASES_OF_MACHINES_AND"] = "NEW_PURCHASES_OF_MACHINES_AND";
    BOOKKEEPING_ACCOUNT_CLASS["NEW_PURCHASES_OF_MACHINES_AND_OTHER_EQUIPMENT"] = "NEW_PURCHASES_OF_MACHINES_AND_OTHER_EQUIPMENT";
    BOOKKEEPING_ACCOUNT_CLASS["NOMINAL_MILAGE_SUBSIDY_PERSONAL_VEHICLE"] = "NOMINAL_MILAGE_SUBSIDY_PERSONAL_VEHICLE";
    BOOKKEEPING_ACCOUNT_CLASS["OFFICE_COSTS"] = "OFFICE_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OFFICE_SUPPLIES"] = "OFFICE_SUPPLIES";
    BOOKKEEPING_ACCOUNT_CLASS["ONGOING_NEW_DEVELOPMENT_AND_ADVANCES_FOR_BUILDINGS_AND_LAND"] = "ONGOING_NEW_DEVELOPMENT_AND_ADVANCES_FOR_BUILDINGS_AND_LAND";
    BOOKKEEPING_ACCOUNT_CLASS["ONGOING_WORK"] = "ONGOING_WORK";
    BOOKKEEPING_ACCOUNT_CLASS["OPPORTUNISTIC_INCOME"] = "OPPORTUNISTIC_INCOME";
    BOOKKEEPING_ACCOUNT_CLASS["ORGANIZATIONAL_DUES"] = "ORGANIZATIONAL_DUES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_ACCRUED_COSTS_AND_PREPAIDS"] = "OTHER_ACCRUED_COSTS_AND_PREPAIDS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_ALLOWANCES_AND_BENEFITS"] = "OTHER_ALLOWANCES_AND_BENEFITS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_CAR_COSTS"] = "OTHER_CAR_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_COSTS"] = "OTHER_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_COSTS_OF_DOING_BUSINESS"] = "OTHER_COSTS_OF_DOING_BUSINESS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_DEBTS"] = "OTHER_DEBTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_EMPLOYEE_COSTS"] = "OTHER_EMPLOYEE_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_EXTERNAL_COSTS"] = "OTHER_EXTERNAL_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_EXTERNAL_COSTS_NONDEDUCTIBLE"] = "OTHER_EXTERNAL_COSTS_NONDEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_EXTERNAL_SERVICES"] = "OTHER_EXTERNAL_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_FINANCIAL_REVENUE"] = "OTHER_FINANCIAL_REVENUE";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_FIXED_ASSETS"] = "OTHER_FIXED_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_INCOME"] = "OTHER_INCOME";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_INVENTORY_ASSETS"] = "OTHER_INVENTORY_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_LEGALLY_REQUIRED_FEES"] = "OTHER_LEGALLY_REQUIRED_FEES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_LIABILITIES"] = "OTHER_LIABILITIES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_LOANS"] = "OTHER_LOANS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_LONG_TERM_DEBT"] = "OTHER_LONG_TERM_DEBT";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_MATERIAL_ASSETS"] = "OTHER_MATERIAL_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_PENSION_COSTS"] = "OTHER_PENSION_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_PREPAID_COSTS_AND_ACCRUED_INCOME"] = "OTHER_PREPAID_COSTS_AND_ACCRUED_INCOME";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_PROVISIONS"] = "OTHER_PROVISIONS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_RECEIVABLES"] = "OTHER_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_RISK_RELATED_COSTS"] = "OTHER_RISK_RELATED_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SALARY_DEDUCTIONS"] = "OTHER_SALARY_DEDUCTIONS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_DEBT"] = "OTHER_SHORT_TERM_DEBT";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_DEBT_BANK_ADVANCES"] = "OTHER_SHORT_TERM_DEBT_BANK_ADVANCES";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_DEBT_TO_BANKS_VENDORS_ETC"] = "OTHER_SHORT_TERM_DEBT_TO_BANKS_VENDORS_ETC";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_DEBT_UNDEFINED"] = "OTHER_SHORT_TERM_DEBT_UNDEFINED";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_INVESTMENTS"] = "OTHER_SHORT_TERM_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["OTHER_SHORT_TERM_RECEIVABLES"] = "OTHER_SHORT_TERM_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_ACCRUED_TAX_LIABILITIES"] = "OWNER_ACCRUED_TAX_LIABILITIES";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_DEPOSITS"] = "OWNER_DEPOSITS";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_WITHDRAWALS_BENEFITS"] = "OWNER_WITHDRAWALS_BENEFITS";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_WITHDRAWALS_CASH"] = "OWNER_WITHDRAWALS_CASH";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_WITHDRAWALS_GOODS"] = "OWNER_WITHDRAWALS_GOODS";
    BOOKKEEPING_ACCOUNT_CLASS["OWNER_YEARLY_RESULT"] = "OWNER_YEARLY_RESULT";
    BOOKKEEPING_ACCOUNT_CLASS["PENSION_INSURANCE_PREMIUMS"] = "PENSION_INSURANCE_PREMIUMS";
    BOOKKEEPING_ACCOUNT_CLASS["PER_DIEM_ABROAD"] = "PER_DIEM_ABROAD";
    BOOKKEEPING_ACCOUNT_CLASS["PER_DIEM_LOCAL"] = "PER_DIEM_LOCAL";
    BOOKKEEPING_ACCOUNT_CLASS["PER_DIEM_TAX_EXEMPT_ABROAD"] = "PER_DIEM_TAX_EXEMPT_ABROAD";
    BOOKKEEPING_ACCOUNT_CLASS["PER_DIEM_TAX_EXEMPT_LOCAL"] = "PER_DIEM_TAX_EXEMPT_LOCAL";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_1"] = "PERIODISED_RESERVE_1";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_2"] = "PERIODISED_RESERVE_2";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_3"] = "PERIODISED_RESERVE_3";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_4"] = "PERIODISED_RESERVE_4";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_5"] = "PERIODISED_RESERVE_5";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_6"] = "PERIODISED_RESERVE_6";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_7"] = "PERIODISED_RESERVE_7";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_3_TAXATION"] = "PERIODISED_RESERVE_3_TAXATION";
    BOOKKEEPING_ACCOUNT_CLASS["PERIODISED_RESERVE_4_TAXATION"] = "PERIODISED_RESERVE_4_TAXATION";
    BOOKKEEPING_ACCOUNT_CLASS["POSTAL_SERVICES"] = "POSTAL_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_FEES_AND_PREMIUMS"] = "PREPAID_FEES_AND_PREMIUMS";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_GOODS_AND_SERVICES"] = "PREPAID_GOODS_AND_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_INSURANCE_PREMIUMS"] = "PREPAID_INSURANCE_PREMIUMS";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_INTEREST"] = "PREPAID_INTEREST";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_LEASING_SHORT_TERM"] = "PREPAID_LEASING_SHORT_TERM";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_RENTAL_COSTS"] = "PREPAID_RENTAL_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["PREPAID_REVENUE"] = "PREPAID_REVENUE";
    BOOKKEEPING_ACCOUNT_CLASS["PROFITS_ON_SALES_OF_IMMATERIAL_OR_MATERIAL_ASSETS"] = "PROFITS_ON_SALES_OF_IMMATERIAL_OR_MATERIAL_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["PROVISIONS_FOR_EXPANSIONFUND"] = "PROVISIONS_FOR_EXPANSIONFUND";
    BOOKKEEPING_ACCOUNT_CLASS["PROVISIONS_FOR_GUARANTEES"] = "PROVISIONS_FOR_GUARANTEES";
    BOOKKEEPING_ACCOUNT_CLASS["PROVISIONS_FOR_PENSIONS"] = "PROVISIONS_FOR_PENSIONS";
    BOOKKEEPING_ACCOUNT_CLASS["PURCHASES_GOODS_SERVICES"] = "PURCHASES_GOODS_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["READING_MATERIALS"] = "READING_MATERIALS";
    BOOKKEEPING_ACCOUNT_CLASS["REAL_ESTATE_COSTS"] = "REAL_ESTATE_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["REDUCTIONS_IN_PRICES"] = "REDUCTIONS_IN_PRICES";
    BOOKKEEPING_ACCOUNT_CLASS["RELIEF_FUNDS_BUILDINGS_AND_LAND_IMPROVEMENTS"] = "RELIEF_FUNDS_BUILDINGS_AND_LAND_IMPROVEMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["RELIEF_FUNDS_OTHER_FIXED_ASSETS"] = "RELIEF_FUNDS_OTHER_FIXED_ASSETS";
    BOOKKEEPING_ACCOUNT_CLASS["RENTAL_PROPERTIES"] = "RENTAL_PROPERTIES";
    BOOKKEEPING_ACCOUNT_CLASS["REPAIRS_AND_MAINTENANCE"] = "REPAIRS_AND_MAINTENANCE";
    BOOKKEEPING_ACCOUNT_CLASS["REPAIRS_AND_MAINTENANCE_VEHICLES"] = "REPAIRS_AND_MAINTENANCE_VEHICLES";
    BOOKKEEPING_ACCOUNT_CLASS["REPRESENTATION"] = "REPRESENTATION";
    BOOKKEEPING_ACCOUNT_CLASS["REPRESENTATION_DEDUCTIBLE"] = "REPRESENTATION_DEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["REPRESENTATION_NONDEDUCTIBLE"] = "REPRESENTATION_NONDEDUCTIBLE";
    BOOKKEEPING_ACCOUNT_CLASS["RESERVED_FUNDS"] = "RESERVED_FUNDS";
    BOOKKEEPING_ACCOUNT_CLASS["RESTING_VAT_RECEIVABLES"] = "RESTING_VAT_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["RESULT"] = "RESULT";
    BOOKKEEPING_ACCOUNT_CLASS["RESULT_OF_SALES_OF_FINANCIAL_INSTRUMENTS"] = "RESULT_OF_SALES_OF_FINANCIAL_INSTRUMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["RESULT_OF_SALES_OF_SHORT_TERM_INVESTMENTS"] = "RESULT_OF_SALES_OF_SHORT_TERM_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["REVENUE_VAT_EXEMPT"] = "REVENUE_VAT_EXEMPT";
    BOOKKEEPING_ACCOUNT_CLASS["ROUNDING_ERRORS"] = "ROUNDING_ERRORS";
    BOOKKEEPING_ACCOUNT_CLASS["SALARIES"] = "SALARIES";
    BOOKKEEPING_ACCOUNT_CLASS["SALARIES_COLLECTIVE"] = "SALARIES_COLLECTIVE";
    BOOKKEEPING_ACCOUNT_CLASS["SALES"] = "SALES";
    BOOKKEEPING_ACCOUNT_CLASS["SALES_AND_OTHER_REVENUE_WITH_VAT"] = "SALES_AND_OTHER_REVENUE_WITH_VAT";
    BOOKKEEPING_ACCOUNT_CLASS["SALES_GOODS_SERVICES"] = "SALES_GOODS_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["SHARES"] = "SHARES";
    BOOKKEEPING_ACCOUNT_CLASS["SHARE_CAPITAL"] = "SHARE_CAPITAL";
    BOOKKEEPING_ACCOUNT_CLASS["SHORT_TERM_DEBT_TO_CREDIT_INSTITUTIONS"] = "SHORT_TERM_DEBT_TO_CREDIT_INSTITUTIONS";
    BOOKKEEPING_ACCOUNT_CLASS["SHORT_TERM_DEBT_TO_EMPLOYEES"] = "SHORT_TERM_DEBT_TO_EMPLOYEES";
    BOOKKEEPING_ACCOUNT_CLASS["SHORT_TERM_EMPLOYEE_RECEIVABLES"] = "SHORT_TERM_EMPLOYEE_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["SHORT_TERM_LOAN_DEBT"] = "SHORT_TERM_LOAN_DEBT";
    BOOKKEEPING_ACCOUNT_CLASS["SOCIAL_FEES_COSTS"] = "SOCIAL_FEES_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["SOFTWARE"] = "SOFTWARE";
    BOOKKEEPING_ACCOUNT_CLASS["STOCK_AND_SECURITIES_IN_LISTED_COMPANIES"] = "STOCK_AND_SECURITIES_IN_LISTED_COMPANIES";
    BOOKKEEPING_ACCOUNT_CLASS["STOCK_AND_SECURITIES_IN_OTHER_COMPANIES"] = "STOCK_AND_SECURITIES_IN_OTHER_COMPANIES";
    BOOKKEEPING_ACCOUNT_CLASS["SUBCONTRACTORS"] = "SUBCONTRACTORS";
    BOOKKEEPING_ACCOUNT_CLASS["SUBSIDIES_GRANTS_ETC"] = "SUBSIDIES_GRANTS_ETC";
    BOOKKEEPING_ACCOUNT_CLASS["TAXES_APPLIED_TO_RESULT"] = "TAXES_APPLIED_TO_RESULT";
    BOOKKEEPING_ACCOUNT_CLASS["TAX_ACCOUNT"] = "TAX_ACCOUNT";
    BOOKKEEPING_ACCOUNT_CLASS["TAX_ALLOCATION_RESERVE"] = "TAX_ALLOCATION_RESERVE";
    BOOKKEEPING_ACCOUNT_CLASS["TAX_LIABILITIES"] = "TAX_LIABILITIES";
    BOOKKEEPING_ACCOUNT_CLASS["TAX_RECEIVABLES"] = "TAX_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["TELECOM"] = "TELECOM";
    BOOKKEEPING_ACCOUNT_CLASS["TELECOM_AND_POSTAL_SERVICES"] = "TELECOM_AND_POSTAL_SERVICES";
    BOOKKEEPING_ACCOUNT_CLASS["TEMPORARY_STAFF"] = "TEMPORARY_STAFF";
    BOOKKEEPING_ACCOUNT_CLASS["TICKETS"] = "TICKETS";
    BOOKKEEPING_ACCOUNT_CLASS["TRANSFER_FROM_TAX_ALLOCATION_RESERVE"] = "TRANSFER_FROM_TAX_ALLOCATION_RESERVE";
    BOOKKEEPING_ACCOUNT_CLASS["TRANSFER_TO_TAX_ALLOCATION_RESERVE"] = "TRANSFER_TO_TAX_ALLOCATION_RESERVE";
    BOOKKEEPING_ACCOUNT_CLASS["TRAVEL"] = "TRAVEL";
    BOOKKEEPING_ACCOUNT_CLASS["TRUCK_COSTS"] = "TRUCK_COSTS";
    BOOKKEEPING_ACCOUNT_CLASS["UNREALIZED_EXCHANGE_RATE_EFFECTS_ON_PAYABLES_AND_DEBTS"] = "UNREALIZED_EXCHANGE_RATE_EFFECTS_ON_PAYABLES_AND_DEBTS";
    BOOKKEEPING_ACCOUNT_CLASS["UNREALIZED_EXCHANGE_RATE_EFFECTS_ON_RECEIVABLES_AND_INVESTMENTS"] = "UNREALIZED_EXCHANGE_RATE_EFFECTS_ON_RECEIVABLES_AND_INVESTMENTS";
    BOOKKEEPING_ACCOUNT_CLASS["UNRESTRICTED_EQUITY"] = "UNRESTRICTED_EQUITY";
    BOOKKEEPING_ACCOUNT_CLASS["VACATION_PAY_DEBT_CHANGE"] = "VACATION_PAY_DEBT_CHANGE";
    BOOKKEEPING_ACCOUNT_CLASS["VACATION_PAY_DEBT_CHANGE_COLLECTIVE"] = "VACATION_PAY_DEBT_CHANGE_COLLECTIVE";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_ACCOUNT"] = "VAT_ACCOUNT";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_PAYABLES"] = "VAT_PAYABLES";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_PURCHASE_ABROAD"] = "VAT_PURCHASE_ABROAD";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_REVERSE_CHARGE_06"] = "VAT_REVERSE_CHARGE_06";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_REVERSE_CHARGE_12"] = "VAT_REVERSE_CHARGE_12";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_REVERSE_CHARGE_25"] = "VAT_REVERSE_CHARGE_25";
    BOOKKEEPING_ACCOUNT_CLASS["VAT_RECEIVABLES"] = "VAT_RECEIVABLES";
    BOOKKEEPING_ACCOUNT_CLASS["YEARLY_RESULT"] = "YEARLY_RESULT";
})(BOOKKEEPING_ACCOUNT_CLASS || (BOOKKEEPING_ACCOUNT_CLASS = {}));
var BOOKKEEPING_ACCOUNT_TYPE;
(function (BOOKKEEPING_ACCOUNT_TYPE) {
    BOOKKEEPING_ACCOUNT_TYPE["ASSETS"] = "ASSETS";
    BOOKKEEPING_ACCOUNT_TYPE["COSTS"] = "COSTS";
    BOOKKEEPING_ACCOUNT_TYPE["DEBTS"] = "DEBTS";
    BOOKKEEPING_ACCOUNT_TYPE["DEPRECIATIONS"] = "DEPRECIATIONS";
    BOOKKEEPING_ACCOUNT_TYPE["EQUITY"] = "EQUITY";
    BOOKKEEPING_ACCOUNT_TYPE["FINANCIALS"] = "FINANCIALS";
    BOOKKEEPING_ACCOUNT_TYPE["FIXED_ASSETS"] = "FIXED_ASSETS";
    BOOKKEEPING_ACCOUNT_TYPE["NOTES"] = "NOTES";
    BOOKKEEPING_ACCOUNT_TYPE["OWN_CAPITAL_AND_DEBTS"] = "OWN_CAPITAL_AND_DEBTS";
    BOOKKEEPING_ACCOUNT_TYPE["REVENUES"] = "REVENUES";
    BOOKKEEPING_ACCOUNT_TYPE["WORKING_CAPITAL"] = "WORKING_CAPITAL";
})(BOOKKEEPING_ACCOUNT_TYPE || (BOOKKEEPING_ACCOUNT_TYPE = {}));
class BookkeepingAccount extends BaseModel {
}
__decorate$14([
    Property(),
    __metadata$14("design:type", String)
], BookkeepingAccount.prototype, "accountType", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", String)
], BookkeepingAccount.prototype, "accountClass", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", Boolean)
], BookkeepingAccount.prototype, "advanced", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", String)
], BookkeepingAccount.prototype, "description", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", String)
], BookkeepingAccount.prototype, "identifier", void 0);
class BookkeepingAccountListResponse extends BaseModel {
}
__decorate$14([
    Property({ type: BookkeepingAccount }),
    __metadata$14("design:type", Array)
], BookkeepingAccountListResponse.prototype, "data", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", Number)
], BookkeepingAccountListResponse.prototype, "length", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", Number)
], BookkeepingAccountListResponse.prototype, "offset", void 0);
__decorate$14([
    Property(),
    __metadata$14("design:type", Number)
], BookkeepingAccountListResponse.prototype, "total", void 0);

var __decorate$13 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$13 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class LedgerEntry extends BaseModel {
}
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerEntry.prototype, "accountTotal", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerEntry.prototype, "amount", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerEntry.prototype, "created", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerEntry.prototype, "description", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerEntry.prototype, "direction", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerEntry.prototype, "number", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerEntry.prototype, "series", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Reference)
], LedgerEntry.prototype, "reference", void 0);
class LedgerAccount extends BaseModel {
}
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerAccount.prototype, "accountClass", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerAccount.prototype, "accountType", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "closingBalance", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerAccount.prototype, "description", void 0);
__decorate$13([
    Property({ type: LedgerEntry }),
    __metadata$13("design:type", Array)
], LedgerAccount.prototype, "entries", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], LedgerAccount.prototype, "identifier", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "openingBalance", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "openingTotal", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "runningTotal", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "totalCredit", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Amount)
], LedgerAccount.prototype, "totalDebit", void 0);
class Ledger extends BaseModel {
}
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], Ledger.prototype, "companyId", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], Ledger.prototype, "endDate", void 0);
__decorate$13([
    Property({ type: LedgerAccount }),
    __metadata$13("design:type", Array)
], Ledger.prototype, "ledgerAccounts", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], Ledger.prototype, "startDate", void 0);
class ManualTransactionRequest extends BaseModel {
}
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], ManualTransactionRequest.prototype, "assetId", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], ManualTransactionRequest.prototype, "bookDate", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], ManualTransactionRequest.prototype, "description", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], ManualTransactionRequest.prototype, "supportStaffId", void 0);
__decorate$13([
    Property({ type: BookkeepingHint }),
    __metadata$13("design:type", Array)
], ManualTransactionRequest.prototype, "hints", void 0);

var __decorate$12 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$12 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var COMPANY_FISCAL_YEAR_LENGTH;
(function (COMPANY_FISCAL_YEAR_LENGTH) {
    COMPANY_FISCAL_YEAR_LENGTH["BROKEN"] = "BROKEN";
    COMPANY_FISCAL_YEAR_LENGTH["CUSTOM"] = "CUSTOM";
    COMPANY_FISCAL_YEAR_LENGTH["EXTENDED"] = "EXTENDED";
    COMPANY_FISCAL_YEAR_LENGTH["SHORTENED"] = "SHORTENED";
    COMPANY_FISCAL_YEAR_LENGTH["STANDARD"] = "STANDARD";
})(COMPANY_FISCAL_YEAR_LENGTH || (COMPANY_FISCAL_YEAR_LENGTH = {}));
var COMPANY_FISCAL_ASSET_TYPE;
(function (COMPANY_FISCAL_ASSET_TYPE) {
    COMPANY_FISCAL_ASSET_TYPE["ANNUAL_REPORT"] = "ANNUAL_REPORT";
    COMPANY_FISCAL_ASSET_TYPE["EMPLOYER_REPORT"] = "EMPLOYER_REPORT";
    COMPANY_FISCAL_ASSET_TYPE["PERIODICAL_STATEMENT"] = "PERIODICAL_STATEMENT";
    COMPANY_FISCAL_ASSET_TYPE["SIE_FILE"] = "SIE_FILE";
    COMPANY_FISCAL_ASSET_TYPE["TAXATION_CHANGE"] = "TAXATION_CHANGE";
    COMPANY_FISCAL_ASSET_TYPE["TAXATION_DECISION"] = "TAXATION_DECISION";
    COMPANY_FISCAL_ASSET_TYPE["TAX_RETURN"] = "TAX_RETURN";
    COMPANY_FISCAL_ASSET_TYPE["VAT_REPORT"] = "VAT_REPORT";
    COMPANY_FISCAL_ASSET_TYPE["YEARLY_STATEMENT"] = "YEARLY_STATEMENT";
    COMPANY_FISCAL_ASSET_TYPE["OTHER"] = "OTHER";
})(COMPANY_FISCAL_ASSET_TYPE || (COMPANY_FISCAL_ASSET_TYPE = {}));
var COMPANY_PERIOD_TYPE;
(function (COMPANY_PERIOD_TYPE) {
    COMPANY_PERIOD_TYPE["COMPANY_TAX"] = "COMPANY_TAX";
    COMPANY_PERIOD_TYPE["EMPLOYEE_TAXES"] = "EMPLOYEE_TAXES";
    COMPANY_PERIOD_TYPE["FISCAL_YEAR"] = "FISCAL_YEAR";
    COMPANY_PERIOD_TYPE["PERIODICAL_REPORT_OF_VAT_EXEMPT_TRADE"] = "PERIODICAL_REPORT_OF_VAT_EXEMPT_TRADE";
    COMPANY_PERIOD_TYPE["PRELIMINARY_TAXES"] = "PRELIMINARY_TAXES";
    COMPANY_PERIOD_TYPE["VAT_PAYMENTS"] = "VAT_PAYMENTS";
    COMPANY_PERIOD_TYPE["YEARLY_PROFIT_TAX"] = "YEARLY_PROFIT_TAX";
})(COMPANY_PERIOD_TYPE || (COMPANY_PERIOD_TYPE = {}));
var COMPANY_PERIOD_INTERVAL;
(function (COMPANY_PERIOD_INTERVAL) {
    COMPANY_PERIOD_INTERVAL["BIMONTHLY"] = "BIMONTHLY";
    COMPANY_PERIOD_INTERVAL["DAY"] = "DAY";
    COMPANY_PERIOD_INTERVAL["HALF_YEAR"] = "HALF_YEAR";
    COMPANY_PERIOD_INTERVAL["MONTH"] = "MONTH";
    COMPANY_PERIOD_INTERVAL["QUARTER"] = "QUARTER";
    COMPANY_PERIOD_INTERVAL["WEEK"] = "WEEK";
    COMPANY_PERIOD_INTERVAL["YEAR"] = "YEAR";
})(COMPANY_PERIOD_INTERVAL || (COMPANY_PERIOD_INTERVAL = {}));
var INITIATED_ACTIVITY;
(function (INITIATED_ACTIVITY) {
    INITIATED_ACTIVITY["FISCAL_YEAR_REOPENED"] = "FISCAL_YEAR_REOPENED";
    INITIATED_ACTIVITY["PERIOD_REOPENED"] = "PERIOD_REOPENED";
})(INITIATED_ACTIVITY || (INITIATED_ACTIVITY = {}));
class CompanyFiscalAsset extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalAsset.prototype, "assetId", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalAsset.prototype, "documentDate", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalAsset.prototype, "fiscalAssetType", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalAsset.prototype, "resourceUrl", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalAsset.prototype, "period", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Number)
], CompanyFiscalAsset.prototype, "year", void 0);
class CompanyReportingPeriod extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", Boolean)
], CompanyReportingPeriod.prototype, "active", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Amount)
], CompanyReportingPeriod.prototype, "amount", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyReportingPeriod.prototype, "end", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyReportingPeriod.prototype, "interval", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Number)
], CompanyReportingPeriod.prototype, "repeatEvery", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyReportingPeriod.prototype, "start", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyReportingPeriod.prototype, "type", void 0);
class NonConformanceReport extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], NonConformanceReport.prototype, "activityDescription", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], NonConformanceReport.prototype, "dateConcluded", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], NonConformanceReport.prototype, "dateInitiated", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], NonConformanceReport.prototype, "id", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], NonConformanceReport.prototype, "initiatedActivity", void 0);
__decorate$12([
    Property({ type: CompanyFiscalAsset }),
    __metadata$12("design:type", Array)
], NonConformanceReport.prototype, "relatedAssets", void 0);
class DatedPermit extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], DatedPermit.prototype, "applied", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], DatedPermit.prototype, "granted", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], DatedPermit.prototype, "expires", void 0);
class EmployeeDatedPermit extends DatedPermit {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], EmployeeDatedPermit.prototype, "employeeId", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], EmployeeDatedPermit.prototype, "notes", void 0);
class CompanyFiscalYear extends BaseModel {
}
__decorate$12([
    Property({ type: NonConformanceReport }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "activeNonconformanceReports", void 0);
__decorate$12([
    Property({ type: CompanyFiscalAsset }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "assets", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalYear.prototype, "closed", void 0);
__decorate$12([
    Property({ type: BookkeepingHint }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "closingBalances", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalYear.prototype, "end", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalYear.prototype, "fiscalYearLength", void 0);
__decorate$12([
    Property({ type: NonConformanceReport }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "nonConformanceReports", void 0);
__decorate$12([
    Property({ type: BookkeepingHint }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "openingBalances", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Boolean)
], CompanyFiscalYear.prototype, "readyToClose", void 0);
__decorate$12([
    Property({ type: CompanyReportingPeriod }),
    __metadata$12("design:type", Array)
], CompanyFiscalYear.prototype, "reportingPeriods", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalYear.prototype, "start", void 0);
class CompanyFiscalPeriod extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalPeriod.prototype, "type", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalPeriod.prototype, "start", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalPeriod.prototype, "interval", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Number)
], CompanyFiscalPeriod.prototype, "repeatEvery", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalPeriod.prototype, "end", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Amount)
], CompanyFiscalPeriod.prototype, "amount", void 0);
// DEPRECATED.
class CompanyFiscalData extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], CompanyFiscalData.prototype, "firstFiscalYear", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyFiscalData.prototype, "vatPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyFiscalData.prototype, "employerPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyFiscalData.prototype, "taxationPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", EmployeeDatedPermit)
], CompanyFiscalData.prototype, "firstEmployeePermit", void 0);
__decorate$12([
    Property({ type: CompanyFiscalPeriod }),
    __metadata$12("design:type", Array)
], CompanyFiscalData.prototype, "periodicals", void 0);
class CompanyTaxationData extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyTaxationData.prototype, "vatPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyTaxationData.prototype, "employerPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", DatedPermit)
], CompanyTaxationData.prototype, "taxationPermit", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", EmployeeDatedPermit)
], CompanyTaxationData.prototype, "firstEmployeePermit", void 0);
class CompanyFiscalInformation extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", CompanyFiscalYear)
], CompanyFiscalInformation.prototype, "currentFiscalYear", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", CompanyFiscalYear)
], CompanyFiscalInformation.prototype, "upcomingFiscalYear", void 0);
__decorate$12([
    Property({ type: CompanyFiscalYear }),
    __metadata$12("design:type", Array)
], CompanyFiscalInformation.prototype, "historicalFiscalYears", void 0);

var ROLE;
(function (ROLE) {
    ROLE["ADMIN"] = "ADMIN";
    ROLE["AUDITOR"] = "AUDITOR";
    ROLE["BOARD_MEMBER"] = "BOARD_MEMBER";
    ROLE["EMPLOYEE"] = "EMPLOYEE";
    ROLE["INTERNAL_ACCOUNTANT"] = "INTERNAL_ACCOUNTANT";
    ROLE["INTERNAL_AUDITOR"] = "INTERNAL_AUDITOR";
    ROLE["INVOICE_EDITOR"] = "INVOICE_EDITOR";
    ROLE["LAWYER"] = "LAWYER";
    ROLE["LEGAL_INTERCEPT"] = "LEGAL_INTERCEPT";
    ROLE["LIQUIDATOR"] = "LIQUIDATOR";
    ROLE["OWNER"] = "OWNER";
    ROLE["SHARE_HOLDER"] = "SHARE_HOLDER";
    ROLE["SUPPORT"] = "SUPPORT";
    ROLE["TAX_AUDITOR"] = "TAX_AUDITOR";
    ROLE["TRUSTEE"] = "TRUSTEE";
})(ROLE || (ROLE = {}));

var __decorate$11 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$11 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class RestrictedAsset extends BaseModel {
}
__decorate$11([
    Property({ type: ROLE }),
    __metadata$11("design:type", Array)
], RestrictedAsset.prototype, "accessAllowed", void 0);
__decorate$11([
    Property(),
    __metadata$11("design:type", String)
], RestrictedAsset.prototype, "assetDescription", void 0);
__decorate$11([
    Property(),
    __metadata$11("design:type", String)
], RestrictedAsset.prototype, "assetId", void 0);
__decorate$11([
    Property(),
    __metadata$11("design:type", String)
], RestrictedAsset.prototype, "id", void 0);
class RestrictedAssetCollection extends BaseModel {
}
__decorate$11([
    Property({ type: RestrictedAsset }),
    __metadata$11("design:type", Array)
], RestrictedAssetCollection.prototype, "restrictedAssets", void 0);

var __decorate$10 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$10 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var COMPANY_STATUS;
(function (COMPANY_STATUS) {
    COMPANY_STATUS["REGISTERING"] = "REGISTERING";
    COMPANY_STATUS["ONBOARDING"] = "ONBOARDING";
    COMPANY_STATUS["ACTIVE"] = "ACTIVE";
    COMPANY_STATUS["INACTIVE"] = "INACTIVE";
    COMPANY_STATUS["RECEIVERSHIP"] = "RECEIVERSHIP";
    COMPANY_STATUS["LIQUIDATING"] = "LIQUIDATING";
    /**
     * This status is specifically for companies deleted during
     * on-boarding or registration or during testing.
     */
    COMPANY_STATUS["CLOSED"] = "CLOSED";
})(COMPANY_STATUS || (COMPANY_STATUS = {}));
var COMPANY_TYPE;
(function (COMPANY_TYPE) {
    COMPANY_TYPE["ASSOCIATION"] = "ASSOCIATION";
    COMPANY_TYPE["COOPERATIVE"] = "COOPERATIVE";
    COMPANY_TYPE["GENERAL_PARTNERSHIP"] = "GENERAL_PARTNERSHIP";
    COMPANY_TYPE["FOUNDATION"] = "FOUNDATION";
    COMPANY_TYPE["HOME_OWNER_ASSOCIATION"] = "HOME_OWNER_ASSOCIATION";
    COMPANY_TYPE["HOME_RENTER_ASSOCIATION"] = "HOME_RENTER_ASSOCIATION";
    COMPANY_TYPE["LIMITED_COMPANY"] = "LIMITED_COMPANY";
    COMPANY_TYPE["LIMITED_PARTNERSHIP"] = "LIMITED_PARTNERSHIP";
    COMPANY_TYPE["NON_PROFIT"] = "NON_PROFIT";
    COMPANY_TYPE["PUBLIC_LIMITED_COMPANY"] = "PUBLIC_LIMITED_COMPANY";
    COMPANY_TYPE["SOLE_TRADER"] = "SOLE_TRADER";
})(COMPANY_TYPE || (COMPANY_TYPE = {}));
var COMPANY_FEATURES;
(function (COMPANY_FEATURES) {
    COMPANY_FEATURES["CARDS"] = "CARDS";
    COMPANY_FEATURES["EMPLOYEES"] = "EMPLOYEES";
    COMPANY_FEATURES["ROYALTIES"] = "ROYALTIES";
    COMPANY_FEATURES["IZETTLE"] = "IZETTLE";
    COMPANY_FEATURES["CAR_BENEFIT"] = "CAR_BENEFIT";
})(COMPANY_FEATURES || (COMPANY_FEATURES = {}));
class CompanyFeature extends BaseModel {
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyFeature.prototype, "name", void 0);
__decorate$10([
    Property({ defaultValue: false }),
    __metadata$10("design:type", Boolean)
], CompanyFeature.prototype, "enabled", void 0);
class CompanyConfiguration extends BaseModel {
    getFeature(name) {
        return this.features.filter((feature) => feature.name === name).shift();
    }
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyConfiguration.prototype, "companyId", void 0);
__decorate$10([
    Property({ type: CompanyFeature }),
    __metadata$10("design:type", Array)
], CompanyConfiguration.prototype, "features", void 0);
class CompanyInfo extends BaseModel {
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "id", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "identifier", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "name", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "managedBy", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "status", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyInfo.prototype, "type", void 0);
// The way forward. Most company data/information is stored under company.details
// This was mapped/flattened to simplify data models, but causes much confusion.
// This is an attempt to rectify this.
class CompanyData extends BaseModel {
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "name", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "identifier", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "description", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", CompanyTaxationData)
], CompanyData.prototype, "taxationData", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", CompanyFiscalInformation)
], CompanyData.prototype, "fiscalInformation", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", CompanyFiscalData)
], CompanyData.prototype, "fiscalData", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", DatedPermit)
], CompanyData.prototype, "registration", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", Address)
], CompanyData.prototype, "address", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "email", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "phone", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "website", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "country", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "vatIdentifier", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", BankAccountDetails)
], CompanyData.prototype, "mainAccount", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], CompanyData.prototype, "businessOperationCode", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", Boolean)
], CompanyData.prototype, "registeredAsEmployer", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", RestrictedAssetCollection)
], CompanyData.prototype, "restrictedAssets", void 0);
class Company extends BaseModel {
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "id", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "identifier", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "name", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "managedBy", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "status", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", CompanyFiscalData)
], Company.prototype, "fiscalData", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", CompanyData)
], Company.prototype, "details", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], Company.prototype, "type", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", DatedPermit)
], Company.prototype, "registration", void 0);
class CompanyListResponse extends BaseModel {
}
__decorate$10([
    Property({ type: Company }),
    __metadata$10("design:type", Array)
], CompanyListResponse.prototype, "data", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", Number)
], CompanyListResponse.prototype, "length", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", Number)
], CompanyListResponse.prototype, "offset", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", Number)
], CompanyListResponse.prototype, "total", void 0);

var __decorate$$ = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$$ = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatData extends BaseModel {
}
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], VatData.prototype, "period", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenuesVatNotOther", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "localDebts", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "costEU", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "costNotEU", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueEU", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueNotEU", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueVatExempt", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueVat25", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueVat12", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "revenueVat06", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "costVat25", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "costVat12", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "costVat06", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "inboundVat", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Number)
], VatData.prototype, "vatResult", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], VatData.prototype, "text", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], VatData.prototype, "orgNr", void 0);

var VAT_PERIOD_INTERVAL;
(function (VAT_PERIOD_INTERVAL) {
    VAT_PERIOD_INTERVAL["DAY"] = "DAY";
    VAT_PERIOD_INTERVAL["WEEK"] = "WEEK";
    VAT_PERIOD_INTERVAL["MONTH"] = "MONTH";
    VAT_PERIOD_INTERVAL["QUARTER"] = "QUARTER";
    VAT_PERIOD_INTERVAL["HALF_YEAR"] = "HALF_YEAR";
    VAT_PERIOD_INTERVAL["YEAR"] = "YEAR";
    VAT_PERIOD_INTERVAL["BIMONTHLY"] = "BIMONTHLY";
})(VAT_PERIOD_INTERVAL || (VAT_PERIOD_INTERVAL = {}));

var __decorate$_ = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$_ = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatIntervalRequest extends BaseModel {
}
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], VatIntervalRequest.prototype, "companyId", void 0);
__decorate$_([
    Property({ type: VAT_PERIOD_INTERVAL }),
    __metadata$_("design:type", String)
], VatIntervalRequest.prototype, "interval", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], VatIntervalRequest.prototype, "start", void 0);

var __decorate$Z = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Z = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatPayment extends BaseModel {
}
__decorate$Z([
    Property(),
    __metadata$Z("design:type", String)
], VatPayment.prototype, "companyId", void 0);
__decorate$Z([
    Property(),
    __metadata$Z("design:type", String)
], VatPayment.prototype, "vatReportId", void 0);
__decorate$Z([
    Property(),
    __metadata$Z("design:type", Amount)
], VatPayment.prototype, "amount", void 0);
__decorate$Z([
    Property(),
    __metadata$Z("design:type", Reference)
], VatPayment.prototype, "paymentReference", void 0);

var VAT_PERIOD_STATUS;
(function (VAT_PERIOD_STATUS) {
    VAT_PERIOD_STATUS["OPEN"] = "OPEN";
    VAT_PERIOD_STATUS["CLOSED"] = "CLOSED";
})(VAT_PERIOD_STATUS || (VAT_PERIOD_STATUS = {}));

var VAT_REPORT_TYPE;
(function (VAT_REPORT_TYPE) {
    VAT_REPORT_TYPE["OLD_REPORT"] = "OLD_REPORT";
    VAT_REPORT_TYPE["NEW_REPORT"] = "NEW_REPORT";
})(VAT_REPORT_TYPE || (VAT_REPORT_TYPE = {}));

var __decorate$Y = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Y = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatReport extends BaseModel {
}
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], VatReport.prototype, "reportId", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], VatReport.prototype, "companyId", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], VatReport.prototype, "period", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], VatReport.prototype, "assetId", void 0);
__decorate$Y([
    Property({ type: PAYMENT_STATUS }),
    __metadata$Y("design:type", String)
], VatReport.prototype, "paymentStatus", void 0);
__decorate$Y([
    Property({ type: VatPayment }),
    __metadata$Y("design:type", Array)
], VatReport.prototype, "payments", void 0);
__decorate$Y([
    Property({ type: VAT_REPORT_TYPE }),
    __metadata$Y("design:type", String)
], VatReport.prototype, "type", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", VatData)
], VatReport.prototype, "vatData", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", Boolean)
], VatReport.prototype, "correction", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], VatReport.prototype, "verificationId", void 0);

var __decorate$X = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$X = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatPeriod extends BaseModel {
}
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "id", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "companyId", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "name", void 0);
__decorate$X([
    Property({ type: VAT_PERIOD_INTERVAL }),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "interval", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "period", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "start", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "end", void 0);
__decorate$X([
    Property({ type: VAT_PERIOD_STATUS }),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "status", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", VatReport)
], VatPeriod.prototype, "vatReport", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], VatPeriod.prototype, "corrections", void 0);

var __decorate$W = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$W = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatPeriodListResponse extends BaseModel {
}
__decorate$W([
    Property({ type: VatPeriod }),
    __metadata$W("design:type", Array)
], VatPeriodListResponse.prototype, "vatPeriods", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", Number)
], VatPeriodListResponse.prototype, "count", void 0);

var __decorate$V = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$V = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatReportRequest extends BaseModel {
}
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], VatReportRequest.prototype, "companyId", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], VatReportRequest.prototype, "orgNr", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Boolean)
], VatReportRequest.prototype, "correction", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], VatReportRequest.prototype, "period", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenuesVatNotOther", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "localDebts", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "costEU", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "costNotEU", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueEU", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueNotEU", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueVatExempt", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueVat25", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueVat12", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "revenueVat06", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "costVat25", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "costVat12", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "costVat06", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "inboundVat", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", Number)
], VatReportRequest.prototype, "vatResult", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], VatReportRequest.prototype, "text", void 0);

var __decorate$U = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$U = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatReportsResponse extends BaseModel {
}
__decorate$U([
    Property(),
    __metadata$U("design:type", VatReport)
], VatReportsResponse.prototype, "vatReport", void 0);
__decorate$U([
    Property({ type: VatReport }),
    __metadata$U("design:type", Array)
], VatReportsResponse.prototype, "corrections", void 0);

var __decorate$T = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$T = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VatStatusRequest extends BaseModel {
}
__decorate$T([
    Property(),
    __metadata$T("design:type", String)
], VatStatusRequest.prototype, "companyId", void 0);
__decorate$T([
    Property({ type: VAT_PERIOD_STATUS }),
    __metadata$T("design:type", String)
], VatStatusRequest.prototype, "status", void 0);
__decorate$T([
    Property(),
    __metadata$T("design:type", String)
], VatStatusRequest.prototype, "period", void 0);

var __decorate$S = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$S = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BOOKKEEPING_STATUS;
(function (BOOKKEEPING_STATUS) {
    BOOKKEEPING_STATUS["CREATED"] = "CREATED";
    BOOKKEEPING_STATUS["IN_REVIEW"] = "IN_REVIEW";
    BOOKKEEPING_STATUS["APPROVED"] = "APPROVED";
    BOOKKEEPING_STATUS["BOOKED"] = "BOOKED";
    BOOKKEEPING_STATUS["REVERSED"] = "REVERSED";
    BOOKKEEPING_STATUS["REJECTED"] = "REJECTED";
    BOOKKEEPING_STATUS["DELETED"] = "DELETED";
})(BOOKKEEPING_STATUS || (BOOKKEEPING_STATUS = {}));
class BookkeepingMetadata extends BaseModel {
}
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "id", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "companyId", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "userId", void 0);
__decorate$S([
    Property({ type: COMPANY_TYPE }),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "companyType", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Reference)
], BookkeepingMetadata.prototype, "entityReference", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "created", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "modified", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "description", void 0);
__decorate$S([
    Property({ type: BookkeepingHint }),
    __metadata$S("design:type", Array)
], BookkeepingMetadata.prototype, "bookkeepingHints", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "transactionMarket", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "vatArea", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "counterPartVATRegistration", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "bookkeepingStatus", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Reference)
], BookkeepingMetadata.prototype, "parentReference", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], BookkeepingMetadata.prototype, "bookDate", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Amount)
], BookkeepingMetadata.prototype, "totalAmount", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Amount)
], BookkeepingMetadata.prototype, "totalVAT", void 0);
__decorate$S([
    Property({ type: VatAmount }),
    __metadata$S("design:type", Array)
], BookkeepingMetadata.prototype, "vatAmounts", void 0);

var __decorate$R = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$R = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class BookkeepingTransactionRow extends BaseModel {
}
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransactionRow.prototype, "rowId", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransactionRow.prototype, "account", void 0);
__decorate$R([
    Property({ type: PAYMENT_TYPE }),
    __metadata$R("design:type", String)
], BookkeepingTransactionRow.prototype, "txDirection", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", Amount)
], BookkeepingTransactionRow.prototype, "txAmount", void 0);
__decorate$R([
    Property({ type: VAT_TYPE }),
    __metadata$R("design:type", String)
], BookkeepingTransactionRow.prototype, "vatClassType", void 0);
class BookkeepingTransactionLinkedReferences extends BaseModel {
}
__decorate$R([
    Property({ type: Reference }),
    __metadata$R("design:type", Array)
], BookkeepingTransactionLinkedReferences.prototype, "VERIFICATION", void 0);
class BookkeepingTransaction extends BaseModel {
}
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "companyId", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "txId", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "corrects", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "correctedBy", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "series", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", Number)
], BookkeepingTransaction.prototype, "number", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "created", void 0);
__decorate$R([
    Property({ type: BookkeepingTransactionRow }),
    __metadata$R("design:type", Array)
], BookkeepingTransaction.prototype, "rows", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", BookkeepingTransactionLinkedReferences)
], BookkeepingTransaction.prototype, "linkedReferences", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", Reference)
], BookkeepingTransaction.prototype, "reference", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", String)
], BookkeepingTransaction.prototype, "description", void 0);
class BookkeepingTransactionListResponse extends BaseModel {
}
__decorate$R([
    Property(),
    __metadata$R("design:type", Number)
], BookkeepingTransactionListResponse.prototype, "total", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", Number)
], BookkeepingTransactionListResponse.prototype, "count", void 0);
__decorate$R([
    Property(),
    __metadata$R("design:type", Number)
], BookkeepingTransactionListResponse.prototype, "offset", void 0);
__decorate$R([
    Property({ type: BookkeepingTransaction }),
    __metadata$R("design:type", Array)
], BookkeepingTransactionListResponse.prototype, "transactions", void 0);
class CloseYearResponse extends BaseModel {
}
__decorate$R([
    Property({ type: BookkeepingTransaction }),
    __metadata$R("design:type", Array)
], CloseYearResponse.prototype, "transactions", void 0);

var __decorate$Q = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Q = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CARD_STATUS;
(function (CARD_STATUS) {
    CARD_STATUS["OK"] = "OK";
    CARD_STATUS["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    CARD_STATUS["LOST_CARD"] = "LOST_CARD";
    CARD_STATUS["STOLEN_CARD"] = "STOLEN_CARD";
    CARD_STATUS["EXPIRED_CARD"] = "EXPIRED_CARD";
    CARD_STATUS["RESTRICTED_CARD"] = "RESTRICTED_CARD";
    CARD_STATUS["SECURITY_VIOLATION"] = "SECURITY_VIOLATION";
    CARD_STATUS["CONTACT_ISSUER"] = "CONTACT_ISSUER";
    CARD_STATUS["CARD_DESTROYED"] = "CARD_DESTROYED";
    CARD_STATUS["REFUND_TO_CUSTOMER"] = "REFUND_TO_CUSTOMER";
    CARD_STATUS["CARD_VOIDED"] = "CARD_VOIDED";
})(CARD_STATUS || (CARD_STATUS = {}));
var CARD_SEND_PIN;
(function (CARD_SEND_PIN) {
    CARD_SEND_PIN["YES"] = "true";
    CARD_SEND_PIN["NO"] = "false";
})(CARD_SEND_PIN || (CARD_SEND_PIN = {}));
var BRAND;
(function (BRAND) {
    BRAND["REDFLAG"] = "REDFLAG";
    BRAND["BANCO"] = "BANCO";
    BRAND["BOKIO"] = "BOKIO";
})(BRAND || (BRAND = {}));
class CardRenewal extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardRenewal.prototype, "time", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardRenewal.prototype, "activatedDate", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], CardRenewal.prototype, "activated", void 0);
class Card extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "created", void 0);
__decorate$Q([
    Property({ type: CARD_STATUS }),
    __metadata$Q("design:type", String)
], Card.prototype, "status", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "activated", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "cardPinSent", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "cardDisplayName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "organisationDisplayName", void 0);
__decorate$Q([
    Property({ type: BRAND }),
    __metadata$Q("design:type", String)
], Card.prototype, "brand", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "publicToken", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "openForInternetPurchases", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "openForAbroadPurchases", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "allowCashWithdrawal", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], Card.prototype, "enrolled", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "custAccount", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "userId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "companyId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "cardId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "accountId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "activatedDate", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Address)
], Card.prototype, "deliveryAddress", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "phoneNumber", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "lastFourDigits", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "expirationDate", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], Card.prototype, "threeDsPartner", void 0);
__decorate$Q([
    Property({ type: CardRenewal }),
    __metadata$Q("design:type", Array)
], Card.prototype, "renewals", void 0);
class ActivationSignatureResponse extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], ActivationSignatureResponse.prototype, "payloadBase64", void 0);
class ActivationSignaturePayloadRequest extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], ActivationSignaturePayloadRequest.prototype, "lastFourDigits", void 0);
class CardNameSuggestion extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardNameSuggestion.prototype, "name", void 0);
class CardListResponse extends BaseModel {
}
__decorate$Q([
    Property({ type: Card }),
    __metadata$Q("design:type", Array)
], CardListResponse.prototype, "data", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Number)
], CardListResponse.prototype, "count", void 0);
class CardActivateRequest extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardActivateRequest.prototype, "companyId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardActivateRequest.prototype, "lastFourDigits", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardActivateRequest.prototype, "userId", void 0);
__decorate$Q([
    Property({ type: CARD_SEND_PIN }),
    __metadata$Q("design:type", String)
], CardActivateRequest.prototype, "sendPin", void 0);
class CardCreateRequest extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardCreateRequest.prototype, "companyId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], CardCreateRequest.prototype, "replacement", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardCreateRequest.prototype, "userId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardCreateRequest.prototype, "cardDisplayName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardCreateRequest.prototype, "companyDisplayName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardCreateRequest.prototype, "supportStaffId", void 0);
class CreateCardRequestV2 extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "companyId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "userId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "cardDisplayName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "companyDisplayName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "accountId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CreateCardRequestV2.prototype, "phoneNumber", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Address)
], CreateCardRequestV2.prototype, "deliveryAddress", void 0);
class CardUpdateStatusRequest extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardUpdateStatusRequest.prototype, "companyId", void 0);
__decorate$Q([
    Property({ type: CARD_STATUS }),
    __metadata$Q("design:type", String)
], CardUpdateStatusRequest.prototype, "status", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], CardUpdateStatusRequest.prototype, "userId", void 0);
class ActivateCardRequestV2 extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Signature)
], ActivateCardRequestV2.prototype, "signature", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], ActivateCardRequestV2.prototype, "mobilePhoneNumber", void 0);
class ReplaceCardRequest extends BaseModel {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Address)
], ReplaceCardRequest.prototype, "deliveryAddress", void 0);
class UpdateCardRequest extends BaseModel {
}
__decorate$Q([
    Property({ defaultValue: true }),
    __metadata$Q("design:type", Boolean)
], UpdateCardRequest.prototype, "openForInternetPurchases", void 0);
__decorate$Q([
    Property({ defaultValue: true }),
    __metadata$Q("design:type", Boolean)
], UpdateCardRequest.prototype, "openForAbroadPurchases", void 0);
__decorate$Q([
    Property({ defaultValue: false }),
    __metadata$Q("design:type", Boolean)
], UpdateCardRequest.prototype, "allowCashWithdrawal", void 0);
__decorate$Q([
    Property({ type: CARD_STATUS }),
    __metadata$Q("design:type", String)
], UpdateCardRequest.prototype, "cardStatus", void 0);

var __decorate$P = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$P = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CARD_TRANSACTION_STATUS;
(function (CARD_TRANSACTION_STATUS) {
    CARD_TRANSACTION_STATUS["BOOKED"] = "BOOKED";
    CARD_TRANSACTION_STATUS["CANCELLED"] = "CANCELLED";
    CARD_TRANSACTION_STATUS["IN_REVIEW"] = "IN_REVIEW";
    CARD_TRANSACTION_STATUS["PENDING"] = "PENDING";
    CARD_TRANSACTION_STATUS["REJECTED"] = "REJECTED";
})(CARD_TRANSACTION_STATUS || (CARD_TRANSACTION_STATUS = {}));
var CARD_TRANSACTION_RESERVATION_STATUS;
(function (CARD_TRANSACTION_RESERVATION_STATUS) {
    CARD_TRANSACTION_RESERVATION_STATUS["CANCELLED"] = "CANCELLED";
    CARD_TRANSACTION_RESERVATION_STATUS["RESERVED"] = "RESERVED";
    CARD_TRANSACTION_RESERVATION_STATUS["SETTLED"] = "SETTLED";
})(CARD_TRANSACTION_RESERVATION_STATUS || (CARD_TRANSACTION_RESERVATION_STATUS = {}));
var CARD_TRANSACTION_RESOLUTION_TYPE;
(function (CARD_TRANSACTION_RESOLUTION_TYPE) {
    CARD_TRANSACTION_RESOLUTION_TYPE["CARD_HOLDER_DEBT"] = "CARD_HOLDER_DEBT";
    CARD_TRANSACTION_RESOLUTION_TYPE["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    CARD_TRANSACTION_RESOLUTION_TYPE["SALARY_CONVERSION"] = "SALARY_CONVERSION";
})(CARD_TRANSACTION_RESOLUTION_TYPE || (CARD_TRANSACTION_RESOLUTION_TYPE = {}));
var CARD_TRANSACTION_SORT_ORDER;
(function (CARD_TRANSACTION_SORT_ORDER) {
    CARD_TRANSACTION_SORT_ORDER["DESCENDING"] = "DESCENDING";
    CARD_TRANSACTION_SORT_ORDER["ASCENDING"] = "ASCENDING";
})(CARD_TRANSACTION_SORT_ORDER || (CARD_TRANSACTION_SORT_ORDER = {}));
class CardTransactionReservation extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransactionReservation.prototype, "reservationId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransactionReservation.prototype, "status", void 0);
class CardTransactionResolution extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", Reference)
], CardTransactionResolution.prototype, "reference", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransactionResolution.prototype, "type", void 0);
class CardTransactionResolveRequest extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransactionResolveRequest.prototype, "assetId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransactionResolveRequest.prototype, "type", void 0);
class CreditReference extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CreditReference.prototype, "transactionId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CreditReference.prototype, "transactionTime", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CreditReference.prototype, "merchantName", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], CreditReference.prototype, "creditedAmount", void 0);
class CardTransaction extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], CardTransaction.prototype, "amount", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "assetId", void 0);
__decorate$P([
    Property({ type: BookkeepingHint }),
    __metadata$P("design:type", Array)
], CardTransaction.prototype, "bookkeepingHints", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "cardId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "companyId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "created", void 0);
__decorate$P([
    Property({ type: CreditReference }),
    __metadata$P("design:type", Array)
], CardTransaction.prototype, "creditedBy", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "crediting", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", DepreciationItem)
], CardTransaction.prototype, "depreciationItem", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "id", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Reference)
], CardTransaction.prototype, "integrationRef", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "merchantName", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "modified", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", CardTransactionReservation)
], CardTransaction.prototype, "reservation", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", CardTransactionResolution)
], CardTransaction.prototype, "resolution", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "resourceUrl", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "status", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], CardTransaction.prototype, "transactionAmount", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "transactionTime", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "type", void 0);
__decorate$P([
    Property({ type: VatAmount }),
    __metadata$P("design:type", Array)
], CardTransaction.prototype, "vatList", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], CardTransaction.prototype, "userId", void 0);
class CardTransactionBookkeepingRequest extends BaseModel {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", DepreciationItem)
], CardTransactionBookkeepingRequest.prototype, "depreciationItem", void 0);
__decorate$P([
    Property({ type: BookkeepingHint }),
    __metadata$P("design:type", Array)
], CardTransactionBookkeepingRequest.prototype, "bookkeepingHints", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], CardTransactionBookkeepingRequest.prototype, "totalVatAmount", void 0);
__decorate$P([
    Property({ type: VatAmount }),
    __metadata$P("design:type", Array)
], CardTransactionBookkeepingRequest.prototype, "vatList", void 0);
class CardTransactionListResponse extends BaseModel {
}
__decorate$P([
    Property({ type: CardTransaction }),
    __metadata$P("design:type", Array)
], CardTransactionListResponse.prototype, "data", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Number)
], CardTransactionListResponse.prototype, "length", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Number)
], CardTransactionListResponse.prototype, "offset", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Number)
], CardTransactionListResponse.prototype, "total", void 0);

var __decorate$O = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$O = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class ClientInfoResponse extends BaseModel {
}
__decorate$O([
    Property(),
    __metadata$O("design:type", Boolean)
], ClientInfoResponse.prototype, "newVersionAvailable", void 0);
__decorate$O([
    Property(),
    __metadata$O("design:type", String)
], ClientInfoResponse.prototype, "version", void 0);
__decorate$O([
    Property(),
    __metadata$O("design:type", Number)
], ClientInfoResponse.prototype, "build", void 0);
__decorate$O([
    Property(),
    __metadata$O("design:type", String)
], ClientInfoResponse.prototype, "name", void 0);

var __decorate$N = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$N = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var COMMENT_CONTEXT;
(function (COMMENT_CONTEXT) {
    COMMENT_CONTEXT["SUPPORT"] = "SUPPORT";
    COMMENT_CONTEXT["USERSPACE"] = "USERSPACE";
    COMMENT_CONTEXT["SYSTEM"] = "SYSTEM";
})(COMMENT_CONTEXT || (COMMENT_CONTEXT = {}));
class Content extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Content.prototype, "mimeType", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Content.prototype, "payload", void 0);
class CreateCommentRequest extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], CreateCommentRequest.prototype, "inReplyTo", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Reference)
], CreateCommentRequest.prototype, "author", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Content)
], CreateCommentRequest.prototype, "content", void 0);
__decorate$N([
    Property({ type: COMMENT_CONTEXT }),
    __metadata$N("design:type", String)
], CreateCommentRequest.prototype, "context", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Object)
], CreateCommentRequest.prototype, "metadata", void 0);
class CommentsAuthor extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", Reference)
], CommentsAuthor.prototype, "entity", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], CommentsAuthor.prototype, "name", void 0);
class Comment extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Comment.prototype, "id", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Comment.prototype, "inReplyTo", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Comment.prototype, "created", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Comment.prototype, "modified", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", CommentsAuthor)
], Comment.prototype, "author", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Content)
], Comment.prototype, "content", void 0);
__decorate$N([
    Property({ type: COMMENT_CONTEXT }),
    __metadata$N("design:type", String)
], Comment.prototype, "context", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], Comment.prototype, "tag", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Object)
], Comment.prototype, "metadata", void 0);
class CommentListResponse extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", Reference)
], CommentListResponse.prototype, "entity", void 0);
__decorate$N([
    Property({ type: Comment }),
    __metadata$N("design:type", Array)
], CommentListResponse.prototype, "data", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Number)
], CommentListResponse.prototype, "total", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Number)
], CommentListResponse.prototype, "offset", void 0);
__decorate$N([
    Property(),
    __metadata$N("design:type", Number)
], CommentListResponse.prototype, "length", void 0);
class EditCommentRequest extends BaseModel {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", Content)
], EditCommentRequest.prototype, "content", void 0);

var __decorate$M = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$M = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyActivationRequest extends BaseModel {
}
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], CompanyActivationRequest.prototype, "identifier", void 0);
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], CompanyActivationRequest.prototype, "name", void 0);

var __decorate$L = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$L = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyBaseInfoStatus extends BaseModel {
}
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfoStatus.prototype, "code", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfoStatus.prototype, "text", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfoStatus.prototype, "date", void 0);
class CompanyFunction extends BaseModel {
}
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyFunction.prototype, "code", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyFunction.prototype, "text", void 0);
class Representative extends BaseModel {
}
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], Representative.prototype, "firstName", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], Representative.prototype, "lastName", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], Representative.prototype, "identifier", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], Representative.prototype, "otherIdentifier", void 0);
__decorate$L([
    Property({ type: CompanyFunction }),
    __metadata$L("design:type", Array)
], Representative.prototype, "functions", void 0);
class CompanyBaseInfo extends BaseModel {
}
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfo.prototype, "companyIdentifier", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfo.prototype, "companyName", void 0);
__decorate$L([
    Property({ type: CompanyBaseInfoStatus }),
    __metadata$L("design:type", Array)
], CompanyBaseInfo.prototype, "status", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfo.prototype, "fiscalYearStart", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], CompanyBaseInfo.prototype, "fiscalYearEnd", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", Boolean)
], CompanyBaseInfo.prototype, "auditorsReportRequired", void 0);
__decorate$L([
    Property({ type: Representative }),
    __metadata$L("design:type", Array)
], CompanyBaseInfo.prototype, "representatives", void 0);

var __decorate$K = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$K = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CreateCompanyRequest extends BaseModel {
}
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "type", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "status", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "name", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "address", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "careOf", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "postalCode", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "postalTown", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "countryCode", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "identifier", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "vatIdentifier", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "email", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "phone", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "website", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "country", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", BankAccountDetails)
], CreateCompanyRequest.prototype, "mainAccount", void 0);
__decorate$K([
    Property({ type: String }),
    __metadata$K("design:type", String)
], CreateCompanyRequest.prototype, "businessOperationCodes", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", CompanyFiscalData)
], CreateCompanyRequest.prototype, "fiscalData", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", DatedPermit)
], CreateCompanyRequest.prototype, "registration", void 0);
class CreateCompanyFiscalYearRequest extends BaseModel {
}
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyFiscalYearRequest.prototype, "endDate", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyFiscalYearRequest.prototype, "length", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CreateCompanyFiscalYearRequest.prototype, "startDate", void 0);
class CompanyDataRequest extends BaseModel {
}
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "name", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", Address)
], CompanyDataRequest.prototype, "address", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "identifier", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "vatIdentifier", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "email", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "phone", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "website", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "country", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", BankAccountDetails)
], CompanyDataRequest.prototype, "mainAccount", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "businessOperationCode", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", CompanyFiscalData)
], CompanyDataRequest.prototype, "fiscalData", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", DatedPermit)
], CompanyDataRequest.prototype, "registration", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], CompanyDataRequest.prototype, "description", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", Boolean)
], CompanyDataRequest.prototype, "registeredAsEmployer", void 0);

var __decorate$J = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$J = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var YEAR_END_STEP;
(function (YEAR_END_STEP) {
    YEAR_END_STEP["WARMUP"] = "WARMUP";
    YEAR_END_STEP["STARTED"] = "STARTED";
    YEAR_END_STEP["CUSTOMER_DONE"] = "CUSTOMER_DONE";
    YEAR_END_STEP["WAITING_FOR_CUSTOMER_TO_SIGN"] = "WAITING_FOR_CUSTOMER_TO_SIGN";
    YEAR_END_STEP["CREATING_DOCUMENTS"] = "CREATING_DOCUMENTS";
    YEAR_END_STEP["WAITING_FOR_FINAL_SIGNATURE"] = "WAITING_FOR_FINAL_SIGNATURE";
    YEAR_END_STEP["BOOKS_CLOSED"] = "BOOKS_CLOSED";
    YEAR_END_STEP["DIVIDENDS"] = "DIVIDENDS";
    YEAR_END_STEP["SHAREHOLDER_INFORMATION"] = "SHAREHOLDER_INFORMATION";
    YEAR_END_STEP["ANNUAL_REPORT_STORY"] = "ANNUAL_REPORT_STORY";
    YEAR_END_STEP["BOARD_MEMBER_INFORMATION"] = "BOARD_MEMBER_INFORMATION";
    YEAR_END_STEP["GENERATING_ANNUAL_REPORT"] = "GENERATING_ANNUAL_REPORT";
    YEAR_END_STEP["ANNUAL_REPORT_DOCUMENTS"] = "ANNUAL_REPORT_DOCUMENTS";
    YEAR_END_STEP["SUBMITTING_ANNUAL_REPORT"] = "SUBMITTING_ANNUAL_REPORT";
    YEAR_END_STEP["WAITING_FOR_BOLAGSVERKET"] = "WAITING_FOR_BOLAGSVERKET";
    YEAR_END_STEP["ANNUAL_REPORT_DONE"] = "ANNUAL_REPORT_DONE";
    YEAR_END_STEP["EXIT"] = "EXIT";
})(YEAR_END_STEP || (YEAR_END_STEP = {}));
var FLAG_TYPE;
(function (FLAG_TYPE) {
    FLAG_TYPE["SYSTEM_FLAG"] = "SYSTEM_FLAG";
    FLAG_TYPE["USER_FLAG"] = "USER_FLAG";
    FLAG_TYPE["CLOSE_YEAR_FLAG"] = "CLOSE_YEAR_FLAG";
})(FLAG_TYPE || (FLAG_TYPE = {}));
var YEAR_END_REPORT_TYPE;
(function (YEAR_END_REPORT_TYPE) {
    YEAR_END_REPORT_TYPE["BALANCE"] = "BALANCE";
    YEAR_END_REPORT_TYPE["PROFITLOSS"] = "PROFITLOSS";
    YEAR_END_REPORT_TYPE["NE"] = "NE";
    YEAR_END_REPORT_TYPE["SIMPLIFIED_ANNUAL_ACCOUNTS"] = "SIMPLIFIED_ANNUAL_ACCOUNTS";
    YEAR_END_REPORT_TYPE["VAT"] = "VAT";
    YEAR_END_REPORT_TYPE["LEDGER"] = "LEDGER";
    YEAR_END_REPORT_TYPE["INK_2"] = "INK_2";
    YEAR_END_REPORT_TYPE["INK_2_SRU"] = "INK_2_SRU";
    YEAR_END_REPORT_TYPE["AGM_PROTOCOL"] = "AGM_PROTOCOL";
    YEAR_END_REPORT_TYPE["ANNUAL_REPORT"] = "ANNUAL_REPORT";
})(YEAR_END_REPORT_TYPE || (YEAR_END_REPORT_TYPE = {}));
var YEAR_END_REPORT_STATUS;
(function (YEAR_END_REPORT_STATUS) {
    YEAR_END_REPORT_STATUS["DRAFT"] = "DRAFT";
    YEAR_END_REPORT_STATUS["FINAL"] = "FINAL";
})(YEAR_END_REPORT_STATUS || (YEAR_END_REPORT_STATUS = {}));
var ANNUAL_REPORT_SUBMIT_STATE;
(function (ANNUAL_REPORT_SUBMIT_STATE) {
    ANNUAL_REPORT_SUBMIT_STATE["PENDING"] = "PENDING";
    ANNUAL_REPORT_SUBMIT_STATE["SUBMITTED"] = "SUBMITTED";
    ANNUAL_REPORT_SUBMIT_STATE["FAILED"] = "FAILED";
})(ANNUAL_REPORT_SUBMIT_STATE || (ANNUAL_REPORT_SUBMIT_STATE = {}));
class HelpFlag extends BaseModel {
}
__decorate$J([
    Property({ type: FLAG_TYPE }),
    __metadata$J("design:type", String)
], HelpFlag.prototype, "type", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], HelpFlag.prototype, "timestamp", void 0);
class YearEndAssignee extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndAssignee.prototype, "since", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndAssignee.prototype, "userId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndAssignee.prototype, "displayName", void 0);
class YearEndReport extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndReport.prototype, "created", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndReport.prototype, "assetId", void 0);
__decorate$J([
    Property({ type: YEAR_END_REPORT_TYPE }),
    __metadata$J("design:type", String)
], YearEndReport.prototype, "reportType", void 0);
__decorate$J([
    Property({ type: YEAR_END_REPORT_STATUS }),
    __metadata$J("design:type", String)
], YearEndReport.prototype, "reportStatus", void 0);
class YearEndMetaDataBase extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "doneUploadingReceipts", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "taxReportId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "primaryEmployer", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "otherIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "otherTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "nonDeductibleIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "insuranceIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "actualDeductiblePreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "deductiblePreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndMetaDataBase.prototype, "deductibleMileage", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "accruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "reverseAccruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "resultDeficitPreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "taxAdjustment", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "preliminaryTaxDecisionAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "supplementaryTaxPaymentAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", YearEndAssignee)
], YearEndMetaDataBase.prototype, "assignee", void 0);
__decorate$J([
    Property({ type: YearEndReport }),
    __metadata$J("design:type", Array)
], YearEndMetaDataBase.prototype, "reports", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "totalTaxPaid", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "annualReportId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "annualReportApprovalURL", void 0);
__decorate$J([
    Property({ type: ANNUAL_REPORT_SUBMIT_STATE }),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "annualReportSubmitState", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeInvoiceServiceNotRendered", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "accruedIncomeInvoiceServiceNotRenderedAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeInvoiceServiceNotRenderedInvoices", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeServiceRenderedNotInvoiced", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "accruedIncomeServiceRenderedNotInvoicedAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeServiceRenderedNotInvoicedInvoices", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceNotRendered", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceNotRenderedRecurring", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceNotRenderedAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceNotRenderedAssetId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceNotRenderedSupplier", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceRenderedNotInvoiced", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceRenderedNotInvoicedAmount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceRenderedNotInvoicedAssetId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], YearEndMetaDataBase.prototype, "accruedIncomeSupplierServiceRenderedNotInvoicedSupplier", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], YearEndMetaDataBase.prototype, "accruedIncomeBooked", void 0);
class YearEndMetaDataUpdateRequest extends YearEndMetaDataBase {
}
class YearEndMetaData extends YearEndMetaDataBase {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndMetaData.prototype, "yearEndCountdown", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndMetaData.prototype, "receiptsToUpload", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaData.prototype, "ownerSalaries", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], YearEndMetaData.prototype, "employeeSalaries", void 0);
class CompanyYearEndStep extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "companyId", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "companyName", void 0);
__decorate$J([
    Property({ type: COMPANY_TYPE }),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "companyType", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", YearEndMetaData)
], CompanyYearEndStep.prototype, "metadata", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "modified", void 0);
__decorate$J([
    Property({ type: YEAR_END_STEP }),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "step", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", HelpFlag)
], CompanyYearEndStep.prototype, "systemFlag", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", HelpFlag)
], CompanyYearEndStep.prototype, "userFlag", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", HelpFlag)
], CompanyYearEndStep.prototype, "closeYearFlag", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "fiscalEndDate", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], CompanyYearEndStep.prototype, "fiscalStartDate", void 0);
class CompanyYearEndStepListResponse extends BaseModel {
}
__decorate$J([
    Property({ type: CompanyYearEndStep }),
    __metadata$J("design:type", Array)
], CompanyYearEndStepListResponse.prototype, "data", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], CompanyYearEndStepListResponse.prototype, "length", void 0);
class YearEndListResponse extends BaseModel {
}
__decorate$J([
    Property({ type: CompanyYearEndStep }),
    __metadata$J("design:type", Array)
], YearEndListResponse.prototype, "data", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndListResponse.prototype, "length", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndListResponse.prototype, "offset", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndListResponse.prototype, "total", void 0);
class CompaniesCount extends BaseModel {
}
__decorate$J([
    Property({ type: YEAR_END_STEP }),
    __metadata$J("design:type", String)
], CompaniesCount.prototype, "step", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], CompaniesCount.prototype, "count", void 0);
class YearEndSummary extends BaseModel {
}
__decorate$J([
    Property({ type: CompaniesCount }),
    __metadata$J("design:type", Array)
], YearEndSummary.prototype, "counts", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndSummary.prototype, "userFlagCount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndSummary.prototype, "systemFlagCount", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Number)
], YearEndSummary.prototype, "closeYearFlagCount", void 0);
class LLCTaxCalculation extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "fiscalYearResult", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "fiscalYearTaxableResult", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "yearlyTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "accruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "reverseAccruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "resultDeficitPreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "paidPreliminaryTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "taxesAndFeesSkv", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "taxesAndFeesRF", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "totalTaxPaid", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "taxDue", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "specialSalaryTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], LLCTaxCalculation.prototype, "skvPayment", void 0);
class SoleTraderTaxCalculation extends BaseModel {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "actualDeductiblePreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "deductiblePreviousYear", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "accruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "reverseAccruals", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "additionalIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "fiscalYearResult", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "nonDeductibleIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Boolean)
], SoleTraderTaxCalculation.prototype, "primaryEmployer", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxableIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxesPaidOnAdditionalIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "allowance", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "skvTaxableIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "incomeTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "stateTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "soleTraderTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "totalTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxDeductible", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "yearlyTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "paidPreliminaryTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxesAndFeesSkv", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxesAndFeesRF", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "totalTaxPaid", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "taxDue", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "pension", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "pensionTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "specialSalaryTax", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "fiscalYearExcessDeficit", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "fiscalYearExcessDeficitDeductible", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], SoleTraderTaxCalculation.prototype, "taxationCode", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", Amount)
], SoleTraderTaxCalculation.prototype, "publicServiceFee", void 0);

var __decorate$I = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$I = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FirstEmployeePermitRequest extends BaseModel {
}
__decorate$I([
    Property(),
    __metadata$I("design:type", String)
], FirstEmployeePermitRequest.prototype, "employeeId", void 0);
__decorate$I([
    Property(),
    __metadata$I("design:type", String)
], FirstEmployeePermitRequest.prototype, "notes", void 0);

var __decorate$H = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$H = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class UpdateCompanyRequest extends BaseModel {
}
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "name", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "identifier", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "description", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", CompanyFiscalData)
], UpdateCompanyRequest.prototype, "fiscalData", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", DatedPermit)
], UpdateCompanyRequest.prototype, "registration", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", Address)
], UpdateCompanyRequest.prototype, "address", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "email", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "phone", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "website", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "country", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "vatIdentifier", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", BankAccountDetails)
], UpdateCompanyRequest.prototype, "mainAccount", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], UpdateCompanyRequest.prototype, "businessOperationCode", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", Boolean)
], UpdateCompanyRequest.prototype, "registeredAsEmployer", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", RestrictedAssetCollection)
], UpdateCompanyRequest.prototype, "restrictedAssets", void 0);

var __decorate$G = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$G = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CUSTOMER_STATUS;
(function (CUSTOMER_STATUS) {
    CUSTOMER_STATUS["ACTIVE"] = "ACTIVE";
    CUSTOMER_STATUS["DELETED"] = "DELETED";
})(CUSTOMER_STATUS || (CUSTOMER_STATUS = {}));
var CUSTOMER_TYPE;
(function (CUSTOMER_TYPE) {
    CUSTOMER_TYPE["COMPANY"] = "COMPANY";
    CUSTOMER_TYPE["INDIVIDUAL"] = "INDIVIDUAL";
})(CUSTOMER_TYPE || (CUSTOMER_TYPE = {}));
class DeliveryAddress extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], DeliveryAddress.prototype, "attention", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Address)
], DeliveryAddress.prototype, "address", void 0);
class Percentage extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], Percentage.prototype, "percentage", void 0);
class CustomerData extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "name", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Address)
], CustomerData.prototype, "address", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "identifier", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "vatIdentifier", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "email", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "phone", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "website", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerData.prototype, "country", void 0);
class CustomerDefaults extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], CustomerDefaults.prototype, "payByDays", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerDefaults.prototype, "currency", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Percentage)
], CustomerDefaults.prototype, "discount", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", DeliveryAddress)
], CustomerDefaults.prototype, "deliveryAddress", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerDefaults.prototype, "buyerContact", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerDefaults.prototype, "sellerContact", void 0);
class Customer extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], Customer.prototype, "id", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], Customer.prototype, "number", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], Customer.prototype, "type", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", CustomerData)
], Customer.prototype, "data", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", CustomerDefaults)
], Customer.prototype, "defaults", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], Customer.prototype, "vatArea", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], Customer.prototype, "status", void 0);
class CreateCustomerRequest extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", CustomerData)
], CreateCustomerRequest.prototype, "data", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", CustomerDefaults)
], CreateCustomerRequest.prototype, "defaults", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CreateCustomerRequest.prototype, "type", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CreateCustomerRequest.prototype, "vatArea", void 0);
class CustomerSearchResult extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", CustomerData)
], CustomerSearchResult.prototype, "data", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerSearchResult.prototype, "searchToken", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerSearchResult.prototype, "type", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], CustomerSearchResult.prototype, "roaringCompanyId", void 0);
class CustomerListResponse extends BaseModel {
}
__decorate$G([
    Property({ type: Customer }),
    __metadata$G("design:type", Array)
], CustomerListResponse.prototype, "data", void 0);
class CustomerSearchResultListResponse extends BaseModel {
}
__decorate$G([
    Property({ type: CustomerSearchResult }),
    __metadata$G("design:type", Array)
], CustomerSearchResultListResponse.prototype, "data", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], CustomerSearchResultListResponse.prototype, "length", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], CustomerSearchResultListResponse.prototype, "offset", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", Number)
], CustomerSearchResultListResponse.prototype, "total", void 0);

var __decorate$F = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$F = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyUserRelation extends BaseModel {
}
__decorate$F([
    Property(),
    __metadata$F("design:type", String)
], CompanyUserRelation.prototype, "companyId", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", String)
], CompanyUserRelation.prototype, "role", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", String)
], CompanyUserRelation.prototype, "userId", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", String)
], CompanyUserRelation.prototype, "companyName", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", String)
], CompanyUserRelation.prototype, "companyOrgNo", void 0);

var __decorate$E = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$E = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Relation extends BaseModel {
}
__decorate$E([
    Property(),
    __metadata$E("design:type", String)
], Relation.prototype, "id", void 0);
__decorate$E([
    Property({ type: ROLE }),
    __metadata$E("design:type", String)
], Relation.prototype, "role", void 0);
__decorate$E([
    Property(),
    __metadata$E("design:type", CompanyInfo)
], Relation.prototype, "company", void 0);
__decorate$E([
    Property(),
    __metadata$E("design:type", String)
], Relation.prototype, "userId", void 0);
class RelationListResponse extends BaseModel {
}
__decorate$E([
    Property({ type: Relation }),
    __metadata$E("design:type", Array)
], RelationListResponse.prototype, "data", void 0);
__decorate$E([
    Property(),
    __metadata$E("design:type", Number)
], RelationListResponse.prototype, "length", void 0);
__decorate$E([
    Property(),
    __metadata$E("design:type", Number)
], RelationListResponse.prototype, "offset", void 0);
__decorate$E([
    Property(),
    __metadata$E("design:type", Number)
], RelationListResponse.prototype, "total", void 0);

var __decorate$D = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$D = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class EmploymentRequest extends BaseModel {
}
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], EmploymentRequest.prototype, "name", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], EmploymentRequest.prototype, "identifier", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], EmploymentRequest.prototype, "startDate", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], EmploymentRequest.prototype, "endDate", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], EmploymentRequest.prototype, "location", void 0);

var __decorate$C = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$C = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Feature extends BaseModel {
}
__decorate$C([
    Property(),
    __metadata$C("design:type", String)
], Feature.prototype, "companyId", void 0);
__decorate$C([
    Property({ type: COMPANY_FEATURES }),
    __metadata$C("design:type", String)
], Feature.prototype, "type", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Boolean)
], Feature.prototype, "active", void 0);
class FeatureListResponse extends BaseModel {
}
__decorate$C([
    Property({ type: Feature }),
    __metadata$C("design:type", Array)
], FeatureListResponse.prototype, "data", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], FeatureListResponse.prototype, "length", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], FeatureListResponse.prototype, "offset", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], FeatureListResponse.prototype, "total", void 0);
class FeatureActivationRequest extends BaseModel {
}
__decorate$C([
    Property({ type: COMPANY_FEATURES }),
    __metadata$C("design:type", String)
], FeatureActivationRequest.prototype, "type", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Boolean)
], FeatureActivationRequest.prototype, "active", void 0);

var OBJECT_TYPE;
(function (OBJECT_TYPE) {
    OBJECT_TYPE["ACCOUNT_ENTRY"] = "ACCOUNT_ENTRY";
    OBJECT_TYPE["ASSET"] = "ASSET";
    OBJECT_TYPE["BILL"] = "BILL";
    OBJECT_TYPE["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    OBJECT_TYPE["COMPANY"] = "COMPANY";
    OBJECT_TYPE["EXPENSE"] = "EXPENSE";
    OBJECT_TYPE["FINANCIAL_PAYMENT"] = "FINANCIAL_PAYMENT";
    OBJECT_TYPE["GPS_TRANSACTION"] = "GPS_TRANSACTION";
    OBJECT_TYPE["HISTORICAL_INVOICE"] = "HISTORICAL_INVOICE";
    OBJECT_TYPE["INVOICE"] = "INVOICE";
    OBJECT_TYPE["OWNER_DEPOSIT"] = "OWNER_DEPOSIT";
    OBJECT_TYPE["OWNER_WITHDRAWAL"] = "OWNER_WITHDRAWAL";
    OBJECT_TYPE["PAYMENT"] = "PAYMENT";
    OBJECT_TYPE["RECEIPT"] = "RECEIPT";
    OBJECT_TYPE["REGISTRATION_STEP"] = "REGISTRATION_STEP";
    OBJECT_TYPE["REPORT"] = "REPORT";
    OBJECT_TYPE["ROLE"] = "ROLE";
    OBJECT_TYPE["SALARY"] = "SALARY";
    OBJECT_TYPE["SESSION"] = "SESSION";
    OBJECT_TYPE["SETTLEMENT"] = "SETTLEMENT";
    OBJECT_TYPE["TRANSACTION"] = "TRANSACTION";
    OBJECT_TYPE["USER"] = "USER";
    OBJECT_TYPE["VOUCHER"] = "VOUCHER";
    OBJECT_TYPE["WIRECARD_PAYMENT"] = "WIRECARD_PAYMENT";
})(OBJECT_TYPE || (OBJECT_TYPE = {}));
var OBJECT_SUB_TYPE;
(function (OBJECT_SUB_TYPE) {
    OBJECT_SUB_TYPE["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    OBJECT_SUB_TYPE["CARD_HOLDER_DEBT"] = "CARD_HOLDER_DEBT";
    OBJECT_SUB_TYPE["CASH_EMMISSION"] = "CASH_EMMISSION";
    OBJECT_SUB_TYPE["CONTRIBUTION"] = "CONTRIBUTION";
    OBJECT_SUB_TYPE["CREDIT"] = "CREDIT";
    OBJECT_SUB_TYPE["DEBIT"] = "DEBIT";
    OBJECT_SUB_TYPE["PENDING_RESOLUTION"] = "PENDING_RESOLUTION";
    OBJECT_SUB_TYPE["PRELIMINARY_TAXES"] = "PRELIMINARY_TAXES";
    OBJECT_SUB_TYPE["SALARY_TAXES"] = "SALARY_TAXES";
    OBJECT_SUB_TYPE["SOCIAL_FEES"] = "SOCIAL_FEES";
    OBJECT_SUB_TYPE["VAT"] = "VAT";
})(OBJECT_SUB_TYPE || (OBJECT_SUB_TYPE = {}));

var __decorate$B = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$B = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FutureEvent extends BaseModel {
}
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], FutureEvent.prototype, "amount", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], FutureEvent.prototype, "description", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Date)
], FutureEvent.prototype, "dueDate", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Reference)
], FutureEvent.prototype, "reference", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], FutureEvent.prototype, "type", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], FutureEvent.prototype, "subType", void 0);
class Summary extends BaseModel {
}
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "balance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "startingBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "reservedBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "vatBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "shareholderCapital", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Summary.prototype, "accruedTax", void 0);
class Projection extends BaseModel {
}
__decorate$B([
    Property({ type: FutureEvent }),
    __metadata$B("design:type", Array)
], Projection.prototype, "futureEvents", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], Projection.prototype, "limit", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Summary)
], Projection.prototype, "summary", void 0);
class VatAdjustment extends BaseModel {
}
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], VatAdjustment.prototype, "amount", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Reference)
], VatAdjustment.prototype, "reference", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], VatAdjustment.prototype, "subType", void 0);
class DebugProjection extends BaseModel {
}
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "calculatedLimit", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "calculatedSafeToSpend", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "calculatedVatBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "vatBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "balance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "reservedBalance", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "accruedTax", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Amount)
], DebugProjection.prototype, "shareholderCapital", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], DebugProjection.prototype, "limitDate", void 0);
__decorate$B([
    Property({ type: FutureEvent }),
    __metadata$B("design:type", Array)
], DebugProjection.prototype, "events", void 0);
__decorate$B([
    Property({ type: FutureEvent }),
    __metadata$B("design:type", Array)
], DebugProjection.prototype, "calculationEvents", void 0);
__decorate$B([
    Property({ type: VatAdjustment }),
    __metadata$B("design:type", Array)
], DebugProjection.prototype, "vatAdjustments", void 0);

var __decorate$A = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$A = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FixedAssetDepreciation extends BaseModel {
}
__decorate$A([
    Property(),
    __metadata$A("design:type", String)
], FixedAssetDepreciation.prototype, "id", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", Number)
], FixedAssetDepreciation.prototype, "deprecationPeriod", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", Number)
], FixedAssetDepreciation.prototype, "deprecationPeriodRemaining", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", Amount)
], FixedAssetDepreciation.prototype, "depreciationAmount", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", Amount)
], FixedAssetDepreciation.prototype, "depreciationAmountRemaining", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", String)
], FixedAssetDepreciation.prototype, "depreciationDate", void 0);

var __decorate$z = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$z = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FixedAsset extends BaseModel {
}
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "id", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "created", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "modified", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "companyId", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "description", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Amount)
], FixedAsset.prototype, "acquisitionAmount", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "acquisitionDate", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Amount)
], FixedAsset.prototype, "accumulatedAmount", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "accumulatedDate", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Number)
], FixedAsset.prototype, "deprecationPeriod", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Number)
], FixedAsset.prototype, "deprecationPeriodRemaining", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Amount)
], FixedAsset.prototype, "depreciationAmountRemaining", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "accountIdentifier", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "deprecationAccountIdentifier", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], FixedAsset.prototype, "accumulatedDeprecationAccountIdentifier", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Reference)
], FixedAsset.prototype, "reference", void 0);
__decorate$z([
    Property({ type: FixedAssetDepreciation }),
    __metadata$z("design:type", Array)
], FixedAsset.prototype, "fixedAssetDepreciationList", void 0);

var __decorate$y = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$y = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FixedAssetCreateRequest extends BaseModel {
}
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "companyId", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "description", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", Amount)
], FixedAssetCreateRequest.prototype, "acquisitionAmount", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "acquisitionDate", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", Amount)
], FixedAssetCreateRequest.prototype, "accumulatedAmount", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "accumulatedDate", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", Number)
], FixedAssetCreateRequest.prototype, "deprecationPeriod", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "accountIdentifier", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "deprecationAccountIdentifier", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], FixedAssetCreateRequest.prototype, "accumulatedDeprecationAccountIdentifier", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", Reference)
], FixedAssetCreateRequest.prototype, "reference", void 0);

var __decorate$x = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$x = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FixedAssetListResponse extends BaseModel {
}
__decorate$x([
    Property({ type: FixedAsset }),
    __metadata$x("design:type", Array)
], FixedAssetListResponse.prototype, "data", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", Number)
], FixedAssetListResponse.prototype, "length", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", Number)
], FixedAssetListResponse.prototype, "offset", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", Number)
], FixedAssetListResponse.prototype, "total", void 0);

var FIXED_ASSET_SORT;
(function (FIXED_ASSET_SORT) {
    FIXED_ASSET_SORT["CREATED"] = "CREATED";
    FIXED_ASSET_SORT["MODIFIED"] = "MODIFIED";
    FIXED_ASSET_SORT["DESCRIPTION"] = "DESCRIPTION";
    FIXED_ASSET_SORT["ACQUISITION_AMOUNT"] = "ACQUISITION_AMOUNT";
    FIXED_ASSET_SORT["ACQUISITION_DATE"] = "ACQUISITION_DATE";
    FIXED_ASSET_SORT["ACCUMULATED_AMOUNT"] = "ACCUMULATED_AMOUNT";
    FIXED_ASSET_SORT["ACCUMULATED_DATE"] = "ACCUMULATED_DATE";
    FIXED_ASSET_SORT["DEPRECATION_PERIOD"] = "DEPRECATION_PERIOD";
    FIXED_ASSET_SORT["ACCOUNT_IDENTIFIER"] = "ACCOUNT_IDENTIFIER";
})(FIXED_ASSET_SORT || (FIXED_ASSET_SORT = {}));

var FIXED_ASSET_SORT_DIRECTION;
(function (FIXED_ASSET_SORT_DIRECTION) {
    FIXED_ASSET_SORT_DIRECTION["ASC"] = "ASC";
    FIXED_ASSET_SORT_DIRECTION["DESC"] = "DESC";
})(FIXED_ASSET_SORT_DIRECTION || (FIXED_ASSET_SORT_DIRECTION = {}));

var __decorate$w = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$w = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class FixedAssetUpdateRequest extends BaseModel {
}
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "description", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Amount)
], FixedAssetUpdateRequest.prototype, "acquisitionAmount", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "acquisitionDate", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Amount)
], FixedAssetUpdateRequest.prototype, "accumulatedAmount", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "accumulatedDate", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Number)
], FixedAssetUpdateRequest.prototype, "deprecationPeriod", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "accountIdentifier", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "deprecationAccountIdentifier", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], FixedAssetUpdateRequest.prototype, "accumulatedDeprecationAccountIdentifier", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Reference)
], FixedAssetUpdateRequest.prototype, "reference", void 0);

var __decorate$v = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$v = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class LineItem extends BaseModel {
}
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "id", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "name", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "description", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "customVAT", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", Amount)
], LineItem.prototype, "price", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", Number)
], LineItem.prototype, "VAT", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "unit", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "reductionType", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], LineItem.prototype, "reductionItemType", void 0);

var __decorate$u = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$u = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BEARER;
(function (BEARER) {
    BEARER["RECEIVER"] = "RECEIVER";
    BEARER["SENDER"] = "SENDER";
    BEARER["SHARED"] = "SHARED";
})(BEARER || (BEARER = {}));
class Charge extends BaseModel {
}
__decorate$u([
    Property(),
    __metadata$u("design:type", String)
], Charge.prototype, "bearer", void 0);
__decorate$u([
    Property(),
    __metadata$u("design:type", Amount)
], Charge.prototype, "amount", void 0);

var __decorate$t = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$t = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class InvoicePayment extends BaseModel {
}
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], InvoicePayment.prototype, "id", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], InvoicePayment.prototype, "received", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", Amount)
], InvoicePayment.prototype, "amount", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", Reference)
], InvoicePayment.prototype, "source", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", ExchangeAmount)
], InvoicePayment.prototype, "forexAmount", void 0);
__decorate$t([
    Property({ type: Charge }),
    __metadata$t("design:type", Array)
], InvoicePayment.prototype, "charges", void 0);
class InvoicePaymentRegistration extends BaseModel {
}
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], InvoicePaymentRegistration.prototype, "received", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", Amount)
], InvoicePaymentRegistration.prototype, "amount", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", Reference)
], InvoicePaymentRegistration.prototype, "source", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", ExchangeAmount)
], InvoicePaymentRegistration.prototype, "exchangeAmount", void 0);
__decorate$t([
    Property({ type: Charge }),
    __metadata$t("design:type", Array)
], InvoicePaymentRegistration.prototype, "charges", void 0);

var __decorate$s = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$s = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var INVOICE_STATUS;
(function (INVOICE_STATUS) {
    INVOICE_STATUS["BOOKED"] = "BOOKED";
    INVOICE_STATUS["CANCELLED"] = "CANCELLED";
    INVOICE_STATUS["COMPLETE"] = "COMPLETE";
    INVOICE_STATUS["DELETED"] = "DELETED";
    INVOICE_STATUS["DRAFT"] = "DRAFT";
    INVOICE_STATUS["IN_REVIEW"] = "IN_REVIEW";
    INVOICE_STATUS["NEW"] = "NEW";
})(INVOICE_STATUS || (INVOICE_STATUS = {}));
var INVOICE_DELIVERY_METHOD;
(function (INVOICE_DELIVERY_METHOD) {
    INVOICE_DELIVERY_METHOD["LETTER"] = "LETTER";
    INVOICE_DELIVERY_METHOD["DOWNLOAD"] = "DOWNLOAD";
})(INVOICE_DELIVERY_METHOD || (INVOICE_DELIVERY_METHOD = {}));
var INVOICE_DELIVERY_STATUS;
(function (INVOICE_DELIVERY_STATUS) {
    INVOICE_DELIVERY_STATUS["PENDING"] = "PENDING";
    INVOICE_DELIVERY_STATUS["SENT"] = "SENT";
    INVOICE_DELIVERY_STATUS["DELIVERED"] = "DELIVERED";
    INVOICE_DELIVERY_STATUS["FAILED"] = "FAILED";
})(INVOICE_DELIVERY_STATUS || (INVOICE_DELIVERY_STATUS = {}));
var INVOICE_ORDER_BY;
(function (INVOICE_ORDER_BY) {
    INVOICE_ORDER_BY["DATE"] = "DATE";
    INVOICE_ORDER_BY["CREATED"] = "CREATED";
    INVOICE_ORDER_BY["MODIFIED"] = "MODIFIED";
    INVOICE_ORDER_BY["NUMBER"] = "NUMBER";
})(INVOICE_ORDER_BY || (INVOICE_ORDER_BY = {}));
var INVOICE_ORDER;
(function (INVOICE_ORDER) {
    INVOICE_ORDER["ASCENDING"] = "ASCENDING";
    INVOICE_ORDER["DESCENDING"] = "DESCENDING";
})(INVOICE_ORDER || (INVOICE_ORDER = {}));
class Delivery extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Delivery.prototype, "createdAt", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Delivery.prototype, "modifiedAt", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Delivery.prototype, "method", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Delivery.prototype, "status", void 0);
class InvoiceItem extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], InvoiceItem.prototype, "lineItemId", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", LineItem)
], InvoiceItem.prototype, "item", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceItem.prototype, "count", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceItem.prototype, "discount", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], InvoiceItem.prototype, "netPrice", void 0);
class InvoiceSalary extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "redFlagFeePct", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "redFlagFee", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "taxes", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "socialFees", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "grossSalary", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Number)
], InvoiceSalary.prototype, "netSalary", void 0);
class InvoiceEditor extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], InvoiceEditor.prototype, "id", void 0);
class Invoice extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "id", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "buyerContact", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "reference", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "number", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "status", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "paymentStatus", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "resourceUrl", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "date", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "expires", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "creditedBy", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "crediting", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "currency", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "type", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", InvoiceSalary)
], Invoice.prototype, "salary", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Customer)
], Invoice.prototype, "customer", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", InvoiceEditor)
], Invoice.prototype, "editor", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", CompanyInfo)
], Invoice.prototype, "companyInfo", void 0);
__decorate$s([
    Property({ type: InvoiceItem }),
    __metadata$s("design:type", Array)
], Invoice.prototype, "items", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], Invoice.prototype, "sellerContact", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", ExchangeRate)
], Invoice.prototype, "exchangeRate", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], Invoice.prototype, "totalDue", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], Invoice.prototype, "totalNet", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], Invoice.prototype, "totalGross", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], Invoice.prototype, "totalVAT", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Amount)
], Invoice.prototype, "totalDiscount", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Delivery)
], Invoice.prototype, "deliveryOption", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", DeliveryAddress)
], Invoice.prototype, "deliveryAddress", void 0);
__decorate$s([
    Property({ type: InvoicePayment }),
    __metadata$s("design:type", Array)
], Invoice.prototype, "payments", void 0);
class InvoiceListResponse extends BaseModel {
}
__decorate$s([
    Property({ type: Invoice }),
    __metadata$s("design:type", Array)
], InvoiceListResponse.prototype, "data", void 0);
class UpdateInvoiceRequest extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "buyerContact", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "currency", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "date", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", Delivery)
], UpdateInvoiceRequest.prototype, "deliveryOption", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "expires", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "id", void 0);
__decorate$s([
    Property({ type: InvoiceItem }),
    __metadata$s("design:type", Array)
], UpdateInvoiceRequest.prototype, "items", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], UpdateInvoiceRequest.prototype, "sellerContact", void 0);
class CreateCreditInvoiceRequest extends BaseModel {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", Delivery)
], CreateCreditInvoiceRequest.prototype, "deliveryOption", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], CreateCreditInvoiceRequest.prototype, "date", void 0);

var __decorate$r = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$r = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var LOAN_STATUS;
(function (LOAN_STATUS) {
    LOAN_STATUS["PENDING"] = "PENDING";
    LOAN_STATUS["DELIVERED"] = "DELIVERED";
    LOAN_STATUS["CONFIRMED"] = "CONFIRMED";
    LOAN_STATUS["REJECTED"] = "REJECTED";
    LOAN_STATUS["CANCELLED"] = "CANCELLED";
})(LOAN_STATUS || (LOAN_STATUS = {}));
class Loan extends BaseModel {
}
__decorate$r([
    Property(),
    __metadata$r("design:type", Date)
], Loan.prototype, "created", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", Date)
], Loan.prototype, "modified", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", Amount)
], Loan.prototype, "amount", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", String)
], Loan.prototype, "status", void 0);

var __decorate$q = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$q = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class UserAddress extends BaseModel {
    current() {
        if (this.PREFERRED_POSTAL_ADDRESS && !this.PREFERRED_POSTAL_ADDRESS.isEmpty()) {
            return this.PREFERRED_POSTAL_ADDRESS;
        }
        if (this.FOREIGN_REGISTRATION_ADDRESS && !this.FOREIGN_REGISTRATION_ADDRESS.isEmpty()) {
            return this.FOREIGN_REGISTRATION_ADDRESS;
        }
        if (this.SEPARATE_NATIONAL_REGISTRATION_ADDRESS && !this.SEPARATE_NATIONAL_REGISTRATION_ADDRESS.isEmpty()) {
            return this.SEPARATE_NATIONAL_REGISTRATION_ADDRESS;
        }
        if (this.NATIONAL_REGISTRATION_ADDRESS && !this.NATIONAL_REGISTRATION_ADDRESS.isEmpty()) {
            return this.NATIONAL_REGISTRATION_ADDRESS;
        }
        return null;
    }
    mostComplete() {
        let mostComplete = this.current();
        Object.keys(this._values).forEach(key => {
            const props = Object.keys(this._values[key]);
            if (props.length > Object.keys(mostComplete).length) {
                mostComplete = this._values[key];
            }
        });
        return mostComplete;
    }
}
__decorate$q([
    Property(),
    __metadata$q("design:type", Address)
], UserAddress.prototype, "NATIONAL_REGISTRATION_ADDRESS", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", Address)
], UserAddress.prototype, "SEPARATE_NATIONAL_REGISTRATION_ADDRESS", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", Address)
], UserAddress.prototype, "FOREIGN_REGISTRATION_ADDRESS", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", Address)
], UserAddress.prototype, "PREFERRED_POSTAL_ADDRESS", void 0);
class UserDetails extends BaseModel {
    get displayName() {
        return (((this.firstName || '') + ' ' + (this.middleName || '') + ' ' + (this.lastName || ''))
            .replace(/\s{2,}/g, ' ')
            .trim() || undefined);
    }
}
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "identification", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", UserAddress)
], UserDetails.prototype, "addresses", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "firstName", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "lastName", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "middleName", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "email", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "phone", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "dateOfBirth", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "country", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", BankAccountDetails)
], UserDetails.prototype, "mainAccount", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], UserDetails.prototype, "citizenShip", void 0);
class User extends BaseModel {
}
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], User.prototype, "id", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], User.prototype, "created", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", UserDetails)
], User.prototype, "details", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], User.prototype, "lastModified", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], User.prototype, "status", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", Object)
], User.prototype, "integrationIds", void 0);
class CreateUserRequest extends BaseModel {
}
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], CreateUserRequest.prototype, "identification", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", UserDetails)
], CreateUserRequest.prototype, "details", void 0);
__decorate$q([
    Property({ type: Relation }),
    __metadata$q("design:type", Array)
], CreateUserRequest.prototype, "relations", void 0);
class UpdateUserRequest extends BaseModel {
}
__decorate$q([
    Property(),
    __metadata$q("design:type", UserDetails)
], UpdateUserRequest.prototype, "details", void 0);

var __decorate$p = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$p = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Me extends BaseModel {
    getConfigurationByCompanyId(companyId) {
        return (this.configurations || [])
            .filter((config) => config.companyId === companyId)
            .shift();
    }
}
__decorate$p([
    Property(),
    __metadata$p("design:type", User)
], Me.prototype, "user", void 0);
__decorate$p([
    Property({ type: Relation }),
    __metadata$p("design:type", Array)
], Me.prototype, "relations", void 0);
__decorate$p([
    Property({ type: CompanyConfiguration }),
    __metadata$p("design:type", Array)
], Me.prototype, "configurations", void 0);

var __decorate$o = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$o = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var OWNER_DEPOSIT_TYPE;
(function (OWNER_DEPOSIT_TYPE) {
    OWNER_DEPOSIT_TYPE["CASH_EMMISSION"] = "CASH_EMMISSION";
    OWNER_DEPOSIT_TYPE["CONTRIBUTION"] = "CONTRIBUTION";
})(OWNER_DEPOSIT_TYPE || (OWNER_DEPOSIT_TYPE = {}));
var OWNER_DEPOSIT_STATUS;
(function (OWNER_DEPOSIT_STATUS) {
    OWNER_DEPOSIT_STATUS["BOOKED"] = "BOOKED";
    OWNER_DEPOSIT_STATUS["CANCELLED"] = "CANCELLED";
})(OWNER_DEPOSIT_STATUS || (OWNER_DEPOSIT_STATUS = {}));
class OwnerDeposit extends BaseModel {
}
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "id", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "companyId", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "created", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "modified", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", Reference)
], OwnerDeposit.prototype, "paymentReference", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", Amount)
], OwnerDeposit.prototype, "amount", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "type", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OwnerDeposit.prototype, "status", void 0);
class OwnerDepositList extends BaseModel {
}
__decorate$o([
    Property({ type: OwnerDeposit }),
    __metadata$o("design:type", Array)
], OwnerDepositList.prototype, "data", void 0);

var __decorate$n = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$n = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CreateOwnerWithdrawalRequestOverridingParameters extends BaseModel {
}
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], CreateOwnerWithdrawalRequestOverridingParameters.prototype, "accountHolderName", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], CreateOwnerWithdrawalRequestOverridingParameters.prototype, "accountType", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], CreateOwnerWithdrawalRequestOverridingParameters.prototype, "accountNumber", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], CreateOwnerWithdrawalRequestOverridingParameters.prototype, "messageReference", void 0);
class CreateOwnerWithdrawalRequest extends BaseModel {
}
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], CreateOwnerWithdrawalRequest.prototype, "userId", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", Amount)
], CreateOwnerWithdrawalRequest.prototype, "amount", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", CreateOwnerWithdrawalRequestOverridingParameters)
], CreateOwnerWithdrawalRequest.prototype, "overridingParameters", void 0);
class OwnerWithdrawal extends BaseModel {
}
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "id", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "companyId", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "userId", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "created", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "modified", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", Amount)
], OwnerWithdrawal.prototype, "amount", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "paymentStatus", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawal.prototype, "paymentCommandId", void 0);
class OwnerWithdrawalResponse extends BaseModel {
}
__decorate$n([
    Property(),
    __metadata$n("design:type", OwnerWithdrawal)
], OwnerWithdrawalResponse.prototype, "ownerWithdrawal", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", Boolean)
], OwnerWithdrawalResponse.prototype, "ownerWithdrawalCompleted", void 0);
__decorate$n([
    Property(),
    __metadata$n("design:type", String)
], OwnerWithdrawalResponse.prototype, "ownerWithdrawalDetail", void 0);
class OwnerWithDrawlList extends BaseModel {
}
__decorate$n([
    Property({ type: OwnerWithdrawal }),
    __metadata$n("design:type", Array)
], OwnerWithDrawlList.prototype, "withdrawals", void 0);
class OwnerDepositsAndWithdrawalsResponse extends BaseModel {
}
__decorate$n([
    Property({ type: OwnerWithdrawal }),
    __metadata$n("design:type", Array)
], OwnerDepositsAndWithdrawalsResponse.prototype, "ownerWithdrawals", void 0);
__decorate$n([
    Property({ type: OwnerDeposit }),
    __metadata$n("design:type", Array)
], OwnerDepositsAndWithdrawalsResponse.prototype, "ownerDeposits", void 0);

var __decorate$m = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$m = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class PaymentAllowedCountriesResponse extends BaseModel {
}
__decorate$m([
    Property({ type: COUNTRY }),
    __metadata$m("design:type", Array)
], PaymentAllowedCountriesResponse.prototype, "list", void 0);

var __decorate$l = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$l = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var RECEIPT_STATUS;
(function (RECEIPT_STATUS) {
    RECEIPT_STATUS["PENDING"] = "PENDING";
    RECEIPT_STATUS["IN_REVIEW"] = "IN_REVIEW";
    RECEIPT_STATUS["REJECTED"] = "REJECTED";
    RECEIPT_STATUS["BOOKED"] = "BOOKED";
    RECEIPT_STATUS["CANCELLED"] = "CANCELLED";
    RECEIPT_STATUS["DELETED"] = "DELETED";
    RECEIPT_STATUS["DUPLICATE"] = "DUPLICATE";
})(RECEIPT_STATUS || (RECEIPT_STATUS = {}));
var RECEIPT_SORT_ORDER;
(function (RECEIPT_SORT_ORDER) {
    RECEIPT_SORT_ORDER["ASCENDING"] = "ASCENDING";
    RECEIPT_SORT_ORDER["DESCENDING"] = "DESCENDING";
})(RECEIPT_SORT_ORDER || (RECEIPT_SORT_ORDER = {}));
var RECEIPT_ORDER_BY;
(function (RECEIPT_ORDER_BY) {
    RECEIPT_ORDER_BY["CREATED"] = "CREATED";
    RECEIPT_ORDER_BY["MODIFIED"] = "MODIFIED";
})(RECEIPT_ORDER_BY || (RECEIPT_ORDER_BY = {}));
class Receipt extends BaseModel {
}
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "id", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "companyId", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "assetId", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "userId", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "description", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], Receipt.prototype, "totalAmount", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], Receipt.prototype, "totalVAT", void 0);
__decorate$l([
    Property({ type: VatAmount }),
    __metadata$l("design:type", Array)
], Receipt.prototype, "vatList", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "receiptDate", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "created", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "modified", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], Receipt.prototype, "resourceUrl", void 0);
__decorate$l([
    Property({ defaultValue: RECEIPT_STATUS.PENDING }),
    __metadata$l("design:type", String)
], Receipt.prototype, "status", void 0);
__decorate$l([
    Property({ type: BookkeepingHint }),
    __metadata$l("design:type", Array)
], Receipt.prototype, "bookkeepingHints", void 0);
__decorate$l([
    Property({}),
    __metadata$l("design:type", DepreciationItem)
], Receipt.prototype, "depreciationItem", void 0);
class ReceiptListResponse extends BaseModel {
}
__decorate$l([
    Property({ type: Receipt }),
    __metadata$l("design:type", Array)
], ReceiptListResponse.prototype, "data", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Number)
], ReceiptListResponse.prototype, "length", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Number)
], ReceiptListResponse.prototype, "offset", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Number)
], ReceiptListResponse.prototype, "total", void 0);
class ReceiptUpdateRequest extends BaseModel {
}
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], ReceiptUpdateRequest.prototype, "amount", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], ReceiptUpdateRequest.prototype, "totalVat", void 0);
__decorate$l([
    Property({ type: VatAmount }),
    __metadata$l("design:type", Array)
], ReceiptUpdateRequest.prototype, "vatList", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], ReceiptUpdateRequest.prototype, "receiptDate", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], ReceiptUpdateRequest.prototype, "description", void 0);
class ReceiptBookkeepingUpdateRequest extends BaseModel {
}
__decorate$l([
    Property({ type: BookkeepingHint }),
    __metadata$l("design:type", Array)
], ReceiptBookkeepingUpdateRequest.prototype, "bookkeepingHints", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", DepreciationItem)
], ReceiptBookkeepingUpdateRequest.prototype, "depreciationItem", void 0);

var __decorate$k = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$k = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var REGISTRATION_ADDITIONAL_BOOKKEEPING;
(function (REGISTRATION_ADDITIONAL_BOOKKEEPING) {
    REGISTRATION_ADDITIONAL_BOOKKEEPING["SELF"] = "SELF";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["OUT_SOURCED"] = "OUT_SOURCED";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["BOKIO"] = "BOKIO";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["DOOER"] = "DOOER";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["FORTNOX"] = "FORTNOX";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["HOGIA"] = "HOGIA";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["VISMA"] = "VISMA";
    REGISTRATION_ADDITIONAL_BOOKKEEPING["OTHER"] = "OTHER";
})(REGISTRATION_ADDITIONAL_BOOKKEEPING || (REGISTRATION_ADDITIONAL_BOOKKEEPING = {}));
var REGISTRATION_ADDITIONAL_CREATED;
(function (REGISTRATION_ADDITIONAL_CREATED) {
    REGISTRATION_ADDITIONAL_CREATED["NO_COMPANY"] = "NO_COMPANY";
    REGISTRATION_ADDITIONAL_CREATED["THIS_YEAR"] = "THIS_YEAR";
    REGISTRATION_ADDITIONAL_CREATED["PREVIOUSLY"] = "PREVIOUSLY";
})(REGISTRATION_ADDITIONAL_CREATED || (REGISTRATION_ADDITIONAL_CREATED = {}));
var REGISTRATION_STATUS;
(function (REGISTRATION_STATUS) {
    REGISTRATION_STATUS["CANCELLED"] = "CANCELLED";
    REGISTRATION_STATUS["COMPLETE"] = "COMPLETE";
    REGISTRATION_STATUS["OPEN"] = "OPEN";
})(REGISTRATION_STATUS || (REGISTRATION_STATUS = {}));
var REGISTRATION_SORT_ORDER;
(function (REGISTRATION_SORT_ORDER) {
    REGISTRATION_SORT_ORDER["ASCENDING"] = "ASCENDING";
    REGISTRATION_SORT_ORDER["DESCENDING"] = "DESCENDING";
})(REGISTRATION_SORT_ORDER || (REGISTRATION_SORT_ORDER = {}));
var REGISTRATION_ORDERBY;
(function (REGISTRATION_ORDERBY) {
    REGISTRATION_ORDERBY["CREATED"] = "CREATED";
    REGISTRATION_ORDERBY["MODIFIED"] = "MODIFIED";
    REGISTRATION_ORDERBY["DUEDATE"] = "DUEDATE";
})(REGISTRATION_ORDERBY || (REGISTRATION_ORDERBY = {}));
var STEP_NAME;
(function (STEP_NAME) {
    STEP_NAME["VERIFY_USER"] = "verify_user";
    STEP_NAME["CALLBACK"] = "callback";
    STEP_NAME["CATCHALL"] = "catchall";
    STEP_NAME["COMPLETE_APPLICATION"] = "complete_application";
    STEP_NAME["CREATE_COMPANY_EXISTING_LLC"] = "create_company_existing_llc";
    STEP_NAME["CREATE_LLC_APPLICATION"] = "create_llc_application";
    STEP_NAME["CREATE_TAX_AGENCY_APPLICATION"] = "create_tax_agency_application";
    STEP_NAME["WAIT_FOR_CUSTOMER_APPLICATION"] = "wait_for_customer_application";
    STEP_NAME["APPLICATION_APPROVED"] = "application_approved";
    STEP_NAME["WAITING_FOR_TAX_AGENCY"] = "waiting_for_tax_agency";
    STEP_NAME["WAIT_FOR_SHAREHOLDER_CAPITAL"] = "wait_for_shareholder_capital";
    STEP_NAME["WAITING_FOR_LLC_APPLICATION"] = "waiting_for_llc_application";
    STEP_NAME["READY_TO_LAUNCH"] = "ready_to_launch";
    STEP_NAME["INITIAL_CHECKS"] = "initial_checks";
    STEP_NAME["INITIAL_CHECKS_EXISTING_LLC"] = "initial_checks_existing_llc";
    STEP_NAME["INITIAL_SETTLEMENT_AND_ASSET_UPLOAD"] = "initial_settlement_and_asset_upload";
    STEP_NAME["ASSET_UPLOADING_DONE"] = "asset_uploading_done";
    STEP_NAME["FINAL_SETTLEMENT"] = "final_settlement";
    STEP_NAME["VALIDATE_SIE_EXISTING_LLC"] = "validate_sie_existing_llc";
    STEP_NAME["VALIDATE_SIE_EXISTING_SOLE"] = "validate_sie_existing_sole";
    STEP_NAME["CREATE_COMPANY_EXISTING_SOLE"] = "create_company_existing_sole";
})(STEP_NAME || (STEP_NAME = {}));
var STEP_TYPE;
(function (STEP_TYPE) {
    STEP_TYPE["EXTERNAL"] = "EXTERNAL";
    STEP_TYPE["INTERNAL"] = "INTERNAL";
})(STEP_TYPE || (STEP_TYPE = {}));
var REGISTRATION_FLOW;
(function (REGISTRATION_FLOW) {
    REGISTRATION_FLOW["EXISTING_LIMITED_COMPANY"] = "existing_llc_with_sie";
    REGISTRATION_FLOW["EXISTING_SOLE_TRADER"] = "existing_sole_company_1";
    REGISTRATION_FLOW["EXISTING_SOLE_WITH_SIE"] = "existing_sole_with_sie";
    REGISTRATION_FLOW["NEW_LIMITED_COMPANY"] = "new_llc_company";
    REGISTRATION_FLOW["NEW_SOLE_TRADER"] = "new_sole_company_1";
})(REGISTRATION_FLOW || (REGISTRATION_FLOW = {}));
var REGISTRATION_FILE_TYPE;
(function (REGISTRATION_FILE_TYPE) {
    REGISTRATION_FILE_TYPE["SIE"] = "SIE";
    REGISTRATION_FILE_TYPE["OWNER_DEPOSIT_NOTE"] = "OWNER_DEPOSIT_NOTE";
    REGISTRATION_FILE_TYPE["OTHER"] = "OTHER";
})(REGISTRATION_FILE_TYPE || (REGISTRATION_FILE_TYPE = {}));
var AUTHOR_TYPE;
(function (AUTHOR_TYPE) {
    AUTHOR_TYPE["USER"] = "USER";
    AUTHOR_TYPE["ROBOT"] = "ROBOT";
})(AUTHOR_TYPE || (AUTHOR_TYPE = {}));
class Author extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Author.prototype, "id", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Author.prototype, "type", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Author.prototype, "name", void 0);
// This should probably be renamed to RegistrationCompanyDetails
class CompanyDetails extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", Address)
], CompanyDetails.prototype, "companyAddress", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyDetails.prototype, "companyEmail", void 0);
__decorate$k([
    Property({ type: String }),
    __metadata$k("design:type", Array)
], CompanyDetails.prototype, "suggestedNames", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyDetails.prototype, "companyDescription", void 0);
class ShareholderCapital extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", Amount)
], ShareholderCapital.prototype, "amount", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Number)
], ShareholderCapital.prototype, "numberOfShares", void 0);
class Deputy extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Deputy.prototype, "identifier", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Deputy.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Address)
], Deputy.prototype, "address", void 0);
class BoardLocation extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], BoardLocation.prototype, "county", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], BoardLocation.prototype, "municipality", void 0);
class RegistrationApplication extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", Address)
], RegistrationApplication.prototype, "ownerAddress", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", CompanyDetails)
], RegistrationApplication.prototype, "companyDetails", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", ShareholderCapital)
], RegistrationApplication.prototype, "shareholderCapital", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Deputy)
], RegistrationApplication.prototype, "deputy", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", BoardLocation)
], RegistrationApplication.prototype, "boardLocation", void 0);
__decorate$k([
    Property({ type: Deputy }),
    __metadata$k("design:type", Array)
], RegistrationApplication.prototype, "deputies", void 0);
class BusinessOperationActivity extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], BusinessOperationActivity.prototype, "businessOperationCode", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Amount)
], BusinessOperationActivity.prototype, "amount", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Number)
], BusinessOperationActivity.prototype, "proportion", void 0);
class Step extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Step.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Step.prototype, "type", void 0);
class RegistrationStep extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", Author)
], RegistrationStep.prototype, "author", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationStep.prototype, "created", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationStep.prototype, "dueTo", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationStep.prototype, "hasComments", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationStep.prototype, "id", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], RegistrationStep.prototype, "meta", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationStep.prototype, "modified", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Step)
], RegistrationStep.prototype, "step", void 0);
class Flow extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Flow.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Flow.prototype, "country", void 0);
__decorate$k([
    Property({ type: Step }),
    __metadata$k("design:type", Array)
], Flow.prototype, "steps", void 0);
class RegistrationFile extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationFile.prototype, "assetId", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationFile.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationFile.prototype, "type", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationFile.prototype, "createdAt", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Author)
], RegistrationFile.prototype, "author", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationFile.prototype, "resourceUrl", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], RegistrationFile.prototype, "meta", void 0);
class RegistrationDetails extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", RegistrationApplication)
], RegistrationDetails.prototype, "application", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "companyDescription", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "country", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "email", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "firstName", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Boolean)
], RegistrationDetails.prototype, "hasCompany", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "identification", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "language", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "lastName", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], RegistrationDetails.prototype, "meta", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "phoneNo", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationDetails.prototype, "voucherCode", void 0);
__decorate$k([
    Property({ type: BusinessOperationActivity }),
    __metadata$k("design:type", Array)
], RegistrationDetails.prototype, "activities", void 0);
__decorate$k([
    Property({ type: RegistrationFile }),
    __metadata$k("design:type", Array)
], RegistrationDetails.prototype, "files", void 0);
class Registration extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "companyId", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "created", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", RegistrationDetails)
], Registration.prototype, "details", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "id", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Flow)
], Registration.prototype, "flow", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "modified", void 0);
__decorate$k([
    Property({ type: RegistrationStep }),
    __metadata$k("design:type", Array)
], Registration.prototype, "steps", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "status", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Boolean)
], Registration.prototype, "verified", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], Registration.prototype, "userId", void 0);
class RegistrationRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "companyDescription", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "country", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "email", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "flowName", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Boolean)
], RegistrationRequest.prototype, "hasCompany", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "language", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "phoneNo", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationRequest.prototype, "voucherCode", void 0);
class RegistrationUpdateRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], RegistrationUpdateRequest.prototype, "id", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], RegistrationUpdateRequest.prototype, "meta", void 0);
class RegistrationListResponse extends BaseModel {
}
__decorate$k([
    Property({ type: Registration }),
    __metadata$k("design:type", Array)
], RegistrationListResponse.prototype, "data", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Number)
], RegistrationListResponse.prototype, "length", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Number)
], RegistrationListResponse.prototype, "offset", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Number)
], RegistrationListResponse.prototype, "total", void 0);
class CompanyRegistrationUpdateRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", RegistrationApplication)
], CompanyRegistrationUpdateRequest.prototype, "application", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "companyId", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "userId", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "email", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "phoneNo", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "language", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "voucherCode", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "companyDescription", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "status", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CompanyRegistrationUpdateRequest.prototype, "flowName", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], CompanyRegistrationUpdateRequest.prototype, "meta", void 0);
__decorate$k([
    Property({ type: BusinessOperationActivity }),
    __metadata$k("design:type", Array)
], CompanyRegistrationUpdateRequest.prototype, "activities", void 0);
class CreateRegistrationStepRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", Author)
], CreateRegistrationStepRequest.prototype, "author", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CreateRegistrationStepRequest.prototype, "stepName", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CreateRegistrationStepRequest.prototype, "dueDate", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], CreateRegistrationStepRequest.prototype, "meta", void 0);
class CommentAuthor extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentAuthor.prototype, "identity", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentAuthor.prototype, "type", void 0);
class CommentMessage extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", CommentAuthor)
], CommentMessage.prototype, "author", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "content", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "contentType", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "created", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "identity", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "messageType", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "supportSubType", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CommentMessage.prototype, "title", void 0);
class UpdateStepRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", CommentMessage)
], UpdateStepRequest.prototype, "comment", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], UpdateStepRequest.prototype, "dueDate", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], UpdateStepRequest.prototype, "meta", void 0);
var REGISTRATION_FORM_PDF;
(function (REGISTRATION_FORM_PDF) {
    REGISTRATION_FORM_PDF["FORM_816"] = "816";
    REGISTRATION_FORM_PDF["ARTICLES_OF_ASSOCIATION"] = "bolagsordning";
    REGISTRATION_FORM_PDF["MEMORANDUM_OF_ASSOCIATION"] = "stiftelseurkund";
})(REGISTRATION_FORM_PDF || (REGISTRATION_FORM_PDF = {}));
class CreateRegistrationFileRequest extends BaseModel {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CreateRegistrationFileRequest.prototype, "assetId", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CreateRegistrationFileRequest.prototype, "name", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], CreateRegistrationFileRequest.prototype, "type", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Author)
], CreateRegistrationFileRequest.prototype, "author", void 0);
__decorate$k([
    Property(),
    __metadata$k("design:type", Object)
], CreateRegistrationFileRequest.prototype, "meta", void 0);

var __decorate$j = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$j = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION;
(function (REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION) {
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION["FAILED"] = "FAILED";
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION["IN_REVIEW"] = "IN_REVIEW";
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION["PENDING"] = "PENDING";
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION["RESOLVED"] = "RESOLVED";
})(REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION || (REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION = {}));
var REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER;
(function (REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER) {
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER["SE_SHB"] = "SE_SHB";
    REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER["SE_SEB"] = "SE_SEB";
})(REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER || (REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER = {}));
class Debtor extends BaseModel {
}
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], Debtor.prototype, "name", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Account)
], Debtor.prototype, "account", void 0);
class TransactionResolution extends BaseModel {
}
__decorate$j([
    Property(),
    __metadata$j("design:type", Amount)
], TransactionResolution.prototype, "amount", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Reference)
], TransactionResolution.prototype, "reference", void 0);
class RemoteAccountEntryTransaction extends BaseModel {
}
__decorate$j([
    Property(),
    __metadata$j("design:type", Amount)
], RemoteAccountEntryTransaction.prototype, "amount", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Amount)
], RemoteAccountEntryTransaction.prototype, "balance", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "date", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Debtor)
], RemoteAccountEntryTransaction.prototype, "debtor", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "entryId", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Number)
], RemoteAccountEntryTransaction.prototype, "entryIndex", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", ForexAmount)
], RemoteAccountEntryTransaction.prototype, "forexAmount", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "information", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "provider", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Object)
], RemoteAccountEntryTransaction.prototype, "providerMetadata", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "resolution", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Reference)
], RemoteAccountEntryTransaction.prototype, "resolutionReference", void 0);
__decorate$j([
    Property({ type: TransactionResolution }),
    __metadata$j("design:type", Array)
], RemoteAccountEntryTransaction.prototype, "resolutionReferences", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "sourceAccountId", void 0);
__decorate$j([
    Property({ type: RemittanceInfo }),
    __metadata$j("design:type", Array)
], RemoteAccountEntryTransaction.prototype, "transactionReferences", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransaction.prototype, "type", void 0);
class ResolvableTransaction extends RemoteAccountEntryTransaction {
}
class ResolvableTransactionListResponse extends BaseModel {
}
__decorate$j([
    Property({ type: ResolvableTransaction }),
    __metadata$j("design:type", Array)
], ResolvableTransactionListResponse.prototype, "data", void 0);
class RemoteAccountEntryTransactionResolveRequest extends BaseModel {
}
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], RemoteAccountEntryTransactionResolveRequest.prototype, "entryId", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Number)
], RemoteAccountEntryTransactionResolveRequest.prototype, "entryIndex", void 0);
__decorate$j([
    Property(),
    __metadata$j("design:type", Reference)
], RemoteAccountEntryTransactionResolveRequest.prototype, "resolutionReference", void 0);
__decorate$j([
    Property({ type: TransactionResolution }),
    __metadata$j("design:type", Array)
], RemoteAccountEntryTransactionResolveRequest.prototype, "resolutionReferences", void 0);
class ResolvableTransactionResolveRequest extends RemoteAccountEntryTransactionResolveRequest {
}

var __decorate$i = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$i = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DYNAMIC_REPORT_TYPE;
(function (DYNAMIC_REPORT_TYPE) {
    DYNAMIC_REPORT_TYPE["COMPANIES_WITH_PRELIMINARY_TAX"] = "COMPANIES_WITH_PRELIMINARY_TAX";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITH_EMPLOYEES"] = "COMPANIES_WITH_EMPLOYEES";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITH_VAT"] = "COMPANIES_WITH_VAT";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITH_EMPLOYER_RETURN"] = "COMPANIES_WITH_EMPLOYER_RETURN";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITH_MULTI_SALARY_ISSUE"] = "COMPANIES_WITH_MULTI_SALARY_ISSUE";
    DYNAMIC_REPORT_TYPE["ACTIVE_COMPANY_BANK_BALANCES"] = "ACTIVE_COMPANY_BANK_BALANCES";
    DYNAMIC_REPORT_TYPE["SOLE_TRADER_TAX_REPORT"] = "SOLE_TRADER_TAX_REPORT";
    DYNAMIC_REPORT_TYPE["ACTIVE_COMPANIES"] = "ACTIVE_COMPANIES";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITHOUT_VAT_PERMIT"] = "COMPANIES_WITHOUT_VAT_PERMIT";
    DYNAMIC_REPORT_TYPE["SOLE_TRADER_DEPRECIABLES"] = "SOLE_TRADER_DEPRECIABLES";
    DYNAMIC_REPORT_TYPE["LLC_DEPRECIABLES"] = "LLC_DEPRECIABLES";
    DYNAMIC_REPORT_TYPE["SOLE_TRADER_TAX_REPORT_CURRENT_YEAR"] = "SOLE_TRADER_TAX_REPORT_CURRENT_YEAR";
    DYNAMIC_REPORT_TYPE["COMPANIES_WITHOUT_EMPLOYER_PERMIT"] = "COMPANIES_WITHOUT_EMPLOYER_PERMIT";
    DYNAMIC_REPORT_TYPE["LLC_COA"] = "LLC_COA";
    DYNAMIC_REPORT_TYPE["SOLE_COA"] = "SOLE_COA";
    DYNAMIC_REPORT_TYPE["SOLE_TRADER_TAX_CALCULATION"] = "SOLE_TRADER_TAX_CALCULATION";
    DYNAMIC_REPORT_TYPE["ACCOUNT_ENTRIES"] = "ACCOUNT_ENTRIES";
    DYNAMIC_REPORT_TYPE["SIE_GENERATOR"] = "SIE_GENERATOR";
})(DYNAMIC_REPORT_TYPE || (DYNAMIC_REPORT_TYPE = {}));
var DYNAMIC_REPORT_FORMAT;
(function (DYNAMIC_REPORT_FORMAT) {
    DYNAMIC_REPORT_FORMAT["JSON"] = "json";
    DYNAMIC_REPORT_FORMAT["XLS"] = "xls";
    DYNAMIC_REPORT_FORMAT["SIE"] = "sie";
})(DYNAMIC_REPORT_FORMAT || (DYNAMIC_REPORT_FORMAT = {}));
var DYNAMIC_REPORT_CELL_DATA_TYPE;
(function (DYNAMIC_REPORT_CELL_DATA_TYPE) {
    DYNAMIC_REPORT_CELL_DATA_TYPE["TEXT"] = "TEXT";
    DYNAMIC_REPORT_CELL_DATA_TYPE["INTEGER"] = "INTEGER";
    DYNAMIC_REPORT_CELL_DATA_TYPE["DOUBLE"] = "DOUBLE";
    DYNAMIC_REPORT_CELL_DATA_TYPE["CURRENCY"] = "CURRENCY";
    DYNAMIC_REPORT_CELL_DATA_TYPE["DATE"] = "DATE";
    DYNAMIC_REPORT_CELL_DATA_TYPE["LINK"] = "LINK";
    DYNAMIC_REPORT_CELL_DATA_TYPE["FORMULA"] = "FORMULA";
})(DYNAMIC_REPORT_CELL_DATA_TYPE || (DYNAMIC_REPORT_CELL_DATA_TYPE = {}));
class DynamicReport extends BaseModel {
}
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], DynamicReport.prototype, "name", void 0);
__decorate$i([
    Property({ type: DYNAMIC_REPORT_TYPE }),
    __metadata$i("design:type", String)
], DynamicReport.prototype, "type", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], DynamicReport.prototype, "description", void 0);
__decorate$i([
    Property({ type: DYNAMIC_REPORT_FORMAT }),
    __metadata$i("design:type", Array)
], DynamicReport.prototype, "formats", void 0);
class DynamicReportList extends BaseModel {
}
__decorate$i([
    Property({ type: DynamicReport }),
    __metadata$i("design:type", Array)
], DynamicReportList.prototype, "reports", void 0);
class DynamicReportCell extends BaseModel {
}
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], DynamicReportCell.prototype, "dataType", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", Object)
], DynamicReportCell.prototype, "value", void 0);
class DynamicReportRow extends BaseModel {
}
__decorate$i([
    Property({ type: DynamicReportCell }),
    __metadata$i("design:type", Array)
], DynamicReportRow.prototype, "cells", void 0);
class DynamicReportData extends BaseModel {
}
__decorate$i([
    Property(),
    __metadata$i("design:type", DynamicReportRow)
], DynamicReportData.prototype, "headerRow", void 0);
__decorate$i([
    Property({ type: DynamicReportRow }),
    __metadata$i("design:type", Array)
], DynamicReportData.prototype, "data", void 0);

var __decorate$h = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$h = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyReconciliationBalances extends BaseModel {
}
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "accountTotal", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "accountCash", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "accountReserved", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "bookkeepingBank", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "bookkeepingReserved", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "salaryPending", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", Amount)
], CompanyReconciliationBalances.prototype, "diff", void 0);

var __decorate$g = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$g = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var REPORT_TYPE;
(function (REPORT_TYPE) {
    REPORT_TYPE["BALANCE_REPORT"] = "BALANCE_REPORT";
    REPORT_TYPE["PROFIT_LOSS_REPORT"] = "PROFIT_LOSS_REPORT";
})(REPORT_TYPE || (REPORT_TYPE = {}));
var MONETORY_ITEM_FORMAT;
(function (MONETORY_ITEM_FORMAT) {
    MONETORY_ITEM_FORMAT["NUMBER_COMMA"] = "NUMBER_COMMA";
    MONETORY_ITEM_FORMAT["NUMBER_SPACE_COMMA"] = "NUMBER_SPACE_COMMA";
})(MONETORY_ITEM_FORMAT || (MONETORY_ITEM_FORMAT = {}));
class MonetaryItem extends BaseModel {
}
__decorate$g([
    Property({ type: PAYMENT_TYPE }),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "accountDirection", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "period", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "decimals", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "tupleRef", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "order", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", Number)
], MonetaryItem.prototype, "scale", void 0);
__decorate$g([
    Property({ type: MONETORY_ITEM_FORMAT }),
    __metadata$g("design:type", String)
], MonetaryItem.prototype, "format", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", Amount)
], MonetaryItem.prototype, "amount", void 0);
class MonetaryGroup extends BaseModel {
    getMonetaryItemByPeriodId(periodId) {
        return this.monetaryItems[periodId];
    }
}
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], MonetaryGroup.prototype, "label", void 0);
__decorate$g([
    Property({ type: MonetaryGroup }),
    __metadata$g("design:type", Array)
], MonetaryGroup.prototype, "children", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", Object)
], MonetaryGroup.prototype, "monetaryItems", void 0);
__decorate$g([
    Property({ type: Number }),
    __metadata$g("design:type", Array)
], MonetaryGroup.prototype, "noteReference", void 0);
class Report extends BaseModel {
}
__decorate$g([
    Property({ type: REPORT_TYPE }),
    __metadata$g("design:type", String)
], Report.prototype, "type", void 0);
__decorate$g([
    Property({ type: CURRENCY }),
    __metadata$g("design:type", String)
], Report.prototype, "currency", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], Report.prototype, "companyId", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], Report.prototype, "companyName", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], Report.prototype, "companyIdentifier", void 0);
__decorate$g([
    Property({ type: MonetaryGroup }),
    __metadata$g("design:type", Array)
], Report.prototype, "sections", void 0);
__decorate$g([
    Property({ type: ReportPeriod }),
    __metadata$g("design:type", Array)
], Report.prototype, "periods", void 0);
class DownloadableReportResponse extends BaseModel {
}
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], DownloadableReportResponse.prototype, "assetId", void 0);

var __decorate$f = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$f = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class RerenderReportRequest extends BaseModel {
}
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], RerenderReportRequest.prototype, "companyId", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], RerenderReportRequest.prototype, "fiscalEndDate", void 0);

var __decorate$e = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$e = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ROYALTY_STATEMENT_STATUS;
(function (ROYALTY_STATEMENT_STATUS) {
    ROYALTY_STATEMENT_STATUS["BOOKED"] = "BOOKED";
    ROYALTY_STATEMENT_STATUS["CANCELLED"] = "CANCELLED";
    ROYALTY_STATEMENT_STATUS["DELETED"] = "DELETED";
    ROYALTY_STATEMENT_STATUS["IN_REVIEW"] = "IN_REVIEW";
    ROYALTY_STATEMENT_STATUS["PENDING"] = "PENDING";
    ROYALTY_STATEMENT_STATUS["REJECTED"] = "REJECTED";
    ROYALTY_STATEMENT_STATUS["RESOLVED"] = "RESOLVED";
    ROYALTY_STATEMENT_STATUS["COMPLETE"] = "COMPLETE";
})(ROYALTY_STATEMENT_STATUS || (ROYALTY_STATEMENT_STATUS = {}));
var ROYALTY_STATEMENT_SORT;
(function (ROYALTY_STATEMENT_SORT) {
    ROYALTY_STATEMENT_SORT["CREATED"] = "CREATED";
    ROYALTY_STATEMENT_SORT["MODIFIED"] = "MODIFIED";
    ROYALTY_STATEMENT_SORT["PAYMENT_DATE"] = "PAYMENT_DATE";
    ROYALTY_STATEMENT_SORT["AMOUNT_PAID"] = "AMOUNT_PAID";
    ROYALTY_STATEMENT_SORT["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
    ROYALTY_STATEMENT_SORT["COMPANY_ID"] = "COMPANY_ID";
    ROYALTY_STATEMENT_SORT["ORIGIN"] = "ORIGIN";
})(ROYALTY_STATEMENT_SORT || (ROYALTY_STATEMENT_SORT = {}));
var ROYALTY_STATEMENT_SORT_DIRECTION;
(function (ROYALTY_STATEMENT_SORT_DIRECTION) {
    ROYALTY_STATEMENT_SORT_DIRECTION["ASC"] = "ASC";
    ROYALTY_STATEMENT_SORT_DIRECTION["DESC"] = "DESC";
})(ROYALTY_STATEMENT_SORT_DIRECTION || (ROYALTY_STATEMENT_SORT_DIRECTION = {}));
var ROYALTY_STATEMENT_ORIGIN;
(function (ROYALTY_STATEMENT_ORIGIN) {
    ROYALTY_STATEMENT_ORIGIN["APPLE"] = "APPLE";
    ROYALTY_STATEMENT_ORIGIN["EWORK"] = "EWORK";
    ROYALTY_STATEMENT_ORIGIN["GOOGLE"] = "GOOGLE";
    ROYALTY_STATEMENT_ORIGIN["KVADRAT"] = "KVADRAT";
    ROYALTY_STATEMENT_ORIGIN["YOUTUBE"] = "YOUTUBE";
    ROYALTY_STATEMENT_ORIGIN["SVT"] = "SVT";
    ROYALTY_STATEMENT_ORIGIN["ZERO_CHAOS"] = "ZERO_CHAOS";
    ROYALTY_STATEMENT_ORIGIN["SARAH_ENTERPRIZES"] = "SARAH_ENTERPRIZES";
    ROYALTY_STATEMENT_ORIGIN["VIDEOSLOTS_PANDA_MEDIA"] = "VIDEOSLOTS_PANDA_MEDIA";
    ROYALTY_STATEMENT_ORIGIN["BETFAIR"] = "BETFAIR";
    ROYALTY_STATEMENT_ORIGIN["KRY"] = "KRY";
    ROYALTY_STATEMENT_ORIGIN["IQ_NAVIGATOR"] = "IQ_NAVIGATOR";
    ROYALTY_STATEMENT_ORIGIN["MATCHING_VISIONS"] = "MATCHING_VISIONS";
    ROYALTY_STATEMENT_ORIGIN["STIM_SAMI"] = "STIM_SAMI";
    ROYALTY_STATEMENT_ORIGIN["AHUM"] = "AHUM";
    ROYALTY_STATEMENT_ORIGIN["LETS_DEAL"] = "LETS_DEAL";
    ROYALTY_STATEMENT_ORIGIN["GUINEAPIG"] = "GUINEAPIG";
    ROYALTY_STATEMENT_ORIGIN["PRB"] = "PRB";
    ROYALTY_STATEMENT_ORIGIN["TWITCH_TV"] = "TWITCH_TV";
    ROYALTY_STATEMENT_ORIGIN["NAYAX"] = "NAYAX";
    ROYALTY_STATEMENT_ORIGIN["BEROTEC_AB"] = "BEROTEC_AB";
    ROYALTY_STATEMENT_ORIGIN["POSTFORSKOTT"] = "POSTFORSKOTT";
    ROYALTY_STATEMENT_ORIGIN["JAY_PRODUCTIONS"] = "JAY_PRODUCTIONS";
    ROYALTY_STATEMENT_ORIGIN["UNKNOWN"] = "UNKNOWN";
})(ROYALTY_STATEMENT_ORIGIN || (ROYALTY_STATEMENT_ORIGIN = {}));
class RoyaltyStatement extends BaseModel {
    get resourceUrl() {
        return this.assetId ? `/api/asset/${this.assetId}` : null;
    }
}
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "id", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "companyId", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "userId", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "assetId", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "bookkeepingDataId", void 0);
__decorate$e([
    Property({ type: ROYALTY_STATEMENT_STATUS }),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "status", void 0);
__decorate$e([
    Property({ type: PAYMENT_STATUS }),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "paymentStatus", void 0);
__decorate$e([
    Property({ type: ROYALTY_STATEMENT_ORIGIN }),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "royaltyOrigin", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "description", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "invalidationMessage", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "createdDate", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "modifiedDate", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "paymentDate", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatement.prototype, "royaltyStatementDate", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Amount)
], RoyaltyStatement.prototype, "amountPaid", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Amount)
], RoyaltyStatement.prototype, "totalAmount", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Amount)
], RoyaltyStatement.prototype, "totalVat", void 0);
__decorate$e([
    Property({ type: VatAmount }),
    __metadata$e("design:type", Array)
], RoyaltyStatement.prototype, "vatAmounts", void 0);
class UpdateRoyaltyStatementAmountRequest extends BaseModel {
}
__decorate$e([
    Property(),
    __metadata$e("design:type", Amount)
], UpdateRoyaltyStatementAmountRequest.prototype, "totalAmount", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Amount)
], UpdateRoyaltyStatementAmountRequest.prototype, "totalVat", void 0);
__decorate$e([
    Property({ type: VatAmount }),
    __metadata$e("design:type", Array)
], UpdateRoyaltyStatementAmountRequest.prototype, "vatAmounts", void 0);
class UpdateRoyaltyStatementStatusRequest extends BaseModel {
}
__decorate$e([
    Property({ type: ROYALTY_STATEMENT_STATUS }),
    __metadata$e("design:type", String)
], UpdateRoyaltyStatementStatusRequest.prototype, "statementStatus", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], UpdateRoyaltyStatementStatusRequest.prototype, "message", void 0);
class RoyaltyStatementListResponse extends BaseModel {
}
__decorate$e([
    Property({ type: RoyaltyStatement }),
    __metadata$e("design:type", Array)
], RoyaltyStatementListResponse.prototype, "data", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Number)
], RoyaltyStatementListResponse.prototype, "length", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Number)
], RoyaltyStatementListResponse.prototype, "offset", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", Number)
], RoyaltyStatementListResponse.prototype, "total", void 0);
class RoyaltyStatementUpdateRequest extends BaseModel {
}
__decorate$e([
    Property({ type: ROYALTY_STATEMENT_ORIGIN }),
    __metadata$e("design:type", String)
], RoyaltyStatementUpdateRequest.prototype, "royaltyOrigin", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatementUpdateRequest.prototype, "description", void 0);
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], RoyaltyStatementUpdateRequest.prototype, "royaltyStatementDate", void 0);

var __decorate$d = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$d = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanySearchResult extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], CompanySearchResult.prototype, "companyName", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], CompanySearchResult.prototype, "town", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], CompanySearchResult.prototype, "roaringCompanyId", void 0);
class CompanySearchResultListResponse extends BaseModel {
}
__decorate$d([
    Property({ type: CompanySearchResult }),
    __metadata$d("design:type", Array)
], CompanySearchResultListResponse.prototype, "data", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], CompanySearchResultListResponse.prototype, "length", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], CompanySearchResultListResponse.prototype, "offset", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], CompanySearchResultListResponse.prototype, "total", void 0);
var ORGANISATION_RECORD_RESULT_TYPE;
(function (ORGANISATION_RECORD_RESULT_TYPE) {
    ORGANISATION_RECORD_RESULT_TYPE["AB"] = "AB";
    ORGANISATION_RECORD_RESULT_TYPE["EF"] = "EF";
    ORGANISATION_RECORD_RESULT_TYPE["HB"] = "HB";
    ORGANISATION_RECORD_RESULT_TYPE["KB"] = "KB";
    ORGANISATION_RECORD_RESULT_TYPE["OVR"] = "OVR";
    ORGANISATION_RECORD_RESULT_TYPE["UNKNOWN"] = "UNKNOWN";
})(ORGANISATION_RECORD_RESULT_TYPE || (ORGANISATION_RECORD_RESULT_TYPE = {}));
// Any misspelling is from roaring service, dont change
var ORGANISATION_RECORD_RESULT_SUBTYPE;
(function (ORGANISATION_RECORD_RESULT_SUBTYPE) {
    ORGANISATION_RECORD_RESULT_SUBTYPE["PRIVATE_LLC"] = "PRIVATE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PUBLIC_LLC"] = "PUBLIC_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PRIVATE_GENRAL_INSURANCE_LLC"] = "PRIVATE_GENRAL_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["INSURANCE_LLC"] = "INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["LIFE_INSURANCE_LLC"] = "LIFE_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PUBLIC_BANK_LLC"] = "PUBLIC_BANK_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PRIVATE_BANK_LLC"] = "PRIVATE_BANK_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PUBLIC_LIFE_INSURANCE_LLC"] = "PUBLIC_LIFE_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PRIVATE_LIFE_INSURANCE_LLC"] = "PRIVATE_LIFE_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PUBLIC_GENRAL_INSURANCE_LLC"] = "PUBLIC_GENRAL_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["LLC"] = "LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["JOINT_STOCK_BANK_LLC"] = "JOINT_STOCK_BANK_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["HOUSING_ASSOCIATION"] = "HOUSING_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["BRANCH_OF_FOREIGN_BANK"] = "BRANCH_OF_FOREIGN_BANK";
    ORGANISATION_RECORD_RESULT_SUBTYPE["TENANT_OWNER_ASSOCIATION"] = "TENANT_OWNER_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["SOLE_TRADER"] = "SOLE_TRADER";
    ORGANISATION_RECORD_RESULT_SUBTYPE["JOINED_OWNED_SHIPPING_CO"] = "JOINED_OWNED_SHIPPING_CO";
    ORGANISATION_RECORD_RESULT_SUBTYPE["EEIG"] = "EEIG";
    ORGANISATION_RECORD_RESULT_SUBTYPE["EGTS"] = "EGTS";
    ORGANISATION_RECORD_RESULT_SUBTYPE["ECONOMIC_ASSOCIATION"] = "ECONOMIC_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["BRANCH_FOREIGN_CO"] = "BRANCH_FOREIGN_CO";
    ORGANISATION_RECORD_RESULT_SUBTYPE["INSURANCE_ASSOCIATION"] = "INSURANCE_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["TRADING_PARTNERSHIP"] = "TRADING_PARTNERSHIP";
    ORGANISATION_RECORD_RESULT_SUBTYPE["NON_PROFIT_ASSOCIATION"] = "NON_PROFIT_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["SECURITY_FUND"] = "SECURITY_FUND";
    ORGANISATION_RECORD_RESULT_SUBTYPE["LIMITED_PARTNERSHIP"] = "LIMITED_PARTNERSHIP";
    ORGANISATION_RECORD_RESULT_SUBTYPE["EUROPEAN_LLC"] = "EUROPEAN_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["COOPERATIVE_TENANT_ASSOCIATION"] = "COOPERATIVE_TENANT_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["EUROPEAN_COOPERATIVE"] = "EUROPEAN_COOPERATIVE";
    ORGANISATION_RECORD_RESULT_SUBTYPE["COMMUNITY_ASSOCIATION"] = "COMMUNITY_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["RELIGIOUS_COMMUNITY"] = "RELIGIOUS_COMMUNITY";
    ORGANISATION_RECORD_RESULT_SUBTYPE["FAMILY_FOUNDATION"] = "FAMILY_FOUNDATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["FOUNDATION"] = "FOUNDATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["GOVERNMENTAL_UNIT"] = "GOVERNMENTAL_UNIT";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MUNICIPALITY"] = "MUNICIPALITY";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MUNICIPALITY_FEDERATION"] = "MUNICIPALITY_FEDERATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["COUNTY_CONCIL"] = "COUNTY_CONCIL";
    ORGANISATION_RECORD_RESULT_SUBTYPE["SOCIAL_INSURANCE"] = "SOCIAL_INSURANCE";
    ORGANISATION_RECORD_RESULT_SUBTYPE["SWEDISH_CHURCH_UNIT"] = "SWEDISH_CHURCH_UNIT";
    ORGANISATION_RECORD_RESULT_SUBTYPE["PUBLIC_INSTITUTION"] = "PUBLIC_INSTITUTION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MORTGAGE_ASSOCIATION"] = "MORTGAGE_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["REGIONAL_GOVERNMENT_DEP"] = "REGIONAL_GOVERNMENT_DEP";
    ORGANISATION_RECORD_RESULT_SUBTYPE["ESTATE_COOWNERSHIP"] = "ESTATE_COOWNERSHIP";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MUTUAL_INSURANCE_LLC"] = "MUTUAL_INSURANCE_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["SAVINGS_BANK"] = "SAVINGS_BANK";
    ORGANISATION_RECORD_RESULT_SUBTYPE["RELEIF_SOCIETY"] = "RELEIF_SOCIETY";
    ORGANISATION_RECORD_RESULT_SUBTYPE["UNEMPLOYMENT_BENEFIT_CO"] = "UNEMPLOYMENT_BENEFIT_CO";
    ORGANISATION_RECORD_RESULT_SUBTYPE["FOREIGN_JURIDICIAL_PERSON"] = "FOREIGN_JURIDICIAL_PERSON";
    ORGANISATION_RECORD_RESULT_SUBTYPE["OTHER_SWEDISH_JURIDICIAL_PERSON"] = "OTHER_SWEDISH_JURIDICIAL_PERSON";
    ORGANISATION_RECORD_RESULT_SUBTYPE["UNKNOWN_JURIDICIAL_FORM"] = "UNKNOWN_JURIDICIAL_FORM";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MEMBERSHIP_BANK"] = "MEMBERSHIP_BANK";
    ORGANISATION_RECORD_RESULT_SUBTYPE["MUTUAL_SERVICE_PENSION_LLC"] = "MUTUAL_SERVICE_PENSION_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["COOPERATIVE_ASSOCIATION"] = "COOPERATIVE_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["OCCUPATIONAL_PENSION_LLC"] = "OCCUPATIONAL_PENSION_LLC";
    ORGANISATION_RECORD_RESULT_SUBTYPE["OCCUPATIONAL_PENSION_ASSOCIATION"] = "OCCUPATIONAL_PENSION_ASSOCIATION";
    ORGANISATION_RECORD_RESULT_SUBTYPE["OTHER"] = "OTHER";
})(ORGANISATION_RECORD_RESULT_SUBTYPE || (ORGANISATION_RECORD_RESULT_SUBTYPE = {}));
class OrganisationRecordResult extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "type", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "subType", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "status", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "name", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "postalStreet", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "postalTown", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "postalCode", void 0);
__decorate$d([
    Property({ type: String }),
    __metadata$d("design:type", Array)
], OrganisationRecordResult.prototype, "industryCodes", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "webAddress", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "organisationNo", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "registrationDate", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Boolean)
], OrganisationRecordResult.prototype, "registeredForVat", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Boolean)
], OrganisationRecordResult.prototype, "registeredForPreliminaryTax", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], OrganisationRecordResult.prototype, "preliminaryTaxRegistrationDate", void 0);
class OrganisationRecordListResponse extends BaseModel {
}
__decorate$d([
    Property({ type: OrganisationRecordResult }),
    __metadata$d("design:type", Array)
], OrganisationRecordListResponse.prototype, "data", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], OrganisationRecordListResponse.prototype, "length", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], OrganisationRecordListResponse.prototype, "offset", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Number)
], OrganisationRecordListResponse.prototype, "total", void 0);
class AreaAddress extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "careOf", void 0);
__decorate$d([
    Property({ type: String }),
    __metadata$d("design:type", Array)
], AreaAddress.prototype, "lines", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "postalCode", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "postalTown", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "countryCode", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "districtCode", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "parishCode", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "municipalityCode", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], AreaAddress.prototype, "countyCode", void 0);
class TypedAreaAddress extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], TypedAreaAddress.prototype, "type", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", AreaAddress)
], TypedAreaAddress.prototype, "address", void 0);
class Person extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", Boolean)
], Person.prototype, "secrecyMarked", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Person.prototype, "personalNumber", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Person.prototype, "birthDate", void 0);
__decorate$d([
    Property({ type: String }),
    __metadata$d("design:type", Array)
], Person.prototype, "firstNames", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Person.prototype, "surName", void 0);
__decorate$d([
    Property({ type: TypedAreaAddress }),
    __metadata$d("design:type", Array)
], Person.prototype, "addresses", void 0);

var __decorate$c = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$c = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SALARY_PAYMENT_STATUS;
(function (SALARY_PAYMENT_STATUS) {
    SALARY_PAYMENT_STATUS["PENDING"] = "PENDING";
    SALARY_PAYMENT_STATUS["DELIVERED"] = "DELIVERED";
    SALARY_PAYMENT_STATUS["REJECTED"] = "REJECTED";
    SALARY_PAYMENT_STATUS["CONFIRMED"] = "CONFIRMED";
    SALARY_PAYMENT_STATUS["CANCELLED"] = "CANCELLED";
})(SALARY_PAYMENT_STATUS || (SALARY_PAYMENT_STATUS = {}));
var SALARY_REQUEST_BASE_AMOUNT_TYPE;
(function (SALARY_REQUEST_BASE_AMOUNT_TYPE) {
    SALARY_REQUEST_BASE_AMOUNT_TYPE["GROSS"] = "GROSS";
    SALARY_REQUEST_BASE_AMOUNT_TYPE["NET"] = "NET";
    SALARY_REQUEST_BASE_AMOUNT_TYPE["TOTAL"] = "TOTAL";
})(SALARY_REQUEST_BASE_AMOUNT_TYPE || (SALARY_REQUEST_BASE_AMOUNT_TYPE = {}));
var SALARY_BENEFIT_STATE;
(function (SALARY_BENEFIT_STATE) {
    SALARY_BENEFIT_STATE["ACTIVE"] = "ACTIVE";
    SALARY_BENEFIT_STATE["DELETED"] = "DELETED";
})(SALARY_BENEFIT_STATE || (SALARY_BENEFIT_STATE = {}));
var SALARY_BENEFIT_TYPE;
(function (SALARY_BENEFIT_TYPE) {
    SALARY_BENEFIT_TYPE["CAR_BENEFIT"] = "CAR_BENEFIT";
})(SALARY_BENEFIT_TYPE || (SALARY_BENEFIT_TYPE = {}));
class SalaryBenefitMetadata extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefitMetadata.prototype, "carModelCode", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefitMetadata.prototype, "carLicencePlate", void 0);
class SalaryPayment extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryPayment.prototype, "companyId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryPayment.prototype, "userId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryPayment.prototype, "salaryPaymentDate", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryPayment.prototype, "benefitId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], SalaryPayment.prototype, "value", void 0);
class SalaryBenefit extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "id", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "companyId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "userId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "state", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], SalaryBenefit.prototype, "value", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "type", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "startDate", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefit.prototype, "endDate", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", SalaryBenefitMetadata)
], SalaryBenefit.prototype, "metadata", void 0);
__decorate$c([
    Property({ type: SalaryPayment }),
    __metadata$c("design:type", Array)
], SalaryBenefit.prototype, "salaryPayments", void 0);
class SalaryBenefits extends BaseModel {
}
__decorate$c([
    Property({ type: SalaryBenefit }),
    __metadata$c("design:type", Array)
], SalaryBenefits.prototype, "benefits", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], SalaryBenefits.prototype, "totalValue", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryBenefits.prototype, "salaryPaymentDate", void 0);
class Salary extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "id", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "assetId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "userId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "grossSalary", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "payrollTax", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "taxes", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "netSalary", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "socialFees", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], Salary.prototype, "redflagFees", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "created", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "modified", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "paymentMessage", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], Salary.prototype, "paymentStatus", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", SalaryBenefits)
], Salary.prototype, "benefit", void 0);
class SalaryRequest extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryRequest.prototype, "paymentMessage", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryRequest.prototype, "recipientUserId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], SalaryRequest.prototype, "fromCompanyId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", Amount)
], SalaryRequest.prototype, "baseAmount", void 0);
class SalaryList extends BaseModel {
}
__decorate$c([
    Property({ type: Salary }),
    __metadata$c("design:type", Array)
], SalaryList.prototype, "data", void 0);

var __decorate$b = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$b = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PAYMENT_REFERENCE_TYPE;
(function (PAYMENT_REFERENCE_TYPE) {
    PAYMENT_REFERENCE_TYPE["MESSAGE"] = "MESSAGE";
    PAYMENT_REFERENCE_TYPE["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    PAYMENT_REFERENCE_TYPE["UNKNOWN"] = "UNKNOWN";
    PAYMENT_REFERENCE_TYPE["OCR"] = "OCR";
})(PAYMENT_REFERENCE_TYPE || (PAYMENT_REFERENCE_TYPE = {}));
class InternalCompany extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], InternalCompany.prototype, "companyId", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], InternalCompany.prototype, "companyName", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], InternalCompany.prototype, "status", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], InternalCompany.prototype, "type", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Amount)
], InternalCompany.prototype, "amount", void 0);
class PaymentReference extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], PaymentReference.prototype, "type", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], PaymentReference.prototype, "value", void 0);
class Payment extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", PaymentReference)
], Payment.prototype, "paymentReference", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Reference)
], Payment.prototype, "reportReference", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], Payment.prototype, "date", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], Payment.prototype, "status", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Amount)
], Payment.prototype, "amount", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], Payment.prototype, "type", void 0);
class ReportCommandSent extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "companyId", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "commandId", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "companyName", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "companyType", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "type", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "assetId", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "start", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "end", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "period", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "created", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ReportCommandSent.prototype, "correctionForCommandId", void 0);
__decorate$b([
    Property({ type: Payment }),
    __metadata$b("design:type", Array)
], ReportCommandSent.prototype, "payments", void 0);
class CalendarForecast extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], CalendarForecast.prototype, "due", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], CalendarForecast.prototype, "type", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], CalendarForecast.prototype, "interval", void 0);
__decorate$b([
    Property({ type: InternalCompany }),
    __metadata$b("design:type", Array)
], CalendarForecast.prototype, "companies", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Number)
], CalendarForecast.prototype, "count", void 0);
class ExecutedCommand extends BaseModel {
}
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ExecutedCommand.prototype, "due", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", String)
], ExecutedCommand.prototype, "type", void 0);
__decorate$b([
    Property({ type: ReportCommandSent }),
    __metadata$b("design:type", Array)
], ExecutedCommand.prototype, "commands", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Number)
], ExecutedCommand.prototype, "count", void 0);
class PaymentScheduleCalendarResponse extends BaseModel {
}
__decorate$b([
    Property({ type: CalendarForecast }),
    __metadata$b("design:type", Array)
], PaymentScheduleCalendarResponse.prototype, "forecast", void 0);
__decorate$b([
    Property({ type: ExecutedCommand }),
    __metadata$b("design:type", Array)
], PaymentScheduleCalendarResponse.prototype, "executed", void 0);

var AUTH_STRATEGY;
(function (AUTH_STRATEGY) {
    AUTH_STRATEGY["BANK_ID"] = "bankid";
})(AUTH_STRATEGY || (AUTH_STRATEGY = {}));
var BANKID_ERROR_STATE;
(function (BANKID_ERROR_STATE) {
    BANKID_ERROR_STATE["RETRY"] = "RETRY";
    BANKID_ERROR_STATE["CLIENT_ERR"] = "CLIENT_ERR";
    BANKID_ERROR_STATE["EXPIRED_TRANSACTION"] = "EXPIRED_TRANSACTION";
    BANKID_ERROR_STATE["CERTIFICATE_ERR"] = "CERTIFICATE_ERR";
    BANKID_ERROR_STATE["USER_CANCEL"] = "USER_CANCEL";
    BANKID_ERROR_STATE["CANCELLED"] = "CANCELLED";
})(BANKID_ERROR_STATE || (BANKID_ERROR_STATE = {}));
var BANKID_RETRY_STATE;
(function (BANKID_RETRY_STATE) {
    BANKID_RETRY_STATE["RF_RETRY"] = "RF_RETRY";
    BANKID_RETRY_STATE["COMPLETE"] = "COMPLETE";
    BANKID_RETRY_STATE["OUTSTANDING_TRANSACTION"] = "OUTSTANDING_TRANSACTION";
    BANKID_RETRY_STATE["NO_CLIENT"] = "NO_CLIENT";
    BANKID_RETRY_STATE["STARTED"] = "STARTED";
    BANKID_RETRY_STATE["USER_SIGN"] = "USER_SIGN";
})(BANKID_RETRY_STATE || (BANKID_RETRY_STATE = {}));

var __decorate$a = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$a = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class AuthCredentials extends BaseModel {
}
__decorate$a([
    Property(),
    __metadata$a("design:type", String)
], AuthCredentials.prototype, "identifier", void 0);
__decorate$a([
    Property({ type: AUTH_STRATEGY }),
    __metadata$a("design:type", String)
], AuthCredentials.prototype, "strategy", void 0);
__decorate$a([
    Property({ type: ROLE, defaultValue: ROLE.OWNER }),
    __metadata$a("design:type", String)
], AuthCredentials.prototype, "scope", void 0);
class AuthStartResponse extends BaseModel {
}
__decorate$a([
    Property(),
    __metadata$a("design:type", String)
], AuthStartResponse.prototype, "authReference", void 0);
__decorate$a([
    Property(),
    __metadata$a("design:type", String)
], AuthStartResponse.prototype, "autostartToken", void 0);
class AuthResponse extends BaseModel {
}
__decorate$a([
    Property({ type: BANKID_RETRY_STATE }),
    __metadata$a("design:type", String)
], AuthResponse.prototype, "status", void 0);
__decorate$a([
    Property(),
    __metadata$a("design:type", String)
], AuthResponse.prototype, "sessionToken", void 0);

var __decorate$9 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$9 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Stock extends BaseModel {
}
__decorate$9([
    Property(),
    __metadata$9("design:type", String)
], Stock.prototype, "companyId", void 0);
__decorate$9([
    Property(),
    __metadata$9("design:type", String)
], Stock.prototype, "date", void 0);
__decorate$9([
    Property(),
    __metadata$9("design:type", Number)
], Stock.prototype, "totalNumberOfShares", void 0);
__decorate$9([
    Property(),
    __metadata$9("design:type", Amount)
], Stock.prototype, "totalShareholderCapital", void 0);

var __decorate$8 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$8 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SIE_VALIDATION_ERROR_TYPE;
(function (SIE_VALIDATION_ERROR_TYPE) {
    SIE_VALIDATION_ERROR_TYPE["BAD_ENCODING"] = "BAD_ENCODING";
    SIE_VALIDATION_ERROR_TYPE["INCOMPLETE_DATA"] = "INCOMPLETE_DATA";
    SIE_VALIDATION_ERROR_TYPE["UNBALANCED_HISTORY"] = "UNBALANCED_HISTORY";
    SIE_VALIDATION_ERROR_TYPE["UNBALANCED_TRANSACTIONS"] = "UNBALANCED_TRANSACTIONS";
    SIE_VALIDATION_ERROR_TYPE["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(SIE_VALIDATION_ERROR_TYPE || (SIE_VALIDATION_ERROR_TYPE = {}));
class SieValidationInformation extends BaseModel {
}
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationInformation.prototype, "message", void 0);
class SieValidatedFiscalYear extends BaseModel {
}
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidatedFiscalYear.prototype, "startDate", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidatedFiscalYear.prototype, "endDate", void 0);
__decorate$8([
    Property({ type: CompanyBookedBalance }),
    __metadata$8("design:type", Array)
], SieValidatedFiscalYear.prototype, "closingBalances", void 0);
__decorate$8([
    Property({ type: CompanyBookedBalance }),
    __metadata$8("design:type", Array)
], SieValidatedFiscalYear.prototype, "openingBalances", void 0);
__decorate$8([
    Property({ type: CompanyBookedBalance }),
    __metadata$8("design:type", Array)
], SieValidatedFiscalYear.prototype, "results", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Boolean)
], SieValidatedFiscalYear.prototype, "currentFiscalYear", void 0);
class SieValidationResponse extends BaseModel {
}
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "id", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "requestTime", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "sieAssetId", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "ledgerAssetId", void 0);
__decorate$8([
    Property({ type: SIE_VALIDATION_ERROR_TYPE }),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "validationErrorType", void 0);
__decorate$8([
    Property({ type: String }),
    __metadata$8("design:type", Array)
], SieValidationResponse.prototype, "errors", void 0);
__decorate$8([
    Property({ type: SieValidationInformation }),
    __metadata$8("design:type", Array)
], SieValidationResponse.prototype, "conversionEvents", void 0);
__decorate$8([
    Property({ type: SieValidatedFiscalYear }),
    __metadata$8("design:type", Array)
], SieValidationResponse.prototype, "fiscalYears", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "companyOrgIdentifier", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", String)
], SieValidationResponse.prototype, "companyName", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Amount)
], SieValidationResponse.prototype, "pendingReceivables", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Amount)
], SieValidationResponse.prototype, "pendingPayables", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Amount)
], SieValidationResponse.prototype, "bankBalance", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Boolean)
], SieValidationResponse.prototype, "valid", void 0);

var __decorate$7 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$7 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class SendSmsRequest extends BaseModel {
}
__decorate$7([
    Property(),
    __metadata$7("design:type", String)
], SendSmsRequest.prototype, "message", void 0);
__decorate$7([
    Property(),
    __metadata$7("design:type", String)
], SendSmsRequest.prototype, "recipient", void 0);
__decorate$7([
    Property(),
    __metadata$7("design:type", String)
], SendSmsRequest.prototype, "sender", void 0);

var __decorate$6 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$6 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SUBSCRIPTION_STATUS;
(function (SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS["ACTIVE"] = "ACTIVE";
    SUBSCRIPTION_STATUS["PAUSED"] = "PAUSED";
    SUBSCRIPTION_STATUS["STOPPED"] = "STOPPED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var VOUCHER_TYPE;
(function (VOUCHER_TYPE) {
    VOUCHER_TYPE["CREATED"] = "CREATED";
    VOUCHER_TYPE["PAID_DEBIT"] = "PAID_DEBIT";
    VOUCHER_TYPE["CREDITED"] = "CREDITED";
    VOUCHER_TYPE["PAID_CREDIT"] = "PAID_CREDIT";
})(VOUCHER_TYPE || (VOUCHER_TYPE = {}));
var SKU_UNIT;
(function (SKU_UNIT) {
    SKU_UNIT["HOUR"] = "HOUR";
    SKU_UNIT["PIECE"] = "PIECE";
})(SKU_UNIT || (SKU_UNIT = {}));
var SKU_TYPE;
(function (SKU_TYPE) {
    SKU_TYPE["AUTOMATIC"] = "AUTOMATIC";
    SKU_TYPE["CART"] = "CART";
    SKU_TYPE["MONTHLY_SUBSCRIPTION"] = "MONTHLY_SUBSCRIPTION";
})(SKU_TYPE || (SKU_TYPE = {}));
class PriceListInfo extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], PriceListInfo.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], PriceListInfo.prototype, "type", void 0);
class Sku extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "identifier", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "description", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "vatClass", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "unit", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Sku.prototype, "type", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], Sku.prototype, "salePrice", void 0);
class PriceList extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], PriceList.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], PriceList.prototype, "type", void 0);
__decorate$6([
    Property({ type: Sku }),
    __metadata$6("design:type", Array)
], PriceList.prototype, "skus", void 0);
class UpdatePriceListRequest extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], UpdatePriceListRequest.prototype, "type", void 0);
class VoucherRow extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], VoucherRow.prototype, "account", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], VoucherRow.prototype, "credit", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], VoucherRow.prototype, "description", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], VoucherRow.prototype, "debit", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], VoucherRow.prototype, "costCenter", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], VoucherRow.prototype, "project", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Boolean)
], VoucherRow.prototype, "removed", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], VoucherRow.prototype, "transactionInformation", void 0);
class Voucher extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "comments", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "description", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "transactionDate", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], Voucher.prototype, "voucherNumber", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "voucherSeries", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], Voucher.prototype, "year", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "costCenter", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "project", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "referenceNumber", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Voucher.prototype, "referenceType", void 0);
__decorate$6([
    Property({ type: VoucherRow }),
    __metadata$6("design:type", Array)
], Voucher.prototype, "voucherRows", void 0);
class SubscriptionVoucher extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionVoucher.prototype, "created", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionVoucher.prototype, "voucherType", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Voucher)
], SubscriptionVoucher.prototype, "voucher", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionVoucher.prototype, "verification", void 0);
class SubscriptionInvoice extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "subscriptionId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "period", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "redflagInvoiceId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "assetId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "customerBillId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "companyId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "paymentStatus", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "paymentStatusDate", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "crediting", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], SubscriptionInvoice.prototype, "creditedBy", void 0);
__decorate$6([
    Property({ type: SubscriptionVoucher }),
    __metadata$6("design:type", Array)
], SubscriptionInvoice.prototype, "vouchers", void 0);
class DetailedSubscriptionInvoice extends SubscriptionInvoice {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], DetailedSubscriptionInvoice.prototype, "invoiceNumber", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscriptionInvoice.prototype, "invoiceDate", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscriptionInvoice.prototype, "expires", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscriptionInvoice.prototype, "companyName", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], DetailedSubscriptionInvoice.prototype, "totalGross", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], DetailedSubscriptionInvoice.prototype, "totalNet", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], DetailedSubscriptionInvoice.prototype, "totalVAT", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], DetailedSubscriptionInvoice.prototype, "totalDue", void 0);
__decorate$6([
    Property({ type: LineItem }),
    __metadata$6("design:type", Array)
], DetailedSubscriptionInvoice.prototype, "items", void 0);
class ValueCode extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ValueCode.prototype, "subscriptionId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ValueCode.prototype, "companyId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ValueCode.prototype, "code", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], ValueCode.prototype, "monthValue", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], ValueCode.prototype, "monthsLeft", void 0);
class Subscription extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "id", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "companyId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "orgNo", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "companyName", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "created", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], Subscription.prototype, "modified", void 0);
__decorate$6([
    Property({ type: SUBSCRIPTION_STATUS }),
    __metadata$6("design:type", String)
], Subscription.prototype, "status", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Boolean)
], Subscription.prototype, "bookWithVAT", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", PriceListInfo)
], Subscription.prototype, "pricelist", void 0);
__decorate$6([
    Property({ type: String }),
    __metadata$6("design:type", Array)
], Subscription.prototype, "invoices", void 0);
__decorate$6([
    Property({ type: ValueCode }),
    __metadata$6("design:type", Array)
], Subscription.prototype, "valueCodes", void 0);
class DetailedSubscription extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "id", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "companyId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "orgNo", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "companyName", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "created", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "modified", void 0);
__decorate$6([
    Property({ type: SUBSCRIPTION_STATUS }),
    __metadata$6("design:type", String)
], DetailedSubscription.prototype, "status", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Boolean)
], DetailedSubscription.prototype, "bookWithVAT", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", PriceListInfo)
], DetailedSubscription.prototype, "pricelist", void 0);
__decorate$6([
    Property({ type: SubscriptionInvoice }),
    __metadata$6("design:type", Array)
], DetailedSubscription.prototype, "invoices", void 0);
__decorate$6([
    Property({ type: ValueCode }),
    __metadata$6("design:type", Array)
], DetailedSubscription.prototype, "valueCodes", void 0);
class SubscriptionListResponse extends BaseModel {
}
__decorate$6([
    Property({ type: Subscription }),
    __metadata$6("design:type", Array)
], SubscriptionListResponse.prototype, "data", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionListResponse.prototype, "length", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionListResponse.prototype, "offset", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionListResponse.prototype, "total", void 0);
class SubscriptionInvoiceList extends BaseModel {
}
__decorate$6([
    Property({ type: SubscriptionInvoice }),
    __metadata$6("design:type", Array)
], SubscriptionInvoiceList.prototype, "invoices", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], SubscriptionInvoiceList.prototype, "totalGross", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionInvoiceList.prototype, "count", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionInvoiceList.prototype, "offset", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], SubscriptionInvoiceList.prototype, "total", void 0);
class DetailedSubscriptionInvoiceList extends BaseModel {
}
__decorate$6([
    Property({ type: DetailedSubscriptionInvoice }),
    __metadata$6("design:type", Array)
], DetailedSubscriptionInvoiceList.prototype, "invoices", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], DetailedSubscriptionInvoiceList.prototype, "totalGross", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], DetailedSubscriptionInvoiceList.prototype, "count", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], DetailedSubscriptionInvoiceList.prototype, "offset", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], DetailedSubscriptionInvoiceList.prototype, "total", void 0);
class InvoicePreviewItem extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "itemId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "description", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "sku", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "skuType", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "vatClassType", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreviewItem.prototype, "customVatClassId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], InvoicePreviewItem.prototype, "count", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Percentage)
], InvoicePreviewItem.prototype, "discount", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], InvoicePreviewItem.prototype, "salePrice", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], InvoicePreviewItem.prototype, "grossPrice", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], InvoicePreviewItem.prototype, "netPrice", void 0);
class InvoicePreview extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreview.prototype, "subscriptionId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreview.prototype, "companyId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreview.prototype, "period", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreview.prototype, "orgNo", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], InvoicePreview.prototype, "companyName", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], InvoicePreview.prototype, "totalGross", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Amount)
], InvoicePreview.prototype, "totalNet", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Boolean)
], InvoicePreview.prototype, "alreadyBilledForPeriod", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", PriceListInfo)
], InvoicePreview.prototype, "pricelist", void 0);
__decorate$6([
    Property({ type: InvoicePreviewItem }),
    __metadata$6("design:type", Array)
], InvoicePreview.prototype, "items", void 0);
class InvoicePreviewList extends BaseModel {
}
__decorate$6([
    Property({ type: InvoicePreview }),
    __metadata$6("design:type", Array)
], InvoicePreviewList.prototype, "previews", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], InvoicePreviewList.prototype, "count", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], InvoicePreviewList.prototype, "offset", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], InvoicePreviewList.prototype, "total", void 0);
class AddValueCodeRequest extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], AddValueCodeRequest.prototype, "voucherTemplateId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], AddValueCodeRequest.prototype, "companyId", void 0);
class UpdateBookWithVatRequest extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], UpdateBookWithVatRequest.prototype, "bookWithVAT", void 0);
class ShoppingCartItem extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ShoppingCartItem.prototype, "itemId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ShoppingCartItem.prototype, "inventoryItemId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ShoppingCartItem.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], ShoppingCartItem.prototype, "count", void 0);
class ShoppingCart extends BaseModel {
}
__decorate$6([
    Property({ type: ShoppingCartItem }),
    __metadata$6("design:type", Array)
], ShoppingCart.prototype, "items", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], ShoppingCart.prototype, "companyId", void 0);
class AddShoppingCartItemRequest extends BaseModel {
}
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], AddShoppingCartItemRequest.prototype, "inventoryItemId", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", String)
], AddShoppingCartItemRequest.prototype, "name", void 0);
__decorate$6([
    Property(),
    __metadata$6("design:type", Number)
], AddShoppingCartItemRequest.prototype, "count", void 0);

var __decorate$5 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$5 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Term extends BaseModel {
}
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], Term.prototype, "id", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], Term.prototype, "version", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], Term.prototype, "title", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], Term.prototype, "locale", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], Term.prototype, "mediaType", void 0);
class TermListResponse extends BaseModel {
}
__decorate$5([
    Property({ type: Term }),
    __metadata$5("design:type", Array)
], TermListResponse.prototype, "data", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", Number)
], TermListResponse.prototype, "length", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", Number)
], TermListResponse.prototype, "offset", void 0);
__decorate$5([
    Property(),
    __metadata$5("design:type", Number)
], TermListResponse.prototype, "total", void 0);

var __decorate$4 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$4 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TRANSACTION_STATUS;
(function (TRANSACTION_STATUS) {
    TRANSACTION_STATUS["PENDING"] = "PENDING";
    TRANSACTION_STATUS["REJECTED"] = "REJECTED";
    TRANSACTION_STATUS["IN_REVIEW"] = "IN_REVIEW";
    TRANSACTION_STATUS["BOOKED"] = "BOOKED";
    TRANSACTION_STATUS["CANCELLED"] = "CANCELLED";
    TRANSACTION_STATUS["DELETED"] = "DELETED";
    TRANSACTION_STATUS["DRAFT"] = "DRAFT";
    TRANSACTION_STATUS["COMPLETE"] = "COMPLETE";
    TRANSACTION_STATUS["IN_USER_REVIEW"] = "IN_USER_REVIEW";
    TRANSACTION_STATUS["RESOLVED"] = "RESOLVED";
    TRANSACTION_STATUS["NA"] = "NA";
})(TRANSACTION_STATUS || (TRANSACTION_STATUS = {}));
var TRANSACTION_SUB_TYPE;
(function (TRANSACTION_SUB_TYPE) {
    TRANSACTION_SUB_TYPE["CASH_EMMISSION"] = "CASH_EMMISSION";
    TRANSACTION_SUB_TYPE["CONTRIBUTION"] = "CONTRIBUTION";
    TRANSACTION_SUB_TYPE["CREDIT"] = "CREDIT";
    TRANSACTION_SUB_TYPE["DEBIT"] = "DEBIT";
    TRANSACTION_SUB_TYPE["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    TRANSACTION_SUB_TYPE["CARD_HOLDER_DEBT"] = "CARD_HOLDER_DEBT";
    TRANSACTION_SUB_TYPE["DIVIDENDS"] = "DIVIDENDS";
    TRANSACTION_SUB_TYPE["VAT"] = "VAT";
    TRANSACTION_SUB_TYPE["SOCIAL_FEES"] = "SOCIAL_FEES";
    TRANSACTION_SUB_TYPE["PENDING_RESOLUTION"] = "PENDING_RESOLUTION";
    TRANSACTION_SUB_TYPE["PRELIMINARY_TAXES"] = "PRELIMINARY_TAXES";
    TRANSACTION_SUB_TYPE["SALARY_TAXES"] = "SALARY_TAXES";
    TRANSACTION_SUB_TYPE["SALARY_TAXES_v2"] = "SALARY_TAXES_v2";
    TRANSACTION_SUB_TYPE["YEARLY_PROFIT_TAX"] = "YEARLY_PROFIT_TAX";
    TRANSACTION_SUB_TYPE["NA"] = "NA";
})(TRANSACTION_SUB_TYPE || (TRANSACTION_SUB_TYPE = {}));
var TRANSACTION_SORTING_DIRECTION;
(function (TRANSACTION_SORTING_DIRECTION) {
    TRANSACTION_SORTING_DIRECTION["ASC"] = "ASC";
    TRANSACTION_SORTING_DIRECTION["DESC"] = "DESC";
})(TRANSACTION_SORTING_DIRECTION || (TRANSACTION_SORTING_DIRECTION = {}));
var TRANSACTION_ORDER_BY;
(function (TRANSACTION_ORDER_BY) {
    TRANSACTION_ORDER_BY["CREATED_AT"] = "CREATED_AT";
    TRANSACTION_ORDER_BY["MODIFIED_AT"] = "MODIFIED_AT";
    TRANSACTION_ORDER_BY["RESOLVED_AT"] = "RESOLVED_AT";
})(TRANSACTION_ORDER_BY || (TRANSACTION_ORDER_BY = {}));
class Transaction extends BaseModel {
    get resourceUrl() {
        return this.assetId ? `api/asset/${this.assetId}` : null;
    }
}
__decorate$4([
    Property(),
    __metadata$4("design:type", Reference)
], Transaction.prototype, "reference", void 0);
__decorate$4([
    Property({ type: Reference }),
    __metadata$4("design:type", Array)
], Transaction.prototype, "references", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "subType", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "status", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "paymentStatus", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "createdAt", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "modifiedAt", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "resolvedAt", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Amount)
], Transaction.prototype, "total", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Amount)
], Transaction.prototype, "forexAmount", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "description", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "direction", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "companyId", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "userId", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Object)
], Transaction.prototype, "attributes", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], Transaction.prototype, "assetId", void 0);
class TransactionListResponse extends BaseModel {
}
__decorate$4([
    Property({ type: Transaction }),
    __metadata$4("design:type", Array)
], TransactionListResponse.prototype, "data", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionListResponse.prototype, "length", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionListResponse.prototype, "offset", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionListResponse.prototype, "total", void 0);
class TransactionList extends BaseModel {
}
__decorate$4([
    Property({ type: Transaction }),
    __metadata$4("design:type", Array)
], TransactionList.prototype, "transactions", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionList.prototype, "length", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionList.prototype, "offset", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", Number)
], TransactionList.prototype, "totalCount", void 0);

var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$3 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class CompanyUser extends BaseModel {
}
__decorate$3([
    Property({ type: Relation }),
    __metadata$3("design:type", Array)
], CompanyUser.prototype, "relations", void 0);
__decorate$3([
    Property(),
    __metadata$3("design:type", User)
], CompanyUser.prototype, "user", void 0);
class CompanyUserListResponse extends BaseModel {
}
__decorate$3([
    Property({ type: CompanyUser }),
    __metadata$3("design:type", Array)
], CompanyUserListResponse.prototype, "data", void 0);
__decorate$3([
    Property(),
    __metadata$3("design:type", Number)
], CompanyUserListResponse.prototype, "length", void 0);
__decorate$3([
    Property(),
    __metadata$3("design:type", Number)
], CompanyUserListResponse.prototype, "offset", void 0);
__decorate$3([
    Property(),
    __metadata$3("design:type", Number)
], CompanyUserListResponse.prototype, "total", void 0);

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var USER_TIMELINE_EVENT_TYPE;
(function (USER_TIMELINE_EVENT_TYPE) {
    USER_TIMELINE_EVENT_TYPE["ACTIVATED"] = "ACTIVATED";
    USER_TIMELINE_EVENT_TYPE["BOOKED"] = "BOOKED";
    USER_TIMELINE_EVENT_TYPE["CANCELLED"] = "CANCELLED";
    USER_TIMELINE_EVENT_TYPE["COMPLETE"] = "COMPLETE";
    USER_TIMELINE_EVENT_TYPE["CREATED"] = "CREATED";
    USER_TIMELINE_EVENT_TYPE["DELETED"] = "DELETED";
    USER_TIMELINE_EVENT_TYPE["LOGIN"] = "LOGIN";
    USER_TIMELINE_EVENT_TYPE["PAYMENT"] = "PAYMENT";
    USER_TIMELINE_EVENT_TYPE["UPDATED"] = "UPDATED";
})(USER_TIMELINE_EVENT_TYPE || (USER_TIMELINE_EVENT_TYPE = {}));
class UserTimelineEvent extends BaseModel {
}
__decorate$2([
    Property(),
    __metadata$2("design:type", Amount)
], UserTimelineEvent.prototype, "amount", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Object)
], UserTimelineEvent.prototype, "attributes", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", String)
], UserTimelineEvent.prototype, "id", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Reference)
], UserTimelineEvent.prototype, "entity", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", String)
], UserTimelineEvent.prototype, "time", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", String)
], UserTimelineEvent.prototype, "type", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", String)
], UserTimelineEvent.prototype, "userId", void 0);
class UserTimelineResult extends BaseModel {
}
__decorate$2([
    Property(),
    __metadata$2("design:type", UserTimelineEvent)
], UserTimelineResult.prototype, "event", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Number)
], UserTimelineResult.prototype, "weight", void 0);
class UserTimelineResultListResponse extends BaseModel {
}
__decorate$2([
    Property({ type: UserTimelineResult }),
    __metadata$2("design:type", Array)
], UserTimelineResultListResponse.prototype, "data", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Number)
], UserTimelineResultListResponse.prototype, "length", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Number)
], UserTimelineResultListResponse.prototype, "offset", void 0);
__decorate$2([
    Property(),
    __metadata$2("design:type", Number)
], UserTimelineResultListResponse.prototype, "total", void 0);

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class VoucherTemplate extends BaseModel {
}
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "templateId", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "valueCode", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "dateCreated", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "dateModified", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "startDate", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "endDate", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], VoucherTemplate.prototype, "description", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", Number)
], VoucherTemplate.prototype, "value", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", Boolean)
], VoucherTemplate.prototype, "active", void 0);
class VoucherTemplateList extends BaseModel {
}
__decorate$1([
    Property({ type: VoucherTemplate }),
    __metadata$1("design:type", Array)
], VoucherTemplateList.prototype, "templates", void 0);
class UpdateVoucherTemplateRequest extends BaseModel {
}
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], UpdateVoucherTemplateRequest.prototype, "valueCode", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], UpdateVoucherTemplateRequest.prototype, "startDate", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], UpdateVoucherTemplateRequest.prototype, "endDate", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], UpdateVoucherTemplateRequest.prototype, "description", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", Number)
], UpdateVoucherTemplateRequest.prototype, "value", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", Boolean)
], UpdateVoucherTemplateRequest.prototype, "active", void 0);
class CreateVoucherTemplateRequest extends BaseModel {
}
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], CreateVoucherTemplateRequest.prototype, "valueCode", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", Number)
], CreateVoucherTemplateRequest.prototype, "value", void 0);
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], CreateVoucherTemplateRequest.prototype, "description", void 0);

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var VALIDATION_MESSAGE_TYPE;
(function (VALIDATION_MESSAGE_TYPE) {
    VALIDATION_MESSAGE_TYPE["INFO"] = "INFO";
    VALIDATION_MESSAGE_TYPE["WARN"] = "WARN";
    VALIDATION_MESSAGE_TYPE["ERROR"] = "ERROR";
})(VALIDATION_MESSAGE_TYPE || (VALIDATION_MESSAGE_TYPE = {}));
class ValidationMessage extends BaseModel {
}
__decorate([
    Property({ type: VALIDATION_MESSAGE_TYPE }),
    __metadata("design:type", String)
], ValidationMessage.prototype, "type", void 0);
__decorate([
    Property(),
    __metadata("design:type", String)
], ValidationMessage.prototype, "message", void 0);
class InvoiceValidationResponse extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], InvoiceValidationResponse.prototype, "validationSuccessful", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], InvoiceValidationResponse.prototype, "validationMessages", void 0);
class AccountBankValidationResponse extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountBankValidationResponse.prototype, "accountCash", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountBankValidationResponse.prototype, "accountReserved", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountBankValidationResponse.prototype, "bookkeepingBank", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountBankValidationResponse.prototype, "bookkeepingReserved", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], AccountBankValidationResponse.prototype, "validationMessages", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], AccountBankValidationResponse.prototype, "validationSuccessful", void 0);
class AccountPayableValidationResponse extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], AccountPayableValidationResponse.prototype, "companyId", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountPayableValidationResponse.prototype, "unPaidBillAmount", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountPayableValidationResponse.prototype, "unPaidBillAmountFromLedger", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], AccountPayableValidationResponse.prototype, "validationSuccessful", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], AccountPayableValidationResponse.prototype, "validationMessages", void 0);
class VatPaymentQueryResponse extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], VatPaymentQueryResponse.prototype, "companyId", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], VatPaymentQueryResponse.prototype, "totalVatPaid", void 0);
__decorate([
    Property(),
    __metadata("design:type", String)
], VatPaymentQueryResponse.prototype, "fiscalStartDate", void 0);
__decorate([
    Property(),
    __metadata("design:type", String)
], VatPaymentQueryResponse.prototype, "fiscalEndDate", void 0);
class FinancialPaymentOutput extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], FinancialPaymentOutput.prototype, "financialId", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], FinancialPaymentOutput.prototype, "vatAmountActuallyPaid", void 0);
__decorate([
    Property(),
    __metadata("design:type", String)
], FinancialPaymentOutput.prototype, "createdDate", void 0);
class VatValidationResult extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], VatValidationResult.prototype, "periodStart", void 0);
__decorate([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata("design:type", String)
], VatValidationResult.prototype, "periodType", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], VatValidationResult.prototype, "amountsMatched", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], VatValidationResult.prototype, "vatAmountFromBookedTransactions", void 0);
__decorate([
    Property(),
    __metadata("design:type", FinancialPaymentOutput)
], VatValidationResult.prototype, "matchedPayment", void 0);
__decorate([
    Property(),
    __metadata("design:type", ValidationMessage)
], VatValidationResult.prototype, "message", void 0);
__decorate([
    Property({ type: FinancialPaymentOutput }),
    __metadata("design:type", Array)
], VatValidationResult.prototype, "misMatchedPayments", void 0);
__decorate([
    Property({ type: FinancialPaymentOutput }),
    __metadata("design:type", Array)
], VatValidationResult.prototype, "multipleMatchedPayments", void 0);
class VatValidationResponse extends BaseModel {
}
__decorate([
    Property({ type: VatValidationResult }),
    __metadata("design:type", Array)
], VatValidationResponse.prototype, "validationResults", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], VatValidationResponse.prototype, "validationSuccessful", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], VatValidationResponse.prototype, "validationMessages", void 0);
class AccountReceivableValidationResponse extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountReceivableValidationResponse.prototype, "allSentInvoicesTotalAmount", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountReceivableValidationResponse.prototype, "ledgerDebitAmountOnAccountReceivables", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountReceivableValidationResponse.prototype, "invoicesUnPaidAmount", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], AccountReceivableValidationResponse.prototype, "ledgerBalanceAmountOnAccountReceivables", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], AccountReceivableValidationResponse.prototype, "validationMessages", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], AccountReceivableValidationResponse.prototype, "validationSuccessful", void 0);
class SalaryReconciliationResult extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], SalaryReconciliationResult.prototype, "month", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], SalaryReconciliationResult.prototype, "bookkeepingAmount", void 0);
__decorate([
    Property(),
    __metadata("design:type", Amount)
], SalaryReconciliationResult.prototype, "salaryAmount", void 0);
class SalaryValidationResponse extends BaseModel {
}
__decorate([
    Property({ type: SalaryReconciliationResult }),
    __metadata("design:type", Array)
], SalaryValidationResponse.prototype, "taxesReconciliationResults", void 0);
__decorate([
    Property({ type: SalaryReconciliationResult }),
    __metadata("design:type", Array)
], SalaryValidationResponse.prototype, "socialFeesReconciliationResults", void 0);
__decorate([
    Property({ type: SalaryReconciliationResult }),
    __metadata("design:type", Array)
], SalaryValidationResponse.prototype, "taxesDeviations", void 0);
__decorate([
    Property({ type: SalaryReconciliationResult }),
    __metadata("design:type", Array)
], SalaryValidationResponse.prototype, "socialFeesDeviations", void 0);
__decorate([
    Property({ type: ValidationMessage }),
    __metadata("design:type", Array)
], SalaryValidationResponse.prototype, "validationMessages", void 0);
__decorate([
    Property(),
    __metadata("design:type", Boolean)
], SalaryValidationResponse.prototype, "validationSuccessful", void 0);

export { ACCOUNT_TYPE, ANNUAL_REPORT_ASSET_TYPE, ANNUAL_REPORT_COLLECT_STATUS, ANNUAL_REPORT_STATE, ANNUAL_REPORT_SUBMIT_STATE, ASSETUPLOADSTATUS, ASSET_TRANSFORM, AUTHOR_TYPE, AUTH_STRATEGY, Account, AccountBankValidationResponse, AccountPayableValidationResponse, AccountReceivableValidationResponse, AccountStatement, AccountStatementEntry, ActivateCardRequestV2, ActivationSignaturePayloadRequest, ActivationSignatureResponse, AddShoppingCartItemRequest, AddSignatoryRequest, AddValueCodeRequest, Address, Amount, AnnualReport, AnnualReportAsset, AnnualReportCollectResponse, AnnualReportImportBalance, AnnualReportImportedBalance, AnnualReportListResponse, AnnualReportSignRequest, AnnualReportSignResponse, AnnualReportSignature, AnnualReportUpdateRequest, AreaAddress, Asset, AssetBinary, AssetsUploadDetails, AuthCredentials, AuthResponse, AuthStartResponse, Author, BANKID_ERROR_STATE, BANKID_RETRY_STATE, BEARER, BILL_ORDER_BY, BILL_SORT_ORDER, BILL_STATUS, BOOKABLE_TYPE, BOOKKEEPING_ACCOUNT_CLASS, BOOKKEEPING_ACCOUNT_TYPE, BOOKKEEPING_STATUS, BRAND, BankAccountDetails, BgcResponse, BgcResponseItem, Bill, BillBookkeepingUpdateRequest, BillListResponse, BillPayment, BillPaymentReceiver, BillPaymentUpdateRequest, BillUpdateRequest, BinaryMeta, BoardLocation, BoardMember, BookkeepingAccount, BookkeepingAccountListResponse, BookkeepingHint, BookkeepingMetadata, BookkeepingTransaction, BookkeepingTransactionLinkedReferences, BookkeepingTransactionListResponse, BookkeepingTransactionRow, BusinessOperationActivity, CARD_SEND_PIN, CARD_STATUS, CARD_TRANSACTION_RESERVATION_STATUS, CARD_TRANSACTION_RESOLUTION_TYPE, CARD_TRANSACTION_SORT_ORDER, CARD_TRANSACTION_STATUS, COLLECT_RESPONSE_STATUS, COLLECT_RESPONSE_TRANSFORM, COMMENT_CONTEXT, COMPANY_ACCOUNT_TYPE, COMPANY_FEATURES, COMPANY_FISCAL_ASSET_TYPE, COMPANY_FISCAL_YEAR_LENGTH, COMPANY_PERIOD_INTERVAL, COMPANY_PERIOD_TYPE, COMPANY_STATUS, COMPANY_TYPE, COUNTRY, CURRENCY, CUSTOMER_STATUS, CUSTOMER_TYPE, CalendarForecast, Card, CardActivateRequest, CardCreateRequest, CardListResponse, CardNameSuggestion, CardRenewal, CardTransaction, CardTransactionBookkeepingRequest, CardTransactionListResponse, CardTransactionReservation, CardTransactionResolution, CardTransactionResolveRequest, CardUpdateStatusRequest, Charge, ClientInfoResponse, CloseYearResponse, CollectResponse, Comment, CommentAuthor, CommentListResponse, CommentMessage, CommentsAuthor, CompaniesCount, Company, CompanyAccount, CompanyActivationRequest, CompanyBaseInfo, CompanyBaseInfoStatus, CompanyBookedBalance, CompanyConfiguration, CompanyData, CompanyDataRequest, CompanyDetails, CompanyFeature, CompanyFiscalAsset, CompanyFiscalData, CompanyFiscalInformation, CompanyFiscalPeriod, CompanyFiscalYear, CompanyFunction, CompanyInfo, CompanyListResponse, CompanyReconciliationBalances, CompanyRegistrationUpdateRequest, CompanyReportingPeriod, CompanySearchResult, CompanySearchResultListResponse, CompanyTaxationData, CompanyUser, CompanyUserListResponse, CompanyUserRelation, CompanyYearEndStep, CompanyYearEndStepListResponse, Content, CountryData, CreateCardRequestV2, CreateCommentRequest, CreateCompanyFiscalYearRequest, CreateCompanyRequest, CreateCreditInvoiceRequest, CreateCustomerRequest, CreateOwnerWithdrawalRequest, CreateOwnerWithdrawalRequestOverridingParameters, CreateRegistrationFileRequest, CreateRegistrationStepRequest, CreateUserRequest, CreateVoucherTemplateRequest, CreditReference, CurrencyConversionRequest, CurrencyConversionResponse, CurrencyListResponse, Customer, CustomerData, CustomerDefaults, CustomerListResponse, CustomerSearchResult, CustomerSearchResultListResponse, DEPRECIATION_ITEM_TYPE, DIVIDENDS_PAYMENT_STATUS, DYNAMIC_REPORT_CELL_DATA_TYPE, DYNAMIC_REPORT_FORMAT, DYNAMIC_REPORT_TYPE, DatedPermit, Debtor, DebugProjection, Delivery, DeliveryAddress, DepreciationItem, Deputy, DetailedSubscription, DetailedSubscriptionInvoice, DetailedSubscriptionInvoiceList, DividendsDecision, DividendsDecisionRequest, DividendsPayment, DividendsPaymentRequest, DividendsPaymentResponse, DownloadAssetCreationResponse, DownloadableReportResponse, DynamicReport, DynamicReportCell, DynamicReportData, DynamicReportList, DynamicReportRow, EFTA_MEMBERS, EU_MEMBERS, EXCHANGE_RATE_SOURCE, EditCommentRequest, EmployeeDatedPermit, EmploymentRequest, ExchangeAmount, ExchangeRate, ExecutedCommand, FIXED_ASSET_SORT, FIXED_ASSET_SORT_DIRECTION, FLAG_TYPE, Feature, FeatureActivationRequest, FeatureListResponse, FinancialPaymentOutput, FirstEmployeePermitRequest, FixedAsset, FixedAssetCreateRequest, FixedAssetDepreciation, FixedAssetListResponse, FixedAssetUpdateRequest, Flow, Forex, ForexAmount, FutureEvent, GoogleDriveAccessRequest, GoogleDriveAccessUpdateResponse, HAS_VAT_IDENTIFIER, HelpFlag, INITIATED_ACTIVITY, INVOICE_DELIVERY_METHOD, INVOICE_DELIVERY_STATUS, INVOICE_ORDER, INVOICE_ORDER_BY, INVOICE_STATUS, InfinityAmountCurrencyError, InternalCompany, Invoice, InvoiceEditor, InvoiceItem, InvoiceListResponse, InvoicePayment, InvoicePaymentRegistration, InvoicePreview, InvoicePreviewItem, InvoicePreviewList, InvoiceSalary, InvoiceValidationResponse, JsonNode, LANGUAGE, LLCTaxCalculation, LOAN_STATUS, LOCALE_EN_COUNTRY, LOCALE_SV_COUNTRY, Ledger, LedgerAccount, LedgerEntry, LineItem, Loan, MARKET, MONETORY_ITEM_FORMAT, ManualTransactionRequest, Me, MismatchAmountCurrencyError, MonetaryGroup, MonetaryItem, NODE_TYPE, NonAmountObject, NonConformanceReport, OBJECT_SUB_TYPE, OBJECT_TYPE, ORGANISATION_RECORD_RESULT_SUBTYPE, ORGANISATION_RECORD_RESULT_TYPE, OWNER_DEPOSIT_STATUS, OWNER_DEPOSIT_TYPE, OrganisationRecordListResponse, OrganisationRecordResult, OwnerDeposit, OwnerDepositList, OwnerDepositsAndWithdrawalsResponse, OwnerMetaData, OwnerWithDrawlList, OwnerWithdrawal, OwnerWithdrawalResponse, PAYMENT_REFERENCE_TYPE, PAYMENT_STATUS, PAYMENT_TYPE, PROPOSED_PROFIT_APPROPRIATION_REJECTION_REASON, Payment, PaymentAllowedCountriesResponse, PaymentReference, PaymentScheduleCalendarResponse, Percentage, Person, PossibleDividends, PriceList, PriceListInfo, Projection, RECEIPT_ORDER_BY, RECEIPT_SORT_ORDER, RECEIPT_STATUS, REFERENCE_TYPE, REGISTRATION_ADDITIONAL_BOOKKEEPING, REGISTRATION_ADDITIONAL_CREATED, REGISTRATION_FILE_TYPE, REGISTRATION_FLOW, REGISTRATION_FORM_PDF, REGISTRATION_ORDERBY, REGISTRATION_SORT_ORDER, REGISTRATION_STATUS, REMITTANCE_TYPE, REMOTE_ACCOUNT_ENTRY_TRANSACTION_PROVIDER, REMOTE_ACCOUNT_ENTRY_TRANSACTION_RESOLUTION, REPORT_PERIOD_TYPE, REPORT_TYPE, ROLE, ROYALTY_STATEMENT_ORIGIN, ROYALTY_STATEMENT_SORT, ROYALTY_STATEMENT_SORT_DIRECTION, ROYALTY_STATEMENT_STATUS, Receipt, ReceiptBookkeepingUpdateRequest, ReceiptListResponse, ReceiptUpdateRequest, Reference, Registration, RegistrationApplication, RegistrationDetails, RegistrationFile, RegistrationListResponse, RegistrationRequest, RegistrationStep, RegistrationUpdateRequest, Relation, RelationListResponse, RemittanceInfo, RemoteAccountEntryTransaction, RemoteAccountEntryTransactionResolveRequest, ReplaceCardRequest, Report, ReportCommandSent, ReportPeriod, Representative, RerenderReportRequest, ResolvableTransaction, ResolvableTransactionListResponse, ResolvableTransactionResolveRequest, RestrictedAsset, RestrictedAssetCollection, RoyaltyStatement, RoyaltyStatementListResponse, RoyaltyStatementUpdateRequest, SALARY_BENEFIT_STATE, SALARY_BENEFIT_TYPE, SALARY_PAYMENT_STATUS, SALARY_REQUEST_BASE_AMOUNT_TYPE, SIE_VALIDATION_ERROR_TYPE, SIGNATORY_TYPE, SIGNATURE_OBJECT_ENCODING, SIGNATURE_SOURCE, SIGNATURE_TYPE, SIGN_STATUS, SKU_TYPE, SKU_UNIT, STEP_NAME, STEP_TYPE, SUBSCRIPTION_STATUS, Salary, SalaryBenefit, SalaryBenefitMetadata, SalaryBenefits, SalaryList, SalaryPayment, SalaryReconciliationResult, SalaryRequest, SalaryValidationResponse, SendSmsRequest, Shareholder, ShareholderCapital, ShareholderDetails, ShareholderListResponse, ShoppingCart, ShoppingCartItem, SieValidatedFiscalYear, SieValidationInformation, SieValidationResponse, SignAssetRequest, SignPayloadRequest, SignRequestResponse, Signatory, Signature, Sku, SoleTraderTaxCalculation, Step, Stock, Subscription, SubscriptionInvoice, SubscriptionInvoiceList, SubscriptionListResponse, SubscriptionVoucher, Summary, SystemReference, TRANSACTION_ORDER_BY, TRANSACTION_SORTING_DIRECTION, TRANSACTION_STATUS, TRANSACTION_SUB_TYPE, Term, TermListResponse, Transaction, TransactionList, TransactionListResponse, TransactionResolution, TypedAreaAddress, USER_TIMELINE_EVENT_TYPE, UpdateBookWithVatRequest, UpdateCardRequest, UpdateCompanyRequest, UpdateInvoiceRequest, UpdatePriceListRequest, UpdateRoyaltyStatementAmountRequest, UpdateRoyaltyStatementStatusRequest, UpdateShareholdersRequest, UpdateStepRequest, UpdateUserRequest, UpdateVoucherTemplateRequest, UploadedEntityDetails, User, UserAddress, UserDetails, UserTimelineEvent, UserTimelineResult, UserTimelineResultListResponse, VALIDATION_MESSAGE_TYPE, VAT_AREA, VAT_PERIOD_INTERVAL, VAT_PERIOD_STATUS, VAT_REPORT_TYPE, VAT_TYPE, VOUCHER_TYPE, ValidationMessage, ValueCode, VatAdjustment, VatAmount, VatData, VatIntervalRequest, VatPayment, VatPaymentQueryResponse, VatPeriod, VatPeriodListResponse, VatReport, VatReportRequest, VatReportsResponse, VatStatusRequest, VatValidationResponse, VatValidationResult, Voucher, VoucherRow, VoucherTemplate, VoucherTemplateList, YEAR_END_REPORT_STATUS, YEAR_END_REPORT_TYPE, YEAR_END_STEP, YearEndAssignee, YearEndListResponse, YearEndMetaData, YearEndMetaDataBase, YearEndMetaDataUpdateRequest, YearEndReport, YearEndSummary };
